// 八十天环游地球
// 共 1199 个单词

export default [
  {
    id: 1,
    word: "appeler",
    phonetic: "[aple]",
    type: "",
    translation: "\u4f20\u8baf n.f. \u58f0\u97f3\uff0c\u55d3\u97f3\uff1b\u53d1\u8a00\u6743\uff1b\u89c1\u89e3\uff1b\uff08\u6295\u7968\u8005\u7684\uff09\u7968\uff1b[\u8bed]",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 2,
    word: "voix",
    phonetic: "[vwa]",
    type: "",
    translation: "\u8bed\u6001 v.t. \u5f00\uff0c\u6253\u5f00\uff1b\u5f00\u8f9f\uff1b\u5f00\u653e\uff1b\u5f00\u529e\uff1bv.i. \u5f00\u542f\uff1b\u5f00\u5f20\uff1b\u5f00",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 3,
    word: "ouvrir",
    phonetic: "[uvrir]",
    type: "",
    translation: "\u95e8\u8425\u4e1a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 4,
    word: "minuit",
    phonetic: "[min\u0265i]",
    type: "",
    translation: "n.m. \u534a\u591c\uff0c\u5348\u591c\uff1b\u5b50\u591c12\u65f6\uff0c\u96f6\u65f6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 5,
    word: "locataire",
    phonetic: "[l\u0254kat\u03b5r]",
    type: "",
    translation: "n. \u79df\u6237\uff0c\u627f\u79df\u4eba\uff1b\u623f\u5c4b\u627f\u79df\u4eba\uff0c\u623f\u5ba2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 6,
    word: "surpris",
    phonetic: "[syrpri, i:z]",
    type: "",
    translation: "a. \u88ab\u5f53\u573a\u6293\u4f4f\u7684\uff1b\u60ca\u6115\u7684\uff0c\u60ca\u8bb6\u7684\uff0c\u60ca\u5947\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 7,
    word: "maison",
    phonetic: "[m\u03b5z\u0254\u0303]",
    type: "",
    translation: "n.f.\uff08\u72ec\u6237\uff09\u4f4f\u5b85\uff1b\u5bb6\uff1b\u9662\uff0c\u6240\uff0c\u9986\uff1b\u5546\u884c\uff0c\u5546\u5e97",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 8,
    word: "coll\u00e8gue",
    phonetic: "[k\u0254l\u03b5g]",
    type: "",
    translation: "n. \u540c\u4e8b\uff0c\u540c\u50da\uff1b\u540c\u804c\u8005",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 9,
    word: "vingtaine",
    phonetic: "[v\u025b\u0303t\u03b5n]",
    type: "",
    translation: "n.f. \u4e8c\u5341\u5de6\u53f3\uff0c\u4e8c\u5341\u6765\u4e2a v.t.\uff0c v.pr. 1.\u7f13\u6162\u6d41\u52a8\uff0c\u677e\u51fa\uff1b 2.\u7b14\u76f4\u8d70\u7eba\uff1b\u62c9\u4e1d\uff1b 3.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 10,
    word: "filer",
    phonetic: "[file]",
    type: "",
    translation: "\u5c3e\u968f\uff0c\u8ddf\u8e2a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 11,
    word: "difficile",
    phonetic: "[difisil]",
    type: "",
    translation: "a. \u96be\u7684\uff0c\u56f0\u96be\u7684\uff1b\u8270\u8f9b\u7684\uff1b\u96be\u4ee5\u76f8\u5904\u7684\uff0c\u96be\u4ee5\u6ee1\u8db3\u7684 v.t.\uff0c v.pr. 1.\u8ba4\u505a\uff0c\u628a...\u8ba4\u4f5c\u81ea\u5df1\u7684 2.\u627f\u8ba4\uff1b\u4f9b\u8ba4\uff0c\u62db",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 12,
    word: "avouer",
    phonetic: "[avwe]",
    type: "",
    translation: "\u8ba4\uff0c\u8ba4\u7f6a\uff1b 3.\u516c\u5f00\u8868\u660e\uff0c\u8868\u9732\uff1b\u8ba4\u53ef\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 13,
    word: "geste",
    phonetic: "[\u0292\u03b5st]",
    type: "",
    translation: "n.m. \u624b\u52bf\uff0c\u59ff\u52bf\uff1b\u52a8\u4f5c\uff1b\u6177\u6168\u7684\u884c\u4e3a v.t. \u4e3e\u8d77\uff0c\u62ac\u8d77\uff0c\u63d0\u8d77\uff1b\u63ed\u8d77\uff1b\u64a4\u53bb\uff0c\u89e3\u9664\uff0c\u53d6\u6d88\uff1b\u4f7f\u8d77",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 14,
    word: "lever",
    phonetic: "[l\u0259ve]",
    type: "",
    translation: "\u5e8a\uff0c\u4f7f\u8d77\u8eab",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 15,
    word: "soleil",
    phonetic: "[s\u0254l\u03b5j]",
    type: "",
    translation: "n.m. \u592a\u9633\uff1b\u9633\u5149\uff1b\u6674\u5929",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 16,
    word: "signer",
    phonetic: "[si\u0272e]",
    type: "",
    translation: "v.t. \u7b7e\u7f72\uff0c\u5728\u2026\u2026\u4e0a\u7b7e\u540d\uff1b\u52a0\u4ee5\u5370\u8bb0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 17,
    word: "silence",
    phonetic: "[sil\u0251\u0303s]",
    type: "",
    translation: "n.m. \u5bc2\u9759\uff0c\u6c89\u9ed8\uff1b\u4e0d\u8054\u7cfb\uff0c\u4e0d\u5199\u4fe1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 18,
    word: "retour",
    phonetic: "[r(\u0259)tur]",
    type: "",
    translation: "n.m. \u8fd4\u56de\uff1b\u56de\u7a0b\uff08\u7968\uff09\uff1b\u6062\u590d\uff1b\u9000\u56de\uff1b\u56de\u62a5\uff1b\u8f6c\u5411 v.i. \u56de\u6765\uff0c\u56de\u5230\uff1b\u56de\u5bb6\uff1b\u6062\u590d\uff1b\u8fdb\u5165\uff1bv.t. \u6536\u8fdb\uff1b\u4f7f\u8fdb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 19,
    word: "rentrer",
    phonetic: "[r\u0251\u0303tre]",
    type: "",
    translation: "\u5165\uff1b\u7f29\u56de n.m. \u7aef\u90e8\uff0c\u672b\u7aef\uff1b\uff08\u7a7a\u95f4\u7684\uff09\u7ec8\u70b9\uff0c\u5c3d\u5934\uff1b\uff08\u65f6\u95f4\u7684\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 20,
    word: "bout",
    phonetic: "[bu]",
    type: "",
    translation: "\u7ec8\u7ed3\uff0c\u7ed3\u5c40\uff1b\u4e00\u6bb5\uff0c\u4e00\u622a\uff0c\u4e00\u90e8\u5206",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 21,
    word: "conversation",
    phonetic: "[k\u0254\u0303v\u03b5rsasj\u0254\u0303]",
    type: "",
    translation: "n.f. \u8c08\u8bdd\uff0c\u4f1a\u8bdd\uff0c\u4ea4\u8c08\uff1b\u4f1a\u8c08",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 22,
    word: "nos",
    phonetic: "[no]",
    type: "",
    translation: "n\u00f4tre",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 23,
    word: "pouvoir",
    phonetic: "[puvwar]",
    type: "",
    translation: "v.t. \u80fd\u591f\uff1b\u53ef\u4ee5\uff1b\u53ef\u80fd\uff1bn.m. \u80fd\u529b\uff1b\u6743\u5a01\uff1b\u6743\u529b n.f. \u9886\u5bfc\uff0c\u6307\u6325\uff0c\u6307\u5bfc\uff0c\u7ba1\u7406\uff1b\u9886\u5bfc\u90e8\u95e8\uff1b\u9886\u5bfc\u73ed\u5b50\uff1b\u65b9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 24,
    word: "direction",
    phonetic: "[dir\u03b5ksj\u0254\u0303]",
    type: "",
    translation: "\u5411",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 25,
    word: "pass\u00e9",
    phonetic: "[pase]",
    type: "",
    translation: "a. \u8fc7\u53bb\u7684\uff0c\u4ee5\u524d\u7684\uff1bn.m. \u8fc7\u53bb\uff0c\u5f80\u6614 v.i. \u8dcc\u5012\uff1b\u5012\u584c\uff1b\u8dcc\u843d\uff1b\u8131\u843d\uff1b\u964d\u843d\uff1b\u5782\u4e0b\uff1b\u5012\u4e0b\uff1b\u9635",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 26,
    word: "tomber",
    phonetic: "[t\u0254\u0303be]",
    type: "",
    translation: "\u4ea1\uff1b\u5012\u6bd9\uff1b\u4e0b\u53f0\uff1b\u51cf\u5f31\uff1b\u8dcc\u5165",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 27,
    word: "station",
    phonetic: "[stasj\u0254\u0303]",
    type: "",
    translation: "n.f. \u505c\u7559\uff1b\u7ad9\u7acb\uff0c\u76f4\u7acb\uff1b\u8f66\u7ad9\uff1b\u7814\u7a76\u6240\uff1b\u7ad9\uff0c\u53f0\uff0c\u6240\uff0c\u573a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 28,
    word: "impossible",
    phonetic: "[\u025b\u0303p\u0254sibl]",
    type: "",
    translation: "a. \u4e0d\u53ef\u80fd\u7684\uff0c\u505a\u4e0d\u5230\u7684\uff1b\u96be\u4ee5\u76f8\u5904\u7684\uff1b\u8352\u8c2c\u7684\uff0c\u79bb\u5947\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 29,
    word: "blanc",
    phonetic: "[bl\u0251\u0303, -\u222b]",
    type: "",
    translation: "n.m. \u767d\u8272\uff1b\u767d\u8272\u8863\u670d\uff1b\u767d\u8272\u989c\u6599\uff0c\u767d\u6d82\u6599\uff1b\u7a7a\u767d\uff0c\u95f4\u9694",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 30,
    word: "comment",
    phonetic: "[k\u0254m\u0251\u0303]",
    type: "",
    translation: "adv. \u5982\u4f55\uff0c \u600e\u4e48\uff0c \u600e\u6837\uff1b\u4e3a\u4f55\uff0c \u4e3a\u4ec0\u4e48 v.i. \u518d\u6765\uff1b\u8fd4\u56de\uff0c\u56de\u6765\uff1b\u91cd\u65b0\u51fa\u73b0\uff1b\u5728\u8bb0\u5fc6\u4e2d\u91cd\u73b0\uff1b\u56de",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 31,
    word: "revenir",
    phonetic: "[r\u0259vnir]",
    type: "",
    translation: "\u590d\uff0c\u6062\u590d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 32,
    word: "autour",
    phonetic: "[otur]",
    type: "",
    translation: "adv. \u5728\u5468\u56f4\uff0c\u5728\u56db\u5468",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 33,
    word: "ami",
    phonetic: "[ami]",
    type: "",
    translation: "n. \u670b\u53cb\uff1b\u53cb\u597d\u8005\uff0c\u540c\u60c5\u8005\uff1b\u60c5\u4eba a. \u5c0f\u7684\uff1b\u77ee\u5c0f\u7684\uff1b\u5e7c\u5c0f\u7684\uff1b\u5fae\u91cf\u7684\uff1b\u7ec6\u5c0f\u7684\uff1b\u65e0\u5173\u7d27\u8981",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 34,
    word: "petit",
    phonetic: "[p\u0259ti, -t]",
    type: "",
    translation: "\u7684\uff1b\u5351\u9119\u7684\uff1b\u6e3a\u5c0f\u7684\uff1b\uff08\u5730\u4f4d\uff09\u4f4e\u5fae\u7684\uff1b\u53ef\u7231\u7684\uff0c\u4eb2\u7231\u7684 1 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. a. \u7ef7\u7d27\u7684\uff0c\u7d27\u8d34\u7684\uff1b\u5bc6\u96c6\u7684\uff1b\u7cbe\u70bc\u7684\uff1b\u7d27\u51d1\u7684\uff1b\uff08\u65f6\u95f4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 35,
    word: "serr\u00e9",
    phonetic: "[sere]",
    type: "",
    translation: "ou [s\u03b5re] \u7b49\uff09\u7d27\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 36,
    word: "quoi",
    phonetic: "[kwa]",
    type: "",
    translation: "pron.relat. \u4ec0\u4e48",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 37,
    word: "merci",
    phonetic: "[m\u03b5rsi]",
    type: "",
    translation: "n.f. \u601c\u60af\uff0c\u4ec1\u6148\uff0c\u6069\u60e0\uff1bn.m. \u9053\u8c22\u7684\u8bdd\uff1binterj. \u8c22\u8c22",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 38,
    word: "vieux",
    phonetic: "[vj\u00f8, vj\u03b5j]",
    type: "",
    translation: "a. \u5e74\u8001\u7684\uff0c\u8001\u5e74\u7684\uff1b\u5e74\u957f\u7684\uff1b\u5e74\u4ee3\u4e45\u7684\uff1b\u65e7\u7684\uff1bn. \u8001\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 39,
    word: "gens",
    phonetic: "[\u0292\u0251\u0303]",
    type: "",
    translation: "n.m.\uff0c n.f. pl. \u4eba\u4eec\uff1b\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 40,
    word: "choisir",
    phonetic: "[\u222bwazir]",
    type: "",
    translation: "v.t. \u6311\u9009\uff0c\u9009\u62e9\uff1b\u9009\u5b9a\uff0c\u51b3\u5b9a v.t. \u8f6c\u5411\uff0c\u8c03\u8f6c\uff1b\u7ffb\uff1b\u7ffb\u8f6c\uff1b\u4f7f\u65cb\u8f6c\uff0c\u8f6c\u52a8\uff1b\u6405\u62cc\uff1b[\u5f71]",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 41,
    word: "tourner",
    phonetic: "[turne]",
    type: "",
    translation: "\u62cd\u6444\uff1bv.i. \u8f6c\u52a8\uff0c\u65cb\u8f6c\uff0c\u8fd0\u8f6c\uff1b\u8e31\u6765\u8e31\u53bb\uff1b\u56f4\u7ed5\uff0c\u4ee5\u2026\u2026 \u4e3a\u4e2d\u5fc3\uff1b\u5de1\u56de\u6f14\u51fa\uff1b\u62d0\u5f2f\uff0c\u8f6c\u5411\uff1b\u6539\u53d8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 42,
    word: "laisser",
    phonetic: "[lese]",
    type: "",
    translation: "ou [l\u03b5se] v.t. \u7559\uff0c\u4fdd\u7559\uff1b\u4e0d\u7ba1\uff1b\u7559\u7ed9\uff1b\u4ea4\u7ed9\uff1b\u4e22\u4e0b\uff1b\u9057\u7559\uff1b\u4efb\u51ed v.i. \u8d70\uff0c\u53bb\uff1b\u901a\u5411\uff1b\u5e72\uff0c\u884c\u52a8\uff1b\u8868\u73b0\uff1b\u5904\u4e8e\u2026\u7684\u5065\u5eb7\u72b6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 43,
    word: "aller",
    phonetic: "[ale]",
    type: "",
    translation: "\u51b5\uff1b\u9002\u5408\uff0c\u76f8\u914d\uff1b\u8fdb\u884c\uff1bn.m. \u53bb\uff1b\u53bb\u7a0b\uff1b\u53bb\u7a0b\u8f66\u7968",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 44,
    word: "apprendre",
    phonetic: "[apr\u0251\u0303dr]",
    type: "",
    translation: "v.t. \u5b66\uff0c\u5b66\u4e60\uff1b\u719f\u8bb0\uff0c\u8bb0\u4f4f\uff1b\u5f97\u77e5\uff0c\u542c\u8bf4\uff1b\u6559\uff0c\u4f20\u6388",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 45,
    word: "abandonner",
    phonetic: "[ab\u0251\u0303d\u0254ne]",
    type: "",
    translation: "v.t. \u653e\u5f03\uff1b\u629b\u5f03\uff1b\u5f03\u4e4b\u4e0d\u7ba1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 46,
    word: "environ",
    phonetic: "[\u0251\u0303vir\u0254\u0303]",
    type: "",
    translation: "adv. \u5927\u7ea6\uff0c\u5c06\u8fd1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 47,
    word: "r\u00e9solution",
    phonetic: "[rez\u0254lysj\u0254\u0303]",
    type: "",
    translation: "n.f. \u89e3\u51b3\uff0c\u89e3\u7b54\uff1b\u51b3\u5fc3\uff1b\u5206\u89e3\uff1b\u6eb6\u89e3\uff1b[\u6cd5]\u64a4\u9500\uff1b\u51b3\u8bae",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 48,
    word: "main",
    phonetic: "[m\u025b\u0303]",
    type: "",
    translation: "n.f. \u624b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 49,
    word: "s\u00e9rieux",
    phonetic: "[serj\u00f8]",
    type: "",
    translation: "a. \u8ba4\u771f\u7684\uff0c\u4e25\u8083\u7684\uff1b\u5e84\u91cd\u7684\uff0c\u6301\u91cd\u7684\uff1b\u4e25\u91cd\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 50,
    word: "papier",
    phonetic: "[papje]",
    type: "",
    translation: "n.m. \u7eb8\uff1b\u7eb8\u5f20\uff1b\u6587\u4ef6\uff0c\u6587\u4e66\uff1bpl. \u8eab\u4efd\u8bc1\u4ef6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 51,
    word: "septembre",
    phonetic: "[s\u03b5pt\u0251\u0303br]",
    type: "",
    translation: "n.m. \u4e5d\u6708 v.t. \u6572\uff0c\u6253\uff0c\u62cd\uff1b\u6253\u4e2d\uff0c\u51fb\u4e2d\uff1b\u51b2\u5236\uff1b\u4fb5\u88ad\uff0c\u4f7f\u906d\u53d7\uff1b\u4f7f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 52,
    word: "frapper",
    phonetic: "[frape]",
    type: "",
    translation: "\u4ea7\u751f\u5f3a\u70c8\u5370\u8c61\uff0c\u6253\u52a8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 53,
    word: "part",
    phonetic: "[par]",
    type: "",
    translation: "n.f. \u4efd\uff0c\u4efd\u989d\uff1b\u90e8\u5206\uff1b\u80a1\u4efd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 54,
    word: "mercredi",
    phonetic: "[m\u03b5rkr\u0259di]",
    type: "",
    translation: "n.m. \u661f\u671f\u4e09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 55,
    word: "mourir",
    phonetic: "[murir]",
    type: "",
    translation: "v.i. \u6b7b\u4ea1\uff1b\uff08\u690d\u7269\uff09\u67af\u6b7b\uff1b\u51cb\u8c22\uff1b\u9010\u6e10\u6d88\u5931\uff0c\u706d\u4ea1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 56,
    word: "serviteur",
    phonetic: "[s\u03b5rvit\u0153r]",
    type: "",
    translation: "n.m. \u670d\u52a1\u8005",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 57,
    word: "femme",
    phonetic: "[fam]",
    type: "",
    translation: "n.f. \u5973\u4eba\uff0c\u5987\u5973\uff1b\u59bb\u5b50\uff1b\u5df2\u5a5a\u5987\u5973",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 58,
    word: "bras",
    phonetic: "[bra, br\u0251]",
    type: "",
    translation: "n.m. \u81c2\uff0c\u80f3\u818a\uff1b\u81c2\u72b6\u7269\uff1b\u6276\u624b a. \u7f8e\u4e3d\u7684\uff0c\u6f02\u4eae\u7684\uff1b\u4f18\u7f8e\u7684\uff1b\u6674\u6717\u7684\uff1b\u5353\u8d8a\u7684\uff0c\u4f18\u79c0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 59,
    word: "beau",
    phonetic: "[bo, b\u03b5l]",
    type: "",
    translation: "\u7684\uff1b\u9ad8\u5c1a\u7684\uff1b\u9002\u5b9c\u7684\uff1b\u975e\u5e38\u597d\u7684\uff1b\u5927\u91cf\u7684\uff0c\u91cd\u5927\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 60,
    word: "rang",
    phonetic: "[r\u0251\u0303]",
    type: "",
    translation: "n.m. 1.\u6392\uff0c\u884c\uff0c\u5217\uff1b 2.\u7b49\u7ea7\uff0c\u5730\u4f4d\uff0c\u4f4d\u7f6e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 61,
    word: "ciel",
    phonetic: "[sj\u03b5l]",
    type: "",
    translation: "n.m. \u5929\uff0c\u5929\u7a7a\uff1b\u84dd\u5929",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 62,
    word: "tard",
    phonetic: "[tar]",
    type: "",
    translation: "adv. \u665a\uff0c\u8fdf\uff1b\u5728\u508d\u665a\uff1b\u5728\u6df1\u591c v.i. \u6765\uff0c\u6765\u5230\uff1b\u51fa\u73b0\uff0c\u4ea7\u751f\uff1b\u53d1\u751f\uff0c\u7a81\u7136\u6765\u4e34\uff1b\u6765\u81ea\uff1b\u51fa",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 63,
    word: "venir",
    phonetic: "[v(\u0259)nir]",
    type: "",
    translation: "\u81ea\uff0c\u4ea7\u81ea\uff1b\u6e90\u4e8e\uff1b\u4ece\u2026\u2026\u4f20\u4e0b\u6765",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 64,
    word: "eau",
    phonetic: "[o]",
    type: "",
    translation: "n.f. \u6c34\uff1b\u6d77\uff1b\u6e56\uff1b\u6cb3\uff1b\u6c60\u5858\uff1b\u836f\u6c34\uff1b\u6eb6\u6db2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 65,
    word: "action",
    phonetic: "[aksj\u0254\u0303]",
    type: "",
    translation: "n.f. \u884c\u52a8\uff0c\u52a8\u4f5c\uff0c\u884c\u4e3a\uff1b\u80a1\u4efd\uff1b\u80a1\u7968 v.i. \u558a\uff0c\u53eb\uff1b\u5927\u58f0\u53eb\u56b7\uff1b\uff08\u7269\u4f53\uff09\u560e\u5431\u54cd\uff1bv.t. \u547c\u558a\uff0c\u558a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 66,
    word: "crier",
    phonetic: "[krije]",
    type: "",
    translation: "\u53eb\uff0c\u53eb\u56b7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 67,
    word: "sorte",
    phonetic: "[s\u0254rt]",
    type: "",
    translation: "n.f. \u79cd\u7c7b\uff0c\u7c7b\u522b\uff0c\u54c1\u79cd adj.num.card.\uff0c adj.inv. \u516d\uff1b\uff08\u4e00\u4e2a\u6708\u4efd\u7684\uff096\u65e5\uff1b6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 68,
    word: "six",
    phonetic: "[sis]",
    type: "",
    translation: "\u70b9\u949f\uff1b\uff08\u623f\u5c4b\u6216\u623f\u95f4\u7684\uff096\u53f7\uff1b\uff08\u7eb8\u724c\u7b49\u7684\uff09\u516d\u70b9\uff1b\u4e00\u79cd \u53e4\u94dc\u5e01 a. \u65b0\u51fa\u73b0\u7684\uff0c\u65b0\u521b\u7684\uff1b\u65b0\u7684\uff0c\u65b0\u8fd1\u7684\uff1b\u65b0\u5947\u7684\uff0c\u524d\u6240\u672a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 69,
    word: "nouveau",
    phonetic: "[nuvo, -\u03b5l]",
    type: "",
    translation: "\u95fb\u7684\uff1b\u4e0d\u719f\u6089\u7684\uff1b\u65e0\u7ecf\u9a8c\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 70,
    word: "ing\u00e9nieur",
    phonetic: "[\u025b\u0303\u0292enj\u0153r]",
    type: "",
    translation: "n.m. \u5de5\u7a0b\u5e08\uff0c\u6280\u5e08",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 71,
    word: "composer",
    phonetic: "[k\u0254\u0303poze]",
    type: "",
    translation: "v.t. \u7ec4\u6210\uff0c\u6784\u6210\uff1b\u64b0\u5199\uff0c\u5199\u4f5c\uff1b\u4f5c\uff08\u66f2\uff09 2 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. n.m. \u540d\u5b57\uff1b\u59d3\u540d\uff1b\u59d3\u6c0f\uff1b\u540d\u4e49\uff1b\u540d\u79f0\uff1b\u540d\u8a89\uff0c\u540d\u58f0\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 72,
    word: "nom",
    phonetic: "[n\u0254\u0303]",
    type: "",
    translation: "[\u8bed]\u540d\u8bcd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 73,
    word: "mur",
    phonetic: "[myr]",
    type: "",
    translation: "n.m. \u5899\uff0c\u58c1\uff1b\u969c\u788d\uff1b\u5ced\u58c1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 74,
    word: "rapidement",
    phonetic: "[rapidm\u0251\u0303]",
    type: "",
    translation: "adv. \u5f88\u5feb\u5730\uff0c \u8fc5\u901f\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 75,
    word: "verre",
    phonetic: "[v\u03b5r]",
    type: "",
    translation: "n.m. \u676f\u5b50\uff0c\u73bb\u7483\u9152\u676f\uff1b\u4e00\u676f\u9152\uff1b\u73bb\u7483",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 76,
    word: "ensemble",
    phonetic: "[\u0251\u0303s\u0251\u0303bl]",
    type: "",
    translation: "adv. \u5171\u540c\uff0c\u4e00\u8d77\uff1b\u540c\u65f6\uff1bn.m. \u5168\u90e8\uff0c\u5168\u4f53\uff1b\u6574\u4f53\uff1b\u540c\u65f6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 77,
    word: "savoir",
    phonetic: "[savwar]",
    type: "",
    translation: "v.t. \u4f1a\uff0c\u61c2\u5f97\uff1b\u5584\u4e8e\uff1b\u8bb0\u4f4f\uff1b\u77e5\u9053\uff1bn.m. \u77e5\u8bc6\uff0c\u5b66\u95ee",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 78,
    word: "manger",
    phonetic: "[m\u0251\u0303\u0292e]",
    type: "",
    translation: "v.t. \u5403\uff1b\u5403\u996d\uff0c\u5403\u4e1c\u897f\uff1b\u86c0\u98df\uff1b\u8150\u8680 n.f. \u751f\u547d\uff1b\u751f\u547d\u529b\uff0c\u6d3b\u529b\uff1b\u4e00\u751f\uff1b\u751f\u6d3b\uff1b\u751f\u5e73\uff0c\u751f\u6daf\uff1b\u751f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 79,
    word: "vie",
    phonetic: "[vi]",
    type: "",
    translation: "\u5e73\u4e8b\u8ff9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 80,
    word: "esp\u00e9rer",
    phonetic: "[\u03b5spere]",
    type: "",
    translation: "v.t. \u5e0c\u671b\uff0c\u671f\u671b\uff0c\u76fc\u671b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 81,
    word: "temple",
    phonetic: "[t\u0251\u0303pl]",
    type: "",
    translation: "n.m. \u5e99\u5b87\uff0c\u5bfa\u9662\uff1b\uff08\u65b0\u6559\uff09\u6559\u5802\uff0c\u793c\u62dc\u5802 v.t. \u524d\u79fb\uff0c\u4f7f\u524d\u8fdb\uff1b\u4f7f\u53d1\u5c55\uff0c\u4fc3\u8fdb\uff1b\u4f7f\u63d0\u524d\uff1b\u62e8\u5feb\uff1b\u63d0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 82,
    word: "avancer",
    phonetic: "[av\u0251\u0303se]",
    type: "",
    translation: "\u51fa\uff1bv.i. \u524d\u8fdb\uff1b\u8fdb\u519b\uff1b\u8fdb\u6b65\uff0c\u8fdb\u5c55\uff1b\u8d70\u5f97\u5feb\uff1b\u664b\u5347",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 83,
    word: "d\u00e9j\u00e0",
    phonetic: "[de\u0292a]",
    type: "",
    translation: "adv. \u5df2\u7ecf adv. \u66f4\u597d\u5730\uff0c\u8f83\u597d\u5730\uff1b\u66f4\u52a0\uff1b\u6700\u597d\u5730\uff1bn.m. \u6700\u4f73\uff0c\u6700",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 84,
    word: "mieux",
    phonetic: "[mj\u00f8]",
    type: "",
    translation: "\u597d\uff1b\u597d\u8f6c\uff0c\u66f4\u597d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 85,
    word: "sourire",
    phonetic: "[surir]",
    type: "",
    translation: "v.i. \u5fae\u7b11\uff1bn.m. \u5fae\u7b11",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 86,
    word: "recevoir",
    phonetic: "[r\u0259s\u0259vwar]",
    type: "",
    translation: "v.t. \u63a5\u5230\uff0c\u6536\u5230\uff1b\u906d\u53d7\uff0c\u53d7\u5230\uff1b\u63a5\u5f85\uff1b\u63a5\u89c1\uff1b\u5f55\u53d6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 87,
    word: "salut",
    phonetic: "[saly]",
    type: "",
    translation: "n.m. \u62db\u547c\uff0c\u81f4\u610f\uff0c\u81f4\u656c\uff1b\u62ef\u6551\uff1b\u5f97\u6551",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 88,
    word: "position",
    phonetic: "[pozisj\u0254\u0303]",
    type: "",
    translation: "n.f. \u4f4d\u7f6e\uff0c\u65b9\u4f4d\uff1b\u9635\u5730\uff1b\u59ff\u52bf\uff1b\u7acb\u573a\uff0c\u89c2\u70b9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 89,
    word: "octobre",
    phonetic: "[\u0254kt\u0254br]",
    type: "",
    translation: "n.m. \u5341\u6708",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 90,
    word: "silencieusement",
    phonetic: "[sil\u0251\u0303sj\u00f8zm\u0251\u0303]",
    type: "",
    translation: "adv. \u9ed8\u9ed8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 91,
    word: "corps",
    phonetic: "[k\u0254r]",
    type: "",
    translation: "n.m. \u8eab\u4f53\uff0c\u8eaf\u4f53\uff1b\u8089\u4f53\uff1b\u8eaf\u5e72\uff1b\u5c38\u4f53\uff1b\u7269\u4f53\uff1b\u56e2\u4f53",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 92,
    word: "silhouette",
    phonetic: "[silw\u025bt]",
    type: "",
    translation: "n.f. \u4f53\u578b\uff0c\u4f53\u6001\uff1b\u5916\u5f62\uff1b\u4fa7\u5f71\uff0c\u526a\u5f71\uff1b\u5f71\u5b50\uff1b\u8f6e\u5ed3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 93,
    word: "souvenir",
    phonetic: "[suvnir]",
    type: "",
    translation: "n.m. \u8bb0\u5fc6\uff0c\u56de\u5fc6\uff1b\u7eaa\u5ff5\u7269\uff0c\u7eaa\u5ff5\u54c1\uff1bpl. \u56de\u5fc6\u5f55",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 94,
    word: "observer",
    phonetic: "[\u0254ps\u03b5rve]",
    type: "",
    translation: "v.t. \u89c2\u5bdf\uff0c\u89c2\u6d4b\uff1b\u9075\u5b88\uff0c\u9075\u5faa\uff1b\u6ce8\u610f\u5230\uff0c\u7559\u5fc3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 95,
    word: "club",
    phonetic: "[kl\u0153b]",
    type: "",
    translation: "n.m. \u4ff1\u4e50\u90e8\uff0c\u4f1a\uff0c\u793e a. \u53ef\u80fd\u7684\uff0c\u53ef\u80fd\u5b58\u5728\u7684\uff0c\u53ef\u80fd\u53d1\u751f\u7684\uff1b\u8fd8\u53ef\u4ee5\u7684\uff1b\u53ef\u4ee5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 96,
    word: "possible",
    phonetic: "[p\u0254sibl]",
    type: "",
    translation: "\u63a5\u53d7\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 97,
    word: "enfin",
    phonetic: "[\u0251\u0303f\u025b\u0303]",
    type: "",
    translation: "adv. \u6700\u540e\uff0c\u7ec8\u4e8e\uff1b\u603b\u4e4b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 98,
    word: "accident",
    phonetic: "[aksid\u0251\u0303]",
    type: "",
    translation: "n.m.\u610f\u5916\uff1b\u4e8b\u6545",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 99,
    word: "changement",
    phonetic: "[\u222b\u0251\u0303\u0292m\u0251\u0303]",
    type: "",
    translation: "n.m. \u66f4\u6362\uff0c\u6539\u53d8\uff0c\u53d8\u5316",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 100,
    word: "retard",
    phonetic: "[r(\u0259)tar]",
    type: "",
    translation: "n.m. \u5ef6\u8bef\uff0c\u803d\u6401\uff1b\u51cf\u901f\uff0c\u8fdf\u7f13\uff0c\u5ef6\u7f13\uff1b\u843d\u540e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 101,
    word: "alors",
    phonetic: "[al\u0254r]",
    type: "",
    translation: "adv. \u90a3\u4e48\uff0c\u5728\u8fd9\u79cd\u60c5\u51b5\u4e0b\uff1b\u5f53\u65f6\uff0c\u90a3\u65f6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 102,
    word: "vent",
    phonetic: "[v\u0251\u0303]",
    type: "",
    translation: "n.m. \u98ce\uff1b\u7a7a\u6c14\uff0c\u6c14\u6d41\uff1b\u8d8b\u52bf\uff1b\u98ce\u6c14",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 103,
    word: "souvent",
    phonetic: "[suv\u0251\u0303]",
    type: "",
    translation: "adv. \u7ecf\u5e38\uff0c\u5e38\u5e38",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 104,
    word: "musique",
    phonetic: "[myzik]",
    type: "",
    translation: "n.f. \u97f3\u4e50\uff1b\u4e50\u66f2\uff1b\u97f3\u4e50\u6027\uff0c\u548c\u8c10\uff0c\u60a6\u8033",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 105,
    word: "toilette",
    phonetic: "[twal\u03b5t]",
    type: "",
    translation: "n.f. \u68b3\u6d17\uff1b\u6253\u626e\uff1b\u68b3\u5986\u53f0\uff1bn.f. pl. \u5395\u6240\uff0c\u536b\u751f\u95f4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 106,
    word: "d\u00e9jeuner",
    phonetic: "[de\u0292\u0153ne]",
    type: "",
    translation: "n.m. \u5348\u996d\uff0c\u5348\u9910\uff1b\u5348\u9910\u83dc\u80b4\uff1bv.i. \u5403\u65e9\u996d\uff1b\u5403\u5348\u996d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 107,
    word: "habiter",
    phonetic: "[abite]",
    type: "",
    translation: "v.i. \u5c45\u4f4f\uff1bv.t. \u5c45\u4f4f\u5728\uff0c\u5b9a\u5c45\u5728\uff1b\uff08\u52a8\u7269\uff09\u6816\u606f\u5728 a. \u7279\u522b\u559c\u7231\u7684\uff1b\u6700\u6709\u5e0c\u671b\u83b7\u80dc\u7684\uff1bn. \u5fc3\u7231\u8005\uff0c\u7279\u522b\u559c\u7231",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 108,
    word: "favori",
    phonetic: "[fav\u0254ri, -t]",
    type: "",
    translation: "\u7684\u4eba\uff0c\u5ba0\u513f\uff1b\u7ea2\u4eba\uff1b\u7ade\u8d5b\u4e2d\u6700\u6709\u5e0c\u671b\u83b7\u80dc\u7684\u4eba\uff1b\u8d5b\u9a6c\u4e2d\u6700 \u6709\u5e0c\u671b\u8d62\u7684\u9a6c a. \u5e74\u8f7b\u7684\uff1b\u5e74\u5c11\u7684\uff1b\u65b0\u5174\u7684\uff1b\u672a\u6210\u719f\u7684\uff1b\u9752\u5e74\u7684\uff1b\u5e7c\u5c0f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 109,
    word: "jeune",
    phonetic: "[\u0292\u0153n]",
    type: "",
    translation: "\u7684 3 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. v.t. \u91cd\u590d\uff0c\u4f7f\u589e\u52a0\u4e00\u500d\uff1b\u628a\u2026\u2026\u5bf9\u6298\uff1b\u7ed5\u8fc7\uff1b\u8d85\u8fc7\uff1b\u52a0\u886c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 110,
    word: "doubler",
    phonetic: "[duble]",
    type: "",
    translation: "\u91cc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 111,
    word: "presque",
    phonetic: "[pr\u03b5sk]",
    type: "",
    translation: "adv. \u51e0\u4e4e\uff0c\u5dee\u4e0d\u591a n.m. \u706b\uff1b\u706b\u661f\uff0c\u706b\u7130\uff1b\u706b\u707e\uff1bpl. \u706b\u5149\uff0c\u706f\u5149\uff1b\u706f\uff1b\u5c04",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 112,
    word: "feu",
    phonetic: "[f\u00f8]",
    type: "",
    translation: "\u51fb\uff1b\u5f00\u706b\uff1b\u6218\u4e89",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 113,
    word: "exactement",
    phonetic: "[\u03b5gzakt\u0259m\u0251\u0303]",
    type: "",
    translation: "adv. \u51c6\u786e\u5730\uff0c\u786e\u5207\u5730\uff1b\u4e25\u683c\u5730\uff1b\u51c6\u65f6\u5730\uff1b\u5982\u5b9e\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 114,
    word: "sac",
    phonetic: "[sak]",
    type: "",
    translation: "n.m. \u888b\uff0c\u56ca\uff0c\u5305\uff1b\u4e00\u888b\u4e4b\u91cf\uff1b\u624b\u63d0\u5305",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 115,
    word: "poign\u00e9e",
    phonetic: "[pwa\u0272e]",
    type: "",
    translation: "n.f. \u4e00\u628a\uff0c\u4e00\u64ae\uff1b\u4e00\u5c0f\u64ae\u4eba\uff1b\u628a\u624b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 116,
    word: "banque",
    phonetic: "[b\u0251\u0303k]",
    type: "",
    translation: "n.f. \u94f6\u884c\uff1b\u94f6\u884c\u4e1a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 117,
    word: "calmer",
    phonetic: "[kalme]",
    type: "",
    translation: "v.t. \u4f7f\u5e73\u9759\uff1b\u5e73\u606f\uff0c\u7f13\u548c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 118,
    word: "passage",
    phonetic: "[pasa\u0292]",
    type: "",
    translation: "n.m. \u901a\u8fc7\uff0c\u7ecf\u8fc7\uff1b\u6446\u6e21\uff1b\u901a\u9053\uff0c\u5c0f\u5df7\uff1b\u8f6c\u53d8\uff0c\u8fc7\u6e21",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 119,
    word: "article",
    phonetic: "[artikl]",
    type: "",
    translation: "n.m. \u6587\u7ae0\uff1b\u6761\u6b3e\uff0c\u6761\u6587\uff1b\u9879\u76ee\uff1b\u5546\u54c1\uff1b[\u8bed]\u51a0\u8bcd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 120,
    word: "saison",
    phonetic: "[s\u03b5z\u0254\u0303]",
    type: "",
    translation: "n.f. \u5b63\uff1b\u5b63\u8282\uff1b\u5f53\u4ee4\u671f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 121,
    word: "voiture",
    phonetic: "[vwatyr]",
    type: "",
    translation: "n.f. \u8f66\uff0c\u8f66\u8f86\uff1b\u6c7d\u8f66\uff0c\u8f7f\u8f66\uff1b[\u94c1]\u5ba2\u8f66\uff0c\u5ba2\u8f66\u8f66\u53a2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 122,
    word: "c\u00f4t\u00e9",
    phonetic: "[kote]",
    type: "",
    translation: "n.m. \u65c1\uff0c\u4fa7\uff1b\u65b9\u5411\uff1b\u65b9\u9762\uff1b\u808b\uff0c\u80f8\u4fa7\uff0c\u4f53\u4fa7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 123,
    word: "dollar",
    phonetic: "[d\u0254lar]",
    type: "",
    translation: "n.m. \u7f8e\u5143\uff1b\u6fb3\u5143\uff1b\u52a0\u5143\uff1b\u6e2f\u5143",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 124,
    word: "pourtant",
    phonetic: "[purt\u0251\u0303]",
    type: "",
    translation: "adv. \u7136\u800c\uff0c \u65e0\u8bba\u5982\u4f55\uff0c \u53ef\u662f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 125,
    word: "toujours",
    phonetic: "[tu\u0292ur]",
    type: "",
    translation: "adv. \u6c38\u8fdc\uff0c\u4e00\u76f4\uff1b\u603b\u662f\uff1b\u59cb\u7ec8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 126,
    word: "ton",
    phonetic: "[t\u0254\u0303]",
    type: "",
    translation: "n.m. \u97f3\u8c03\uff0c\u58f0\u8c03\uff1badj. \u4f60\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 127,
    word: "pourquoi",
    phonetic: "[purkwa]",
    type: "",
    translation: "adv.\uff0c conj. \u4e3a\u4ec0\u4e48\uff0c\u4e3a\u4f55\uff1b\u539f\u56e0\uff0c\u7406\u7531\uff1b\u95ee\u9898 a. \u5fd7\u613f\u7684\uff0c\u81ea\u613f\u7684\uff1b\u6709\u610f\u7684\uff0c\u6545\u610f\u7684\uff1bn. \u5fd7\u613f\u8005\uff0c\u5fd7\u613f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 128,
    word: "volontaire",
    phonetic: "[v\u0254l\u0254\u0303t\u03b5r]",
    type: "",
    translation: "\u4eba\u5458",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 129,
    word: "douze",
    phonetic: "[duz]",
    type: "",
    translation: "adj.num.card.\uff0c adj.inv. \u5341\u4e8c\uff1b\u7b2c\u5341\u4e8c v.i. \u8d70\uff0c\u884c\u8d70\uff1b\u8e0f\uff0c\u8e29\uff1b\uff08\u8f66\u8f86\u3001\u8239\u7684\uff09\u884c\u9a76\uff1b\u8fd0\u884c\uff0c\u8fd0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 130,
    word: "marcher",
    phonetic: "[mar\u222be]",
    type: "",
    translation: "\u8f6c\uff1b\u53d6\u5f97\u8fdb\u5c55",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 131,
    word: "jamais",
    phonetic: "[\u0292am\u03b5]",
    type: "",
    translation: "adv. \u4ece\u6ca1\uff0c\u4ece\u672a\uff0c\u4ece\u4e0d\uff1b\u5c06\u6765\u67d0\u65e5\uff1b\u66fe\u7ecf adj.poss. \u60a8\u7684\uff0c\u4f60\u7684\uff1b\u4f60\u4eec\u7684\uff1b\u5bf9\u4e8e\u60a8\uff08\u4f60\uff09\u7684\uff1b\u5bf9\u4e8e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 132,
    word: "votre",
    phonetic: "[v\u0254tr]",
    type: "",
    translation: "\u4f60\u4eec\u7684\uff08\u6307\u5ba2\u4f53\uff09 a. \u7ea2\u989c\u8272\u7684\uff1b\u8138\u7ea2\u7684\uff1b\u7ea2\u68d5\u8272\u7684\uff1b\u70e7\u7ea2\u7684\uff1bn.m. \u7ea2\u989c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 133,
    word: "rouge",
    phonetic: "[ru\u0292]",
    type: "",
    translation: "\u8272\uff1b\u53e3\u7ea2\uff1b\u7ea2\u8272\u4fe1\u53f7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 134,
    word: "bord",
    phonetic: "[b\u0254r]",
    type: "",
    translation: "n.m. \u8fb9\uff0c\u8fb9\u7f18\uff1b\u5cb8\u8fb9\uff1b\u8239\u8fb9\uff0c\u8239\u8237\uff1b\u8239 a. \u9ad8\u7684\uff1b\u6da8\u9ad8\u7684\uff1b\u6602\u8d35\u7684\uff1b\u5730\u4f4d\u9ad8\u7684\uff0c\u4e0a\u6d41\u7684\uff1b\u9ad8\u5ea6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 135,
    word: "haut",
    phonetic: "[o, ot]",
    type: "",
    translation: "\u865a\u97f3H \u7684\uff0c\u7279\u522b\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 136,
    word: "car",
    phonetic: "[kar]",
    type: "",
    translation: "conj. \u56e0\u4e3a\uff1bn.m. \u65c5\u6e38\u8f66",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 137,
    word: "rechercher",
    phonetic: "[r\u0259\u222b\u03b5r\u222be]",
    type: "",
    translation: "v.t. \u518d\u5bfb\u627e\uff1b\u63a2\u7d22\uff1b\u7814\u7a76\uff1b\u641c\u67e5\uff1b\u5bfb\u6c42\uff0c\u8ffd\u6c42",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 138,
    word: "treize",
    phonetic: "[tr\u03b5z]",
    type: "",
    translation: "adj.num.card.\uff0c adj.inv. \u5341\u4e09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 139,
    word: "matin",
    phonetic: "[mat\u025b\u0303]",
    type: "",
    translation: "n.m. \u65e9\u6668\uff1b\u4e0a\u5348\uff0c\u4e0a\u534a\u5929 adj. \u957f\u7684\uff0c\u8fdc\u7684\uff1b\u957f\u4e45\u7684\uff0c\u4e45\u8fdc\u7684 n.m.\u957f\uff0c\u957f\u5ea6 adv.\u8bb8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 140,
    word: "longue",
    phonetic: "[l\u0254\u0303g]",
    type: "",
    translation: "\u591a\uff0c\u5f88\u591a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 141,
    word: "chambre",
    phonetic: "[\u222b\u0251\u0303br]",
    type: "",
    translation: "n.f. \u623f\u95f4\uff0c\u7761\u623f\uff1b\u8bae\u4f1a\uff1b\u516c\u4f1a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 142,
    word: "occup\u00e9",
    phonetic: "[\u0254kype]",
    type: "",
    translation: "a. \u5fd9\u788c\u7684\uff1b\u88ab\u5360\u7528\u7684\uff1b\u6709\u4eba\u9884\u8ba2\u7684\uff1b\u88ab\u5360\u9886\u7684 n.f. \u7ed3\u4f34\uff0c\u4f5c\u4f34\uff0c\u966a\u540c\uff1b\u534f\u4f1a\uff0c\u56e2\u4f53\uff1b\u516c\u53f8\uff1b[\u519b]\u8fde\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 143,
    word: "compagnie",
    phonetic: "[k\u0254\u0303pa\u0272i]",
    type: "",
    translation: "\uff08\u52a8\u7269\u7684\uff09\u7fa4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 144,
    word: "prix",
    phonetic: "[pri]",
    type: "",
    translation: "n.m. \u4ef7\u683c\uff1b\u4ef7\u503c\uff1b\u4ee3\u4ef7\uff1b\u5956\uff1b\u5956\u91d1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 145,
    word: "autrefois",
    phonetic: "[otr\u0259fwa]",
    type: "",
    translation: "adv. \u8fc7\u53bb\uff0c\u4ee5\u524d\uff0c\u4ece\u524d\uff0c\u5f80\u6614",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 146,
    word: "cheval",
    phonetic: "[\u222b(\u0259)val]",
    type: "",
    translation: "n.m. \u9a6c\uff0c\u9a6c\u8089\uff1b\u9a91\u9a6c\u672f\uff1b\u9a6c\u529b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 147,
    word: "parcourir",
    phonetic: "[parkuri:r]",
    type: "",
    translation: "v.t. \u8dd1\u5b8c\uff0c\u8d70\u5b8c\uff1b\u8dd1\u904d\uff0c\u8d70\u904d\uff1b\u7ffb\u9605\uff0c\u6d4f\u89c8 4 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 148,
    word: "vitesse",
    phonetic: "[vit\u03b5s]",
    type: "",
    translation: "n.f. \u901f\u5ea6\uff1b\u5feb\uff0c\u8fc5\u901f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 149,
    word: "chemin",
    phonetic: "[\u222b(\u0259)m\u025b\u0303]",
    type: "",
    translation: "n.m. \u8def\uff0c\u5c0f\u8def\uff1b\u8def\u7a0b\uff0c\u884c\u7a0b\uff1b\u9014\u5f84\uff0c\u65b9\u6cd5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 150,
    word: "nous",
    phonetic: "[nu]",
    type: "",
    translation: "pron.pers. \u6211\u4eec\uff0c\u54b1\u4eec",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 151,
    word: "devenir",
    phonetic: "[d\u0259vnir]",
    type: "",
    translation: "v.i. \u53d8\u6210\uff0c\u53d8\u5f97\uff0c\u6210\u4e3a\uff1b\u6709\u2026\u2026\u7684\u7ed3\u679c\uff1b\u5904\u4e8e\u2026\u2026\u72b6\u51b5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 152,
    word: "route",
    phonetic: "[rut]",
    type: "",
    translation: "n.f. \u9053\u8def\uff0c\u516c\u8def\uff1b\u516c\u8def\u8fd0\u8f93\uff1b\u8def\u7a0b\uff0c\u65c5\u9014",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 153,
    word: "lieu",
    phonetic: "[lj\u00f8]",
    type: "",
    translation: "n.m. \u5730\u70b9\uff1b\u5730\u65b9\uff1b\u573a\u6240",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 154,
    word: "mouvement",
    phonetic: "[muvm\u0251\u0303]",
    type: "",
    translation: "n.m. \u8fd0\u52a8\uff0c\u79fb\u52a8\uff1b\u884c\u52a8\uff0c\u6d3b\u52a8\uff1b\u6d41\u52a8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 155,
    word: "machine",
    phonetic: "[ma\u222bin]",
    type: "",
    translation: "n.f. \u673a\u68b0\uff0c\u673a\u5668\uff1b\u673a\u68b0\u8f66\u8f86\uff1b\u673a\u6784\uff0c\u673a\u5173 a. \u7279\u6709\u7684\uff0c\u72ec\u7279\u7684\uff1b\u4e2a\u522b\u7684\uff0c\u5355\u72ec\u7684\uff1b\u7279\u522b\u7684\uff1b\u7279\u5b9a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 156,
    word: "particulier",
    phonetic: "[partikylje, \u03b5:r]",
    type: "",
    translation: "\u7684\uff1b\u79c1\u4eba\u7684\uff0c\u4e2a\u4eba\u7684\uff1bn.m. \u4e2a\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 157,
    word: "mer",
    phonetic: "[m\u03b5r]",
    type: "",
    translation: "n.f. \u6d77\uff1b\u6d77\u6c34\uff1b\u6d77\u8fb9\uff1b\u6d77\u6f6e\uff1b\u5927\u91cf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 158,
    word: "d\u00e9tail",
    phonetic: "[detaj]",
    type: "",
    translation: "n.m. \u7ec6\u8282\uff0c\u7ec6\u90e8\uff1b\u96f6\u552e\uff1b\u8be6\u7ec6\uff0c\u8be6\u5c3d\uff0c\u8be6\u7ec6\u60c5\u51b5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 159,
    word: "seconde",
    phonetic: "[s\u0259g\u0254\u0303d]",
    type: "",
    translation: "n.f. \u79d2\uff1b\u77ac\u95f4\uff0c\u7247\u523b v.t. \u9886\u5bfc\uff0c\u6307\u6325\uff1b\u7ba1\u7406\uff1b\u6307\u5bfc\uff0c\u5f15\u5bfc\uff1b\u5f15\u5411\uff0c\u9886\u5411\uff1b\u9a7e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 160,
    word: "diriger",
    phonetic: "[diri\u0292e]",
    type: "",
    translation: "\u9a76\uff0c\u64cd\u7eb5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 161,
    word: "confortable",
    phonetic: "[k\u0254\u0303f\u0254rtabl]",
    type: "",
    translation: "a. \u8212\u9002\u7684\uff0c\u9002\u610f\u7684\uff1b\u4ee4\u4eba\u5feb\u6170\u7684 n.m. \u670d\u52a1\uff0c\u670d\u5f79\uff1b\u52e4\u52a1\uff0c\u516c\u52a1\uff1b\u5e2e\u5fd9\uff1b\u7528\u5904\uff1b\u884c\u653f\u90e8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 162,
    word: "service",
    phonetic: "[s\u03b5rvis]",
    type: "",
    translation: "\u95e8\uff1b\u5904\uff0c\u79d1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 163,
    word: "chance",
    phonetic: "[\u222b\u0251\u0303s]",
    type: "",
    translation: "n.f. \u8fd0\u6c14\uff1b\u5e78\u8fd0\uff0c\u597d\u8fd0\uff1b\u673a\u4f1a\uff0c\u53ef\u80fd\u6027",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 164,
    word: "nuit",
    phonetic: "[n\u0265i]",
    type: "",
    translation: "n.f. \u591c\uff0c\u591c\u665a\uff0c\u591c\u95f4\uff1b\u6f06\u9ed1\uff0c\u9ed1\u6697",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 165,
    word: "moment",
    phonetic: "[m\u0254m\u0251\u0303]",
    type: "",
    translation: "n.m. \u65f6\u95f4\uff0c\u65f6\u523b\uff1b\u7247\u523b\uff0c\u4e00\u4f1a\u513f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 166,
    word: "mon",
    phonetic: "[m\u0254\u0303, ma, me]",
    type: "",
    translation: "adj.poss. \u6211\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 167,
    word: "projet",
    phonetic: "[pr\u0254\u0292\u03b5]",
    type: "",
    translation: "n.m. \u6253\u7b97\uff0c\u8bbe\u60f3\uff1b\u8ba1\u5212\uff0c\u89c4\u5212\uff1b\u8349\u6848\uff1b\u65b9\u6848\uff1b\u8349\u56fe v.i. \u767b\u4e0a\uff0c\u722c\u4e0a\uff1b\u4e58\u4e0a\uff08\u8f66\u7b49\uff09\uff0c\u9a91\u4e0a\uff08\u9a6c\u7b49\uff09\uff1b\u5347\u9ad8\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 168,
    word: "monter",
    phonetic: "[m\u0254\u0303te]",
    type: "",
    translation: "\u664b\u5347\uff1b\u5347\uff0c\u5347\u8d77\uff0c\u4e0a\u5347\uff1b\u4e0a\u6da8\uff0c\u63d0\u9ad8\uff1bv.t. \u6500\u767b\uff0c\u722c\u4e0a\uff1b \u9a91\uff1b\u5f80\u4e0a\u642c\u8fd0\uff1b\u7ec4\u88c5\uff0c\u5b89\u88c5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 169,
    word: "gar\u00e7on",
    phonetic: "[gars\u0254\u0303]",
    type: "",
    translation: "n.m. \u7537\u5b69\uff1b\u5c0f\u4f19\u5b50\uff1b\u5c0f\u4f19\u8ba1\uff1b\u4f8d\u5e94\u751f\uff0c\u7537\u670d\u52a1\u5458",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 170,
    word: "simplement",
    phonetic: "[s\u025b\u0303pl\u0259m\u0251\u0303]",
    type: "",
    translation: "adv. \u7b80\u5355\u5730\uff1b\u7b80\u6734\u5730\uff1b\u723d\u76f4\u5730\uff0c\u8001\u5b9e\u5730\uff1b\u4ec5\u4ec5\uff0c\u53ea\u662f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 171,
    word: "mot",
    phonetic: "[mo]",
    type: "",
    translation: "n.m. \u8bcd\uff0c\u5b57\uff1b\u77ed\u8bed\uff1b\u4fbf\u6761\uff1b\u540d\u8a00",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 172,
    word: "arr\u00eat",
    phonetic: "[ar\u03b5]",
    type: "",
    translation: "n.m. \u505c\u6b62\uff0c\u4e2d\u6b62\uff1b\u8f66\u7ad9 v.t.,pr. \u8ddf\u968f\uff1b\u63a5\u7740\u2026\u2026\u800c\u6765\uff1b\u987a\u7740\u2026\u2026\u8d70\uff1b\u6ce8\u610f\uff0c\u5173",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 173,
    word: "suivre",
    phonetic: "[s\u0265ivr]",
    type: "",
    translation: "\u5fc3\uff1b\u9075\u5faa\uff1b\u542c\u4ece\uff1b\u8fde\u63a5\uff1b\u524d\u540e\u8fde\u8d2f\uff0c \u4e92\u76f8\u8054\u7cfb n.m. \u51fb\uff0c\u6253\uff0c\u6572\uff0c\u649e\uff1b\u4e00\u4e3e\uff0c\u4e00\u7740\uff0c\u4e00\u4e0b\uff1b\u6572\u6253\u58f0\uff0c\u649e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 174,
    word: "coup",
    phonetic: "[ku]",
    type: "",
    translation: "\u51fb\u58f0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 175,
    word: "regard",
    phonetic: "[r(\u0259)gar]",
    type: "",
    translation: "n.m. \u770b\uff1b\u6ce8\u89c6\uff1b\u76ee\u5149 a. \u5355\u4e00\u7684\uff0c\u5355\u7eaf\u7684\uff1b\u6613\u61c2\u7684\uff0c\u7b80\u5355\u7684\uff1b\u7b80\u6613\u7684\uff1b\u7b80\u6734",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 176,
    word: "simple",
    phonetic: "[s\u025b\u0303pl]",
    type: "",
    translation: "\u7684\uff1b\u666e\u901a\u7684\uff1b\u5929\u771f\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 177,
    word: "penser",
    phonetic: "[p\u0251\u0303se]",
    type: "",
    translation: "v.i. \u60f3\uff0c\u601d\u7d22\uff0c\u601d\u8003",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 178,
    word: "pratiquer",
    phonetic: "[pratike]",
    type: "",
    translation: "v.t. \u5b9e\u884c\uff0c\u5b9e\u65bd\uff1b\u4ece\u4e8b\uff1b\u8fdb\u884c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 179,
    word: "religion",
    phonetic: "[r\u0259li\u0292j\u0254\u0303]",
    type: "",
    translation: "n.f. \u6559\u4e49\uff1b\u5b97\u6559\uff1b\u5b97\u6559\u751f\u6d3b\uff1b\u5b97\u6559\u4fe1\u4ef0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 180,
    word: "politique",
    phonetic: "[p\u0254litik]",
    type: "",
    translation: "a. \u653f\u6cbb\u7684\uff0c\u653f\u6cbb\u4e0a\u7684\uff1bn.f. \u653f\u6cbb\uff1b\u653f\u7b56\uff0c\u65b9\u9488",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 181,
    word: "raison",
    phonetic: "[r\u03b5z\u0254\u0303]",
    type: "",
    translation: "n.f. \u539f\u56e0\uff0c\u7406\u7531\uff1b\u7406\u667a\uff0c\u7406\u6027\uff1b\u9053\u7406\uff0c\u60c5\u7406\uff1b\u660e\u667a\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 182,
    word: "porte",
    phonetic: "[p\u0254rt]",
    type: "",
    translation: "n.f. \u95e8\uff1b\u57ce\u95e8\uff1b\u57ce\u95e8\u65e7\u5740 adj.poss.\uff0c pron.pers. \u4ed6\u4eec\u7684\uff0c \u5979\u4eec\u7684\uff0c \u5b83\u4eec\u7684\uff1b\u4ed6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 183,
    word: "leur",
    phonetic: "[l\u0153r]",
    type: "",
    translation: "\u4eec\uff0c \u5979\u4eec\uff0c \u5b83\u4eec[\u7528\u4f5c\u95f4\u63a5\u5bbe\u8bed]",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 184,
    word: "sans",
    phonetic: "[s\u0251\u0303]",
    type: "",
    translation: "pr\u00e9p. \u6ca1\u6709\uff0c\u65e0\uff0c\u4e0d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 185,
    word: "risquer",
    phonetic: "[riske]",
    type: "",
    translation: "v.t. \u5192\u2026\u2026\u5371\u9669\uff0c\u4f7f\u2026\u2026\u906d\u5371\u9669\uff1b\u5192\u9669\u505a\uff1b\u6709\u2026\u2026\u53ef\u80fd 5 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. a. [\u653e\u5728\u540d\u8bcd\u524d]\u76f8\u540c\u7684\uff0c\u540c\u6837\u7684\uff1b[\u653e\u5728\u540d\u8bcd\u540e]\u672c\u8eab\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 186,
    word: "m\u00eame",
    phonetic: "[m\u03b5m]",
    type: "",
    translation: "[\u653e\u5728\u4eba\u79f0\u4ee3\u8bcd\u540e]\u81ea\u5df1\uff1badv. \u751a\u81f3\uff0c\u5373\u4f7f\uff1b\u6b63\u662f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 187,
    word: "eux",
    phonetic: "[\u00f8]",
    type: "",
    translation: "pron.pers.m.pl. \u4ed6\u4eec\uff0c\u5b83\u4eec v.i. \u8fdb\u5165\uff1b\u89e6\u53ca\uff0c\u6d89\u53ca\uff1b\u53c2\u52a0\uff0c\u53c2\u4e0e\uff1b\u5305\u62ec\u5728\uff1bv.t. \u642c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 188,
    word: "entrer",
    phonetic: "[\u0251\u0303tre]",
    type: "",
    translation: "\u5165\uff0c\u8fd0\u5165",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 189,
    word: "chose",
    phonetic: "[\u222boz]",
    type: "",
    translation: "n.f. \u4e8b\u60c5\uff0c\u4e8b\u7269\uff1b\u4e8b\u5b9e\uff1b\u4e8b\u6001\uff1b\u4e1c\u897f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 190,
    word: "visiter",
    phonetic: "[vizite]",
    type: "",
    translation: "v.t. \u53c2\u89c2\uff0c\u6e38\u89c8\uff1b\u89c6\u5bdf\uff0c\u5de1\u89c6\uff1b\u68c0\u67e5\uff0c\u641c\u67e5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 191,
    word: "loin",
    phonetic: "[lw\u025b\u0303]",
    type: "",
    translation: "adv. \u8fdc\uff0c\u9065\u8fdc\uff1b\u4e45\u8fdc\uff0c\u957f\u4e45",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 192,
    word: "malheureusement",
    phonetic: "[mal\u00f8r\u00f8zm\u0251\u0303]",
    type: "",
    translation: "adv. \u4e0d\u5e78\u5730\uff0c\u53ef\u60dc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 193,
    word: "air",
    phonetic: "[\u03b5r]",
    type: "",
    translation: "n.m. \u5927\u6c14\uff0c\u7a7a\u6c14\uff1b\u7a7a\u4e2d\uff0c\u5929\u7a7a\uff1b\u6837\u5b50\uff0c\u795e\u8272",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 194,
    word: "entendre",
    phonetic: "[\u0251\u0303t\u0251\u0303dr]",
    type: "",
    translation: "v.t. \u542c\u89c1\uff1b\u542c\u61c2\uff0c\u9886\u4f1a\uff1b\u60f3\uff0c\u6253\u7b97",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 195,
    word: "parfait",
    phonetic: "[parf\u03b5]",
    type: "",
    translation: "a. \u5b8c\u7f8e\u7684\uff0c\u5b8c\u5584\u7684\uff1b\u5341\u8db3\u7684\uff0c\u5730\u9053\u7684\uff1bn.m. [\u8bed]\u5b8c\u6210\u5f0f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 196,
    word: "danser",
    phonetic: "[d\u0251\u0303se]",
    type: "",
    translation: "v.i. \u8df3\u821e\uff1b\u8868\u6f14\uff08\u821e\u8e48\uff09 a. \u5bcc\u7684\uff0c\u6709\u94b1\u7684\uff1b\u5145\u8db3\u7684\uff1b\u4e30\u5bcc\u7684\uff0c\u5bcc\u9976\u7684\uff1bn. \u5bcc\u4eba\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 197,
    word: "riche",
    phonetic: "[ri\u222b]",
    type: "",
    translation: "\u6709\u94b1\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 198,
    word: "robe",
    phonetic: "[r\u0254b]",
    type: "",
    translation: "n.f. \u8fde\u8863\u88d9\uff1b\u957f\u888d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 199,
    word: "long",
    phonetic: "[l\u0254\u0303, -g]",
    type: "",
    translation: "a.\uff08\u7a7a\u95f4\uff09\u957f\u7684\uff0c\u8fdc\u7684\uff1b\uff08\u65f6\u95f4\uff09\u957f\u7684\uff0c\u4e45\u7684\uff0c\u4e45\u8fdc\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 200,
    word: "rue",
    phonetic: "[ry]",
    type: "",
    translation: "n.f. \u8857\uff0c\u8857\u9053\uff0c\u9a6c\u8def",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 201,
    word: "aussit\u00f4t",
    phonetic: "[osito]",
    type: "",
    translation: "adv. \u7acb\u523b\uff0c\u7acb\u5373\uff0c\u5373\u523b\uff0c\u9a6c\u4e0a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 202,
    word: "placer",
    phonetic: "[plase]",
    type: "",
    translation: "v.t. \u4f7f\u5c31\u5ea7\uff1b\u5b89\u653e\uff1b\u7ed9\u4e88\u2026\u2026\u4f4d\u5b50\uff1b\u6295\u8d44\uff0c\u5b58\u653e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 203,
    word: "monde",
    phonetic: "[m\u0254\u0303d]",
    type: "",
    translation: "n.m. \u4e16\u754c\uff1b\u4eba\u95f4\uff1b\u4eba\u4eec\uff1b\u9636\u5c42\uff1b\u754c\uff1b\u4e0a\u6d41\u793e\u4f1a\uff0c\u793e\u4ea4\u754c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 204,
    word: "absolument",
    phonetic: "[aps\u0254lym\u0251\u0303]",
    type: "",
    translation: "adv. \u7edd\u5bf9\u5730\uff0c\u5b8c\u5168\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 205,
    word: "voyager",
    phonetic: "[vwaja\u0292e]",
    type: "",
    translation: "v.i. \u65c5\u884c\uff1b\u65c5\u6e38\uff0c\u6e38\u5386\uff1b\u88ab\u8fd0\u9001\uff0c\u88ab\u8fd0\u8f93[\u6307\u7269\u6216\u7272\u53e3] adj. \u7ed9\u4e88\u7684\uff0c \u9001\u7ed9\u7684\uff1b\u5df2\u5b9a\u7684\uff0c \u4e00\u5b9a\u7684\uff1b \u5df2\u77e5\u7684\uff0c \u5047",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 206,
    word: "donn\u00e9",
    phonetic: "[d\u0254ne]",
    type: "",
    translation: "\u5b9a\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 207,
    word: "dernier",
    phonetic: "[d\u03b5rnje, -\u03b5r]",
    type: "",
    translation: "a. \u6700\u540e\u7684\uff1b\u6700\u4f4e\u52a3\u7684\uff0c\u6700\u5dee\u7684\uff1b\u6700\u8fd1\u7684\uff0c\u6700\u65b0\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 208,
    word: "celui",
    phonetic: "[s\u0259l\u0265i]",
    type: "",
    translation: "pron.d\u00e9m. \u6307\u793a\u4ee3\u8bcd\u8fd9\u4e2a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 209,
    word: "attendre",
    phonetic: "[at\u0251\u0303dr]",
    type: "",
    translation: "v.t. \u7b49\uff0c\u7b49\u5019\uff1b\u7b49\u5f85\uff1b\u671f\u671b\uff0c\u671f\u5f85 pr\u00e9p. \u548c\uff0c\u540c\uff0c\u8ddf\uff0c\u4e0e\uff1b\u7528\uff0c\u4f7f\u7528\uff1b\u968f\u7740\uff1b\u7531\u4e8e\uff0c\u56e0\u4e3a\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 210,
    word: "avec",
    phonetic: "[av\u03b5k]",
    type: "",
    translation: "\u5bf9\u4e8e\uff1b\u5e26\u6709\uff0c\u5177\u6709\uff1b\u5c3d\u7ba1 v.t. \u62ff\uff0c\u53d6\uff0c\u6293\uff1b\u643a\u5e26\uff1b\u642d\u4e58\uff1b\u5e26\u8d70\uff0c\u63a5\u8d70\uff1b\u5403\uff0c\u559d\uff0c\u670d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 211,
    word: "prendre",
    phonetic: "[pr\u0251\u0303dr]",
    type: "",
    translation: "\u7528\uff1b\u8bb0\u5f55\uff1b\u62cd\u6444\uff1b\u63a5\u53d7\uff1b\u4e70\uff1b\u5360\u7528\uff0c\u82b1\u8d39\uff1b\u653b\u5360\uff0c\u593a\u53d6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 212,
    word: "esprit",
    phonetic: "[\u03b5spri]",
    type: "",
    translation: "n.m. \u7075\u9b42\uff1b\u795e\u7075\uff1b\u7cbe\u7075\uff0c\u9b3c\u795e\uff1b\u601d\u60f3\uff1b\u7cbe\u795e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 213,
    word: "int\u00e9r\u00eat",
    phonetic: "[\u025b\u0303ter\u03b5]",
    type: "",
    translation: "n.m. \u5229\u606f\uff1b\u5229\u76ca\uff0c\u597d\u5904\uff1b\u5173\u5fc3\uff1b\u5174\u8da3\uff0c\u6ce8\u610f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 214,
    word: "inutile",
    phonetic: "[inytil]",
    type: "",
    translation: "a. \u65e0\u7528\u7684\uff0c\u65e0\u5b9e\u7528\u4ef7\u503c\u7684\uff1b\u65e0\u76ca\u7684\uff0c\u65e0\u6548\u7684\uff0c\u5f92\u52b3\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 215,
    word: "bon",
    phonetic: "[b\u0254\u0303, b\u0254n]",
    type: "",
    translation: "a. \u597d\u7684\uff1b\u6070\u5f53\u7684\uff1b\u6b63\u786e\u7684\uff1b\u4f18\u79c0\u7684\uff1b\u7f8e\u597d\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 216,
    word: "chaise",
    phonetic: "[\u222b\u03b5z]",
    type: "",
    translation: "n.f. \u6905\u5b50",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 217,
    word: "capitale",
    phonetic: "[kapital]",
    type: "",
    translation: "n.f. \u9996\u90fd\uff1b\u9996\u5e9c v.,v.pr. \u5173\uff0c\u5173\u95ed\uff1b\u5c01\u95ed\uff1b\u95ed\u4e0a\uff0c\u5408\u62e2\uff1b\u5173\u6389\uff08\u6c34\u3001\u7535",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 218,
    word: "fermer",
    phonetic: "[f\u03b5rme]",
    type: "",
    translation: "\u7b49\uff09\uff0c\u505c\u6b62\u4f7f\u7528 a. \u5fc5\u8981\u7684\uff0c\u5fc5\u9700\u7684\uff1b\u4e0d\u53ef\u6216\u7f3a\u7684\uff1b\u4e0d\u53ef\u907f\u514d\u7684\uff1b\u5fc5\u7136",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 219,
    word: "n\u00e9cessaire",
    phonetic: "[neses\u03b5r]",
    type: "",
    translation: "ou [nes\u03b5s\u03b5r] \u7684\uff1bn.m.\uff08\u751f\u6d3b\uff09\u5fc5\u9700\u54c1\uff1b\u5fc5\u987b\u505a\u7684\u4e8b v.i. \u6ed1\uff0c\u6ed1\u52a8\uff0c\u6ed1\u884c v.t. \u6084\u6084\u5730\u585e\u8fdb\uff1b\uff08\u628a\u60f3\u6cd5\u3001\u610f\u89c1\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 220,
    word: "glisser",
    phonetic: "[glise]",
    type: "",
    translation: "\u5de7\u5999\u5730\u52a0\u8fdb\u53bb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 221,
    word: "enfant",
    phonetic: "[\u0251\u0303f\u0251\u0303]",
    type: "",
    translation: "n. \u513f\u7ae5\uff0c\u5c0f\u5b69\uff1b\u5b50\u5973",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 222,
    word: "billet",
    phonetic: "[bij\u03b5]",
    type: "",
    translation: "n.m. \u7968\uff0c\u5238\uff1b\u95e8\u7968\uff1b\u949e\u7968 6 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. a. \u7b2c\u4e00\u7684\uff1b\u539f\u59cb\u7684\uff1b\u7b2c\u4e00\u4f4d\u7684\uff0c\u9996\u8981\u7684\uff1b\u521d\u6b65\u7684\uff0c\u57fa\u672c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 223,
    word: "premier",
    phonetic: "[pr\u0259mje, -\u03b5r]",
    type: "",
    translation: "\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 224,
    word: "classer",
    phonetic: "[klase]",
    type: "",
    translation: "v.t. \u5206\u7c7b\uff0c\u5206\u7ea7\uff1b\u5f52\u7c7b\uff1b\u6574\u7406\uff0c\u6392\u5217\uff1b\u5f52\uff1b\u7f16\u7ec4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 225,
    word: "samedi",
    phonetic: "[samdi]",
    type: "",
    translation: "n.m. \u661f\u671f\u516d v.t. \u91cd\u65b0\u770b\uff0c\u518d\u770b\uff1b\u91cd\u89c1\u67d0\u4eba\uff0c\u518d\u89c1\u67d0\u4eba\uff1b\u590d\u67e5\uff0c\u590d\u6838\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 226,
    word: "revoir",
    phonetic: "[r(\u0259)vwar]",
    type: "",
    translation: "\u590d\u5ba1\uff1b\u590d\u4e60\uff0c\u6e29\u4e60",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 227,
    word: "pluie",
    phonetic: "[pl\u0265i]",
    type: "",
    translation: "n.f. \u96e8\uff0c\u4e0b\u96e8\uff1b\uff08\u96e8\u70b9\u822c\u88ad\u6765\u7684\uff09\u4e00\u9635\uff1b\u5927\u91cf\uff0c\u5927\u6279",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 228,
    word: "coin",
    phonetic: "[kw\u025b\u0303]",
    type: "",
    translation: "n.m. \u89d2\uff0c\u89d2\u843d\uff1b\u4e00\u9685\u4e4b\u5730\uff1b\u504f\u50fb\u7684\u5730\u65b9\uff1b\u5c45\u4f4f\u7684\u8857\u533a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 229,
    word: "parler",
    phonetic: "[parle]",
    type: "",
    translation: "v.i. \u8bf4\uff1b\u8bb2\u8bdd\uff1bv.t. \u8bf4\uff0c\u8bb2\uff08\u67d0\u79cd\u8bed\u8a00\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 230,
    word: "gaz",
    phonetic: "[g\u0251z]",
    type: "",
    translation: "n.m. \u6c14\uff0c\u6c14\u4f53\uff1b\u5929\u7136\u6c14\uff0c\u7164\u6c14",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 231,
    word: "histoire",
    phonetic: "[istwar]",
    type: "",
    translation: "n.f. \u5386\u53f2\uff1b\u5386\u53f2\u4e66\u7c4d\uff1b\u5386\u53f2\u5b66\uff1b\u6545\u4e8b\uff1b\uff08\u591a\u7528\u590d\u6570\uff09\u8c0e\u8a00",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 232,
    word: "lac",
    phonetic: "[lak]",
    type: "",
    translation: "n.m. \u6e56\uff0c\u6e56\u6cca v.t. \u7b97\uff0c\u8ba1\u7b97\uff1b\u4f30\u8ba1\uff0c\u4f30\u91cf\uff1b\u76d8\u7b97\uff0c\u6253\u7b97\uff1bv.i. \u7b97\uff0c\u8ba1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 233,
    word: "calculer",
    phonetic: "[kalkyle]",
    type: "",
    translation: "\u7b97\uff1b\u7cbe\u6253\u7ec6\u7b97",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 234,
    word: "travail",
    phonetic: "[travaj]",
    type: "",
    translation: "n.m. \u52b3\u52a8\uff0c\u5de5\u4f5c\uff1b\u6d3b\u513f\uff1b\u4efb\u52a1\uff1b\u804c\u4e1a\uff1b\u5e72\u6d3b\uff1b\u5de5\u4f5c\u5730\u70b9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 235,
    word: "front",
    phonetic: "[fr\u0254\u0303]",
    type: "",
    translation: "n.m. \u524d\u989d\uff1b\u9876\uff0c\u5cf0\uff1b\u6b63\u9762\uff1b\u524d\u7ebf\uff0c\u9635\u7ebf a. \u9ed1\u7684\uff0c\u9ed1\u8272\u7684\uff0c\u9edd\u9ed1\u7684\uff1b\u9ed1\u6697\u7684\uff1b\u80ae\u810f\u7684\uff1b\u60b2\u89c2\u7684\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 236,
    word: "noir",
    phonetic: "[nwar]",
    type: "",
    translation: "\u5fe7\u4f24\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 237,
    word: "nombre",
    phonetic: "[n\u0254\u0303br]",
    type: "",
    translation: "n.m. \u6570\uff1b\u6570\u76ee\uff0c\u6570\u91cf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 238,
    word: "contraire",
    phonetic: "[k\u0254\u0303tr\u03b5r]",
    type: "",
    translation: "adj. \u76f8\u53cd\u7684\uff1b\u6709\u5bb3\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 239,
    word: "raconter",
    phonetic: "[rak\u0254\u0303te]",
    type: "",
    translation: "v.t. \u53d9\u8ff0\uff0c\u8bb2\u8ff0\uff1b\u4e71\u5439\uff0c\u778e\u8bb2 n.m. \u788e\u7247\uff0c\u88c2\u7247\uff1b\u7a81\u7136\u53d1\u51fa\u7684\u5de8\u54cd\uff1b\u4eae\u5ea6\uff1b\u5149\u8292\uff1b\u9c9c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 240,
    word: "\u00e9clat",
    phonetic: "[ekla]",
    type: "",
    translation: "\u8273\uff0c\u9c9c\u660e\uff1b\u5149\u5f69",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 241,
    word: "fr\u00e8re",
    phonetic: "[fr\u03b5r]",
    type: "",
    translation: "n.m. \u5144\u5f1f\uff1b\u793e\u53cb\uff0c\u4f1a\u53cb\uff1b\u540c\u884c\uff0c\u540c\u4e8b\uff1b\u4fee\u58eb a. \u516c\u4f17\u7684\uff0c\u6c11\u4f17\u7684\uff1b\u56fd\u5bb6\u7684\uff0c\u653f\u5e9c\u7684\uff1b\u516c\u7acb\u7684\uff1b\u516c\u5171",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 242,
    word: "public",
    phonetic: "[pyblik]",
    type: "",
    translation: "\u7684\uff0c\u516c\u7528\u7684\uff1b\u516c\u5f00\u7684\uff1bn.m. \u516c\u4f17\uff0c\u6c11\u4f17\uff0c\u5927\u4f17",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 243,
    word: "ann\u00e9e",
    phonetic: "[ane]",
    type: "",
    translation: "n.f. \u5e74\uff0c\u5e74\u4efd\uff1b\u5e74\u5ea6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 244,
    word: "rappeler",
    phonetic: "[raple]",
    type: "",
    translation: "v.t. \u518d\u6b21\u6253\u7535\u8bdd\u7ed9\uff08\u67d0\u4eba\uff09\uff1b\u53eb\u56de\uff1b\u53ec\u56de\uff1b\u4f7f\u60f3\u8d77",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 245,
    word: "notre",
    phonetic: "[n\u0254tr]",
    type: "",
    translation: "adj.poss. \u6211\u4eec\u7684\uff1b\u6211\u7684 a. \u5bbd\u7684\uff0c\u5bbd\u9614\u7684\uff0c\u5bbd\u655e\u7684\uff1b\u5bbd\u5927\u7684\uff1bn.m. \u5bbd\u5ea6\uff1b\u5916\u6d77\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 246,
    word: "large",
    phonetic: "[lar\u0292]",
    type: "",
    translation: "\u5927\u6d77",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 247,
    word: "superbe",
    phonetic: "[syp\u03b5rb]",
    type: "",
    translation: "a. \u7f8e\u597d\u7684\uff0c\u6f02\u4eae\u7684\uff0c\u7eda\u4e3d\u7684\uff1b\u6781\u597d\u7684\uff0c\u7edd\u5999\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 248,
    word: "mois",
    phonetic: "[mwa]",
    type: "",
    translation: "n.m. \u6708\uff0c\u6708\u4efd\uff1b\u4e00\u4e2a\u6708\u7684\u65f6\u95f4 v.i. \u4e0b\uff0c\u4e0b\u6765\uff0c\u4e0b\u53bb\uff1b\u671d\u5357\u8d70\uff1b\u4e0b\u69bb\uff1b\u51fa\u8eab\u4e8e\uff0c\u662f\u2026\u2026\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 249,
    word: "descendre",
    phonetic: "[des\u0251\u0303dr]",
    type: "",
    translation: "\u540e\u88d4\uff1b\u964d\u843d\uff0c\u843d\u4e0b\uff1b\u4e0b\u964d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 250,
    word: "besoin",
    phonetic: "[b\u0259zw\u025b\u0303]",
    type: "",
    translation: "n.m. \u60f3\u671b\uff0c\u6b32\u671b\uff0c\u8981\u6c42\uff1b\u9700\u8981\uff0c\u5fc5\u8981\uff0c\u9700\u6c42",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 251,
    word: "citoyen",
    phonetic: "[sitwaj\u025b\u0303, -\u03b5n]",
    type: "",
    translation: "n. \u5e02\u6c11\uff0c\u57ce\u91cc\u4eba\uff1b\u516c\u6c11\uff0c\u56fd\u6c11",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 252,
    word: "mari",
    phonetic: "[mari]",
    type: "",
    translation: "n.m. \u4e08\u592b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 253,
    word: "combien",
    phonetic: "[k\u0254\u0303bj\u025b\u0303]",
    type: "",
    translation: "adv. \u7b2c\u51e0\uff1b\u51e0\u53f7\uff1b\u591a\u5c11\uff1b\u591a\u4e48",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 254,
    word: "retenir",
    phonetic: "[r\u0259tnir]",
    type: "",
    translation: "v.t. \u6263\u7559\uff1b\u6263\u9664\uff1b\u963b\u6b62\uff0c\u6293\u4f4f\uff1b\u7559\u4f4f\uff1b\u6291\u5236\uff1b\u8bb0\u4f4f\uff1b\u9884\u5b9a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 255,
    word: "rire",
    phonetic: "[rir]",
    type: "",
    translation: "v.i. \u7b11\uff0c\u53d1\u7b11\uff1b\u73a9\u4e50\uff1b\u5f00\u73a9\u7b11\uff1bn.m. \u7b11",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 256,
    word: "lit",
    phonetic: "[li]",
    type: "",
    translation: "n.m. \u5e8a\uff1b\u57ab\uff0c\u8925\uff1b\u6cb3\u5e8a n.m. \u8425\u5730\uff0c\u519b\u8425\uff1b\u91ce\u8425\u5730\uff0c\u9732\u8425\u5730\uff1b\uff08\u96c6\u4e2d\uff09\u8425\uff1b[\u653f]",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 257,
    word: "camp",
    phonetic: "[k\u0251\u0303]",
    type: "",
    translation: "\u9635\u8425",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 258,
    word: "trentaine",
    phonetic: "[tr\u0251\u0303t\u03b5n]",
    type: "",
    translation: "n.f. \u4e09\u5341\uff0c\u4e09\u5341\u6765\u4e2a\uff1b\u4e09\u5341\u5c81\uff0c\u4e09\u5341\u5c81\u5de6\u53f3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 259,
    word: "humain",
    phonetic: "[ym\u025b\u0303, -\u03b5n]",
    type: "",
    translation: "a. \u6709\u4eba\u7684\u7279\u70b9\u7684\uff0c\u7531\u4eba\u7ec4\u6210\u7684\uff1b\u4eba\u7684\uff1b\u4eba\u6587\u7684\uff1b\u4eba\u9053\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 260,
    word: "horrible",
    phonetic: "[\u0254ribl]",
    type: "",
    translation: "a. \u53ef\u6015\u7684\uff0c\u6050\u6016\u7684\uff0c\u53ef\u618e\u7684\uff1b\u7cdf\u7cd5\u7684\uff0c\u6076\u52a3\u7684 7 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 261,
    word: "arriv\u00e9e",
    phonetic: "[arive]",
    type: "",
    translation: "n.f. \u5230\u8fbe\uff1b\u5230\u8fbe\u7684\u65f6\u95f4\u6216\u5730\u70b9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 262,
    word: "millier",
    phonetic: "[milje]",
    type: "",
    translation: "n.m. \u5343\uff0c\u5343\u6570\uff0c\u7ea6\u5343\u6570\uff1b\u5f88\u591a\u5f88\u591a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 263,
    word: "installer",
    phonetic: "[\u025b\u0303stale]",
    type: "",
    translation: "v.t. \u5b89\u987f\uff0c\u5b89\u7f6e\uff1b\u5b89\u88c5\uff1b\u5e03\u7f6e\uff0c\u88c5\u914d\uff1b\u5b89\u653e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 264,
    word: "nourrir",
    phonetic: "[nurir]",
    type: "",
    translation: "v.t. \u4f9b\u7ed9\u98df\u7269\uff0c\u5582\u517b\uff1b\u8d61\u517b\uff0c\u629a\u517b\uff1b\u57f9\u517b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 265,
    word: "personnage",
    phonetic: "[p\u03b5rs\u0254na\u0292]",
    type: "",
    translation: "n.m. \u4eba\u7269\uff0c\u89d2\u8272\uff1b\u540d\u4eba\uff0c\u8981\u4eba\uff1b\u4eba[\u6307\u54c1\u884c\u3001\u5916\u8868]",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 266,
    word: "gymnastique",
    phonetic: "[\u0292imnastik]",
    type: "",
    translation: "n.f. \u4f53\u64cd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 267,
    word: "connaissance",
    phonetic: "[k\u0254n\u03b5s\u0251\u0303s]",
    type: "",
    translation: "n.f. \u8ba4\u8bc6\uff0c\u77e5\u9053\uff1b\u611f\u89c9\uff1b\u7ed3\u8bc6\uff1b\u77e5\u8bc6 v.t. \u5f71\u54cd\uff1b\u611f\u52a8\uff1b\u4f7f\u4e0d\u5b89\uff0c\u4f7f\u75db\u82e6\uff1b\u89c4\u5b9a\u2026\u2026\uff08\u7684\u7528",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 268,
    word: "affecter",
    phonetic: "[af\u03b5kte]",
    type: "",
    translation: "\u9014\uff09\uff0c\u62e8\uff1b\u6307\u6d3e\uff0c\u5206\u914d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 269,
    word: "vraiment",
    phonetic: "[vr\u03b5m\u0251\u0303]",
    type: "",
    translation: "adv. \u771f\u6b63\u5730\uff0c\u786e\u5b9e\u5730\uff0c\u5b9e\u5728\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 270,
    word: "fen\u00eatre",
    phonetic: "[f(\u0259)n\u03b5tr]",
    type: "",
    translation: "n.f. \u7a97\uff1b\u73bb\u7483\u7a97\uff1b\u7a97\u72b6\u5f00\u53e3\uff1b[\u4fe1]\u7a97\u53e3 v.t. \u4ecb\u7ecd\uff0c\u5f15\u89c1\uff1b\u9001\u4e0a\uff1b\u51fa\u793a\uff1b\u9610\u8ff0\uff0c\u8bf4\u660e\uff1b\u5c55\u793a\uff1b\u663e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 271,
    word: "pr\u00e9senter",
    phonetic: "[prez\u0251\u0303te]",
    type: "",
    translation: "\u793a\uff0c\u8868\u73b0\u51fa",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 272,
    word: "\u00e9gard",
    phonetic: "[egar]",
    type: "",
    translation: "n.m. 1.\u8003\u8651\uff0c\u6ce8\u610f\uff1b 2.\u6ce8\u91cd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 273,
    word: "\u00e9l\u00e9phant",
    phonetic: "[elef\u0251\u0303]",
    type: "",
    translation: "n.m. \u8c61",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 274,
    word: "novembre",
    phonetic: "[n\u0254v\u0251\u0303br]",
    type: "",
    translation: "n.m. \u5341\u4e00\u6708",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 275,
    word: "id\u00e9e",
    phonetic: "[ide]",
    type: "",
    translation: "n.f. \u770b\u6cd5\uff0c\u60f3\u6cd5\uff1b\u6982\u5ff5\uff1b\u89c2\u5ff5\uff1b\u6982\u51b5\uff1b\u8ba1\u5212\uff1b\u601d\u60f3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 276,
    word: "question",
    phonetic: "[k\u03b5stj\u0254\u0303]",
    type: "",
    translation: "n.f. \u95ee\u9898\uff0c\u95ee\u8bdd\uff1b\u8003\u9898",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 277,
    word: "examiner",
    phonetic: "[\u03b5gzamine]",
    type: "",
    translation: "v.t. \u5ba1\u67e5\uff0c\u68c0\u67e5\uff0c\u7814\u7a76\uff1b\u7ec6\u770b\uff1b\u8bca\u89c6 pr\u00e9p. \u5728\u2026\u2026\u4e0a\u9762\uff1b\u671d\u2026\u2026\u4e0a\u9762\uff1b\u5411\u7740\uff1b\u9ad8\u4e8e\uff0c\u80dc\u4e8e\uff1b\u5173 278 s\u00fbr \u4e8e\uff1b\u6839\u636e\uff1b\u51ed",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 278,
    word: "boire",
    phonetic: "[bwar]",
    type: "",
    translation: "v.t. \u559d\uff0c\u996e\uff1b\u5438\u6536",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 279,
    word: "acheter",
    phonetic: "[a\u222bte]",
    type: "",
    translation: "v.t. \u8d2d\u4e70\uff1b\u6536\u4e70\uff0c\u884c\u8d3f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 280,
    word: "circuler",
    phonetic: "[sirkyle]",
    type: "",
    translation: "v.i. \u5faa\u73af\uff0c\u6d41\u901a\uff1b\u5f80\u6765\uff0c\u901a\u884c\uff1b\u6d41\u4f20\uff1b\u4f20\u64ad\uff0c\u6563\u5e03",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 281,
    word: "sembler",
    phonetic: "[s\u0251\u0303ble]",
    type: "",
    translation: "v.i. \u597d\u50cf\uff0c\u4f3c\u4e4e\uff0c\u770b\u6765\u662f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 282,
    word: "arbre",
    phonetic: "[arbr]",
    type: "",
    translation: "n.m. \u6811\uff0c\u6811\u6728",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 283,
    word: "groupe",
    phonetic: "[grup]",
    type: "",
    translation: "n.m. \u7fa4\uff1b\u5806\uff0c\u4e1b\uff1b\u73ed\uff0c\u7ec4\uff1b\u56e2\u4f53",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 284,
    word: "exercice",
    phonetic: "[\u03b5gz\u03b5rsis]",
    type: "",
    translation: "n.m. \u7ec3\u4e60\uff0c\u8bad\u7ec3\uff0c\u953b\u70bc\uff1b\u4e60\u9898\uff1b\u4f53\u80b2\u6d3b\u52a8 a. \u4e60\u60ef\u7684\uff0c\u4e60\u60ef\u6027\u7684\uff0c\u60ef\u7528\u7684\uff1b\u7ecf\u5e38\u7684\uff0c\u901a\u5e38\u7684\uff1b\u5e38\u89c1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 285,
    word: "habituel",
    phonetic: "[abit\u0265\u03b5l]",
    type: "",
    translation: "\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 286,
    word: "probable",
    phonetic: "[pr\u0254babl]",
    type: "",
    translation: "a. \u5f88\u53ef\u80fd\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 287,
    word: "quel",
    phonetic: "[k\u03b5l]",
    type: "",
    translation: "adj.interr. \u4ec0\u4e48\u6837\u7684\uff0c \u54ea\u4e00\u7c7b\u7684\uff1b\u591a\u4e48\uff0c \u4f55\u7b49\uff1b\u54ea\u4e00\u4e2a n.f. \u4e8b\u52a1\uff1b\u95ee\u9898\uff1b\u4e8b\u60c5\uff1b\u7ea0\u7eb7\uff1b\u4e70\u5356\uff1bpl. \u5546\u4e1a\uff0c\u751f\u610f\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 288,
    word: "affaire",
    phonetic: "[af\u03b5r]",
    type: "",
    translation: "\uff08\u4e2a\u4eba\u7684\uff09\u8863\u7269",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 289,
    word: "communication",
    phonetic: "[k\u0254mynikasj\u0254\u0303]",
    type: "",
    translation: "n.f. \u4ea4\u9645\uff0c\u4ea4\u6d41\uff1b\u901a\u77e5\uff1b\u6d88\u606f\uff1b\u76f8\u8fde",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 290,
    word: "lire",
    phonetic: "[lir]",
    type: "",
    translation: "v.t. \u9605\u8bfb\uff0c\u8bfb\u61c2\uff1b\u6717\u8bfb\uff1b\u5ba3\u8bfb\uff1b\u5bdf\u77e5\uff0c\u770b\u51fa",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 291,
    word: "cr\u00e9dit",
    phonetic: "[kredi]",
    type: "",
    translation: "n.m. \u4fe1\u4efb\uff1b\u4fe1\u8a89\uff1b\u4fe1\u7528\uff1b\u4ed8\u6b3e\u671f\u9650\uff1b\u4fe1\u8d37\uff1b[\u4f1a]\u8d37\u65b9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 292,
    word: "r\u00e9gion",
    phonetic: "[re\u0292j\u0254\u0303]",
    type: "",
    translation: "n.f. \u5730\u533a\uff0c\u5730\u5e26\uff1b\u5927\u533a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 293,
    word: "lundi",
    phonetic: "[l\u0153\u0303di]",
    type: "",
    translation: "n.m. \u661f\u671f\u4e00",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 294,
    word: "mariage",
    phonetic: "[marja\u0292]",
    type: "",
    translation: "n.m. \u7ed3\u5a5a\uff0c\u5a5a\u59fb\uff1b\u5a5a\u793c\uff1b\u8054\u59fb\uff0c\u5408\u5e76\uff1b\u7ed3\u5408\uff0c\u878d\u5408 a. \u4f4e\u52a3\u7684\uff0c\u574f\u7684\uff1b\u4e0d\u9002\u5f53\u7684\uff1b\u4e0d\u7965\u7684\uff1b\u6709\u5bb3\u7684\uff0c\u5371\u9669",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 295,
    word: "mauvais",
    phonetic: "[m\u0254v\u03b5, -z]",
    type: "",
    translation: "\u7684\uff1b\u6076\u7684\uff0c\u6076\u6bd2\u7684\uff0c\u6076\u610f\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 296,
    word: "allure",
    phonetic: "[alyr]",
    type: "",
    translation: "n.f. \u6b65\u5b50\uff0c\u4e3e\u6b62\uff0c\u6001\u5ea6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 297,
    word: "lune",
    phonetic: "[lyn]",
    type: "",
    translation: "n.f. \u6708\u4eae\uff0c\u6708\u7403",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 298,
    word: "quart",
    phonetic: "[kar]",
    type: "",
    translation: "n.m. \u56db\u5206\u4e4b\u4e00\uff1b\u56db\u5206\u4e4b\u4e00\u5347\u7684\u5c0f\u74f6\uff1b\u56db\u5206\u4e4b\u4e00\u5347\u7684\u91cf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 299,
    word: "maximum",
    phonetic: "[maksim\u0254m]",
    type: "",
    translation: "n.m. \u6700\u5927\u91cf\uff0c\u6700\u5927\u6570\uff0c\u6700\u5927\u9650\u5ea6\uff1ba. \u6700\u5927\u7684\uff0c\u6700\u9ad8\u7684 8 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 300,
    word: "app\u00e9tit",
    phonetic: "[apeti]",
    type: "",
    translation: "n.m. \u98df\u6b32\uff0c\u80c3\u53e3\uff1b\u6b32\u671b\uff0c\u6e34\u671b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 301,
    word: "probablement",
    phonetic: "[pr\u0254babl\u0259m\u0251\u0303]",
    type: "",
    translation: "adv. \u53ef\u80fd\uff0c\u5927\u6982\uff0c\u6216\u8bb8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 302,
    word: "fatiguer",
    phonetic: "[fatige]",
    type: "",
    translation: "v.t. \u4f7f\u75b2\u52b3\uff1b\u635f\u574f\uff1b\u4f7f\u538c\u5026",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 303,
    word: "beaucoup",
    phonetic: "[boku]",
    type: "",
    translation: "adv. \u5f88\uff0c\u5f88\u591a\uff1b\u592a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 304,
    word: "exact",
    phonetic: "[\u03b5gza(kt), \u03b5gzakt]",
    type: "",
    translation: "a. \u51c6\u786e\u7684\uff0c\u786e\u5207\u7684\uff0c\u7cbe\u786e\u7684\uff1b\u51c6\u65f6\u7684\uff0c\u5b88\u65f6\u7684\uff1b\u771f\u5b9e\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 305,
    word: "partie",
    phonetic: "[parti]",
    type: "",
    translation: "n.f. \u90e8\u5206\uff0c\u5c40\u90e8\uff1b\u90e8\u95e8\uff1b\u4e13\u4e1a\uff1b\u5f53\u4e8b\u4eba\uff1b\u4e00\u76d8\uff0c\u4e00\u573a v.t.\uff0c v.pr. 1.\u629b\u4e0b\uff0c\u6295\u4e0b\uff1b\u4f7f\u7a81\u7136\u9677\u5165\uff1b 2.\u52a0\u901f\u52a0\u5feb\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 306,
    word: "pr\u00e9cipiter",
    phonetic: "[presipite]",
    type: "",
    translation: "\u731b\u63a8\uff0c\u731b\u62c9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 307,
    word: "journal",
    phonetic: "[\u0292urnal]",
    type: "",
    translation: "n.m. \u62a5\u7eb8\uff1b\u65b0\u95fb\u62a5\u9053\uff1b\u65e5\u8bb0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 308,
    word: "nouvelle",
    phonetic: "[nuv\u03b5l]",
    type: "",
    translation: "n.f. \u6d88\u606f\uff1b\u97f3\u4fe1\uff1b\u65b0\u95fb\u62a5\u9053\uff1b\u77ed\u7bc7\u5c0f\u8bf4\uff0c\u4e2d\u7bc7\u5c0f\u8bf4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 309,
    word: "forc\u00e9",
    phonetic: "[f\u0254rse]",
    type: "",
    translation: "a. \u88ab\u8feb\u7684\uff0c\u5f3a\u5236\u7684\uff1b\u4e0d\u53ef\u907f\u514d\u7684\uff0c\u5fc5\u7136\u7684\uff1b\u4e0d\u81ea\u7136\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 310,
    word: "surface",
    phonetic: "[syrfas]",
    type: "",
    translation: "n.f.\uff08\u7269\u4f53\u7684\uff09\u9762\uff0c\u8868\u9762\uff1b\u9762\u79ef\uff1b\uff08\u4e8b\u7269\u7684\uff09\u5916\u8868",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 311,
    word: "sp\u00e9cial",
    phonetic: "[spesjal]",
    type: "",
    translation: "a. \u7279\u6b8a\u7684\uff0c\u7279\u522b\u7684\uff1b\u7279\u6709\u7684\uff0c\u7279\u8bbe\u7684\uff1b\u4e13\u95e8\u7684\uff1b\u4e13\u7528\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 312,
    word: "finir",
    phonetic: "[finir]",
    type: "",
    translation: "v.t. \u5b8c\u6210\uff0c\u7ed3\u675f\uff1b\u8017\u5c3d\uff0c\u7528\u5c3d\uff0c\u5403\u5149\uff1bv.i. \u5b8c\u6bd5\uff0c\u7ed3\u675f a. \u7279\u522b\u7684\uff0c\u975e\u51e1\u7684\uff1b\u7834\u4f8b\u7684\uff1b\u5947\u7279\u7684\uff0c\u79bb\u5947\u7684\uff1b\u6770\u51fa",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 313,
    word: "extraordinaire",
    phonetic: "[\u03b5kstra\u0254rdin\u03b5r]",
    type: "",
    translation: "\u7684\uff1b\u5de8\u5927\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 314,
    word: "famille",
    phonetic: "[famij]",
    type: "",
    translation: "n.f. \u5bb6\u5ead\uff1b\u5bb6\u5c5e\uff1b\u4eb2\u5c5e\uff1b\u6d3e\uff0c\u5b66\u6d3e\uff1b\u7c7b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 315,
    word: "joie",
    phonetic: "[\u0292wa]",
    type: "",
    translation: "n.f. \u6b22\u4e50\uff0c\u5feb\u4e50\uff1b\u559c\u60a6\uff0c\u6109\u5feb\uff0c\u6ee1\u610f v.t. \u91cd\u83b7\uff0c\u91cd\u65b0\u627e\u5230\uff0c\u5931\u800c\u590d\u5f97\uff1b\u91cd\u65b0\u8d62\u5f97\uff0c\u518d\u535a\u5f97\uff1b\u8fd4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 316,
    word: "regagner",
    phonetic: "[r(\u0259)ga\u0272e]",
    type: "",
    translation: "\u56de\uff0c\u56de\u5230",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 317,
    word: "murmurer",
    phonetic: "[myrmyre]",
    type: "",
    translation: "v.i. \u4f4e\u8bed\uff0c\u7a83\u7a83\u8bae\u8bba\uff1b\u4f4e\u58f0\u62b1\u6028\uff1bv.t. \u4f4e\u58f0\u8bf4 a. \u5de6\u8fb9\u7684\uff0c\u5de6\u9762\u7684\uff0c\u5de6\u4fa7\u7684\uff0c\u5de6\u65b9\u7684\uff1b\u7b28\u62d9\u7684\uff0c\u4e0d\u81ea\u7136",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 318,
    word: "gauche",
    phonetic: "[go\u222b]",
    type: "",
    translation: "\u7684\uff1bn.f. \u5de6\uff0c\u5de6\u624b\uff0c\u5de6\u8fb9\uff0c\u5de6\u9762\uff1b[\u653f]\u5de6\u6d3e a. \u53d1\u75af\u7684\uff0c\u7cbe\u795e\u9519\u4e71\u7684\uff1b\u75af\u75af\u766b\u766b\u7684\uff1b\u75af\u72c2\u7684\uff1b\u5931\u53bb\u7406",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 319,
    word: "fou",
    phonetic: "[fu, f\u0254l]",
    type: "",
    translation: "\u667a\u7684\uff1b\u8fc7\u5206\u7684\uff0c\u8fc7\u591a\u7684\uff1bn. \u75af\u5b50\uff0c\u72c2\u4eba\uff1b\u75af\u75af\u766b\u766b\u7684\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 320,
    word: "conna\u00eetre",
    phonetic: "[k\u0254n\u03b5tr]",
    type: "",
    translation: "v.t. \u77e5\u9053\uff0c\u8ba4\u5f97\uff1b\u61c2\u5f97\uff0c\u719f\u6089\uff1b\u8ba4\u8bc6\uff1b\u4e86\u89e3\uff1b\u4f53\u9a8c\uff0c\u7ecf\u5386 v.t. \u5ef6\u8fdf\uff1b\u63a8\u8fdf\uff1b\u803d\u6401\uff0c\u803d\u8bef\uff1b\u5ef6\u7f13\uff1b\u628a\u8868\u3001\u949f\u62e8\u6162\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 321,
    word: "retarder",
    phonetic: "[r\u0259tarde]",
    type: "",
    translation: "v.i.\uff08\u949f\u8868\uff09\u8d70\u5f97\u6162\uff1b\u843d\u540e\uff0c\u8ddf\u4e0d\u4e0a\u65f6\u4ee3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 322,
    word: "t\u00eate",
    phonetic: "[t\u03b5t]",
    type: "",
    translation: "n.f. \u5934\uff1b\u8111\u888b\uff1b\u8138\uff1b\u9762\u5bb9\uff1b\u8868\u60c5\uff1b\u5934\u8111\uff1b\u9876\u7aef",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 323,
    word: "chercher",
    phonetic: "[\u222b\u03b5r\u222be]",
    type: "",
    translation: "v.t. \u5bfb\u627e\uff1b\u5bfb\u6c42\uff0c\u8c0b\u6c42\uff1b\u62db\u60f9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 324,
    word: "appartement",
    phonetic: "[apart\u0259m\u0251\u0303]",
    type: "",
    translation: "n.m. \u5957\u623f\uff0c\u6210\u5957\u623f\u95f4\uff0c\u5355\u5143\u623f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 325,
    word: "construction",
    phonetic: "[k\u0254\u0303stryksj\u0254\u0303]",
    type: "",
    translation: "n.f. \u5efa\u9020\uff0c\u5efa\u7b51\uff0c\u5efa\u8bbe\uff1b\u7ed3\u6784\uff0c\u6784\u9020\uff1b\u5efa\u7b51\u7269\uff1b\u5236\u9020\u4e1a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 326,
    word: "bagage",
    phonetic: "[baga\u0292]",
    type: "",
    translation: "n.m. \u884c\u674e\u7bb1\uff0c\u7bb1\u5305\uff1b\u884c\u674e\uff1b\u8863\u7269",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 327,
    word: "suffisant",
    phonetic: "[syfiz\u0251\u0303]",
    type: "",
    translation: "a. \u5145\u5206\u7684\uff0c\u5145\u8db3\u7684\uff0c\u8db3\u591f\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 328,
    word: "marin",
    phonetic: "[mar\u025b\u0303, -in]",
    type: "",
    translation: "n.m. \u6d77\u5458\uff0c\u6c34\u624b\uff1b\u822a\u6d77\u8005\uff1b\u822a\u884c\u8005",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 329,
    word: "dissimuler",
    phonetic: "[disimyle]",
    type: "",
    translation: "v.t.\uff0c v.pr. 1.\u63a9\u9970\uff0c\u9690\u7792\uff1b\u906e\u76d6\uff1b 2.\u88c5\u4f5c\u4e0d\u77e5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 330,
    word: "signaler",
    phonetic: "[si\u0272ale]",
    type: "",
    translation: "v.t.\uff08\u7528\u4fe1\u53f7\uff09\u6807\u660e\uff0c\u6307\u793a\uff1b\u4f7f\u6ce8\u610f\uff0c\u6307\u51fa\uff1b\u63ed\u53d1 a. \u81ea\u7136\uff08\u754c\uff09\u7684\uff1b\u5929\u7136\u7684\uff1b\u5929\u751f\u7684\uff1b\u6b63\u5e38\u7684\uff1b\u5408\u4e4e\u60c5\u7406",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 331,
    word: "naturel",
    phonetic: "[natyr\u03b5l]",
    type: "",
    translation: "\u7684 a. \u5b8c\u5168\u7684\uff0c\u5b8c\u6574\u7684\uff1b\u5168\u90e8\u7684\uff1b\u5168\u9762\u7684\uff1b\u5df2\u7ed3\u675f\u7684\uff0c\u5b8c\u6210",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 332,
    word: "complet",
    phonetic: "[k\u0254\u0303pl\u03b5, -t]",
    type: "",
    translation: "\u7684\uff1b\u6ee1\u6ee1\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 333,
    word: "commencer",
    phonetic: "[k\u0254m\u0251\u0303se]",
    type: "",
    translation: "v.t. \u7740\u624b\uff0c\u5f00\u59cb\uff1b\u5f00\u5934\uff0c\u8d77\u5934\uff1bv.i. \u5f00\u59cb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 334,
    word: "remercier",
    phonetic: "[r\u0259m\u03b5rsje]",
    type: "",
    translation: "v.t. \u611f\u8c22\uff0c\u8c22\u8c22\uff1b\u8f9e\u9000",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 335,
    word: "essayer",
    phonetic: "[ese(\u03b5)je]",
    type: "",
    translation: "v.t. \u8bd5\u9a8c\uff0c\u68c0\u9a8c\uff1b\u8bd5\u7a7f\uff1b\u8bd5\u7528 a. \u7c97\u58ee\u7684\uff1b\u80d6\u7684\uff1b\u539a\u7684\uff1b\u5927\u7684\uff1b\u91cd\u5927\u7684\uff1b\u4e25\u91cd\u7684\uff1bn.m.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 336,
    word: "gros",
    phonetic: "[gro, -s]",
    type: "",
    translation: "\u6279\u53d1 9 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. a. \u6b63\u4e49\u7684\uff0c\u516c\u9053\u7684\uff1b\u516c\u6b63\u7684\uff0c\u516c\u5e73\u7684\uff1b\u6b63\u786e\u7684\uff0c\u6b63\u5f53",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 337,
    word: "juste",
    phonetic: "[\u0292yst]",
    type: "",
    translation: "\u7684\uff1b\u51c6\u786e\u7684\uff0c\u7cbe\u786e\u7684\uff1b\u5408\u7406\u7684\uff1b\u51e0\u4e4e\u4e0d\u591f\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 338,
    word: "perdre",
    phonetic: "[p\u03b5rdr]",
    type: "",
    translation: "v.t. \u5931\u53bb\uff1b\u820d\u5f03\uff1b\u4e27\u5931\uff1b\u4e22\u5931\uff1b\u8f93\uff0c\u8d25 a. \u4f4e\u7684\uff0c\u77ee\u7684\uff1b\u4f4e\u5ec9\u7684\uff1b\u4f4e\u5fae\u7684\uff0c\u4e0b\u5c42\u7684\uff1bn.m. \u4e0b\u65b9\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 339,
    word: "bas",
    phonetic: "[b\u0251, -s]",
    type: "",
    translation: "\u4e0b\u90e8\uff0c\u4e0b\u7aef\uff1b\uff08\u5973\u5f0f\uff09\u957f\u7b52\u889c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 340,
    word: "gouvernement",
    phonetic: "[guv\u03b5rn\u0259m\u0251\u0303]",
    type: "",
    translation: "n.m. \u7edf\u6cbb\uff1b\u7ba1\u7406\uff0c\u6cbb\u7406\uff1b\u653f\u4f53\uff1b\u653f\u5e9c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 341,
    word: "britannique",
    phonetic: "[britanik]",
    type: "",
    translation: "adj.\uff0c n. 1.\u5927\u4e0d\u5217\u98a0\u7684\uff0c\u82f1\u56fd\u7684 2.\u82f1\u56fd\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 342,
    word: "immense",
    phonetic: "[im\u0251\u0303s]",
    type: "",
    translation: "a. \u65e0\u8fb9\u7684\uff0c\u65e0\u9650\u7684\uff0c\u5e7f\u5927\u7684\uff0c\u8fbd\u9614\u7684\uff1b\u5de8\u5927\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 343,
    word: "territoire",
    phonetic: "[t\u03b5ritwar]",
    type: "",
    translation: "n.m. \u9886\u571f\uff0c\u56fd\u571f\uff1b\u9886\u5730\uff0c\u5c5e\u5730\uff1b\u8f96\u533a\uff0c\u533a\u57df pr\u00e9p. \u81ea\u2026\u2026\u4ee5\u6765\uff0c\u4ece\u2026\u2026\u4ee5\u540e\uff1b\u4ece\u2026\u2026\uff0c\u81ea\u2026\u2026\uff1badv.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 344,
    word: "depuis",
    phonetic: "[d\u0259p\u0265i]",
    type: "",
    translation: "\u4ece\u6b64\u4ee5\u540e\uff0c\u6b64\u540e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 345,
    word: "fer",
    phonetic: "[f\u03b5r]",
    type: "",
    translation: "n.m. \u94c1\uff1b\u94c1\u5236\u5668\u5177 n.f. \u7ebf\uff1b\u754c\u7ebf\uff1b\u7ebf\u6761\uff1b\u8f6e\u5ed3\uff1b\u7ebf\u8def\uff0c\u822a\u7ebf\uff1b\uff08\u653f\u6cbb\u4e0a\u7684\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 346,
    word: "ligne",
    phonetic: "[li\u0272]",
    type: "",
    translation: "\u8def\u7ebf\uff1b\u7ec6\u7ef3 n.f. \u53f3\u9762\uff0c \u53f3\u8fb9\uff0c \u53f3\u65b9\uff1b\uff08\u9053\u8def\u7684\uff09\u53f3\u8fb9\uff1b[\u653f]\u53f3\u6d3e\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 347,
    word: "droite",
    phonetic: "[drwat]",
    type: "",
    translation: "\u53f3\u7ffc\uff1b \u53f3\u6d3e\u653f\u515a\uff1b\u53f3\u624b\uff1b[\u6570]\u76f4\u7ebf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 348,
    word: "vol",
    phonetic: "[v\u0254l]",
    type: "",
    translation: "n.m. \u98de\u7fd4\uff1b\u98de\u884c\uff1b\u76d7\u7a83\uff0c\u62a2\u52ab\uff1b\u8bc8\u9a97\uff1b\u5bb0\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 349,
    word: "voici",
    phonetic: "[vwasi]",
    type: "",
    translation: "pr\u00e9p.\uff0c adv. \u8fd9\u662f\uff0c\u8fd9\u5c31\u662f\uff1b\u4ee5\u4e0b\u5c31\u662f\uff0c\u4e0b\u9762\u5c31\u662f v.\u8df3\uff0c\u8df3\u8dc3\uff1b\u731b\u6251\uff0c\u6251\u4e0a\u53bb\uff1b\u8e66\u6389\uff0c\u98de\u6389\uff1b\u7206\u70b8\uff0c\u70b8\u6bc1\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 350,
    word: "sauter",
    phonetic: "[sote]",
    type: "",
    translation: "\u8df3\u8fc7\uff0c \u8df3\u8d8a n.m. \u6c34\u9053\uff1b\u6d41\u52a8\uff1b\u79fb\u52a8\uff0c\u8fd0\u884c\uff1b\u8fdb\u5c55\uff0c\u8fc7\u7a0b\uff0c\u671f\u95f4\uff1b\u8bfe",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 351,
    word: "cours",
    phonetic: "[kur]",
    type: "",
    translation: "\u7a0b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 352,
    word: "ind\u00e9pendant",
    phonetic: "[\u025b\u0303dep\u0251\u0303d\u0251\u0303]",
    type: "",
    translation: "a. \u72ec\u7acb\u7684\uff1b\u81ea\u4e3b\u7684\uff1b\u4e0d\u53d7\u675f\u7f1a\u7684\uff1b\u4e0d\u76f8\u5173\u8054\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 353,
    word: "bureau",
    phonetic: "[byro]",
    type: "",
    translation: "n.m. \u529e\u516c\u684c\uff1b\u4e66\u623f\uff1b\u529e\u516c\u5ba4\uff1b\u5c40\uff0c\u7f72\uff0c\u6240\uff0c\u5904",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 354,
    word: "port",
    phonetic: "[p\u0254r]",
    type: "",
    translation: "n.m. \u6e2f\uff0c\u6e2f\u53e3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 355,
    word: "ainsi",
    phonetic: "[\u025b\u0303si]",
    type: "",
    translation: "adv. 1.\u8fd9\u6837\uff0c\u5982\u6b64\uff1b\u540c\u6837\uff0c\u4e00\u6837\uff1b 2.\u7531\u6b64\uff0c\u56e0\u6b64 a. \u5f3a\u58ee\u7684\uff0c\u529b\u6c14\u5927\u7684\uff1b\u80d6\uff0c\u80a5\uff0c\u7c97\uff1b\u80fd\u5e72\u7684\uff1b\u5f3a\u5927\u7684\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 356,
    word: "fort",
    phonetic: "[f\u0254:r]",
    type: "",
    translation: "\u575a\u5f3a\u7684\uff1b\u5f3a\u70c8\u7684\uff1b\u6d53\u70c8\u7684\uff1b\u575a\u56fa\u7684\uff1bn.m. \u9632\u5fa1\u5de5\u4e8b\uff0c\u5821 \u5792\uff0c\u8981\u585e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 357,
    word: "splendide",
    phonetic: "[spl\u0251\u0303did]",
    type: "",
    translation: "a. \u58ee\u4e3d\u7684\uff0c\u5bcc\u4e3d\u5802\u7687\u7684\uff1b\u707f\u70c2\u7684\uff1b\u8f89\u714c\u7684 v.t. \u6b20\uff1b\u5e94\u8be5\uff1b\u5e94\u5f52\u529f\u4e8e\uff1b\u53ef\u80fd\u4f1a\uff1bn.m. \u8d23\u4efb\uff0c\u4e49\u52a1\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 358,
    word: "devoir",
    phonetic: "[d\u0259vwar]",
    type: "",
    translation: "\u4f5c\u4e1a v.i.\uff08\u949f\u3001\u94c3\u3001\u5587\u53ed\u7b49\uff09\u54cd\uff0c\u9e23\uff1b\u6309\u94c3\uff1bv.t. \u6572\u54cd\uff1b\u6253\u94c3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 359,
    word: "sonner",
    phonetic: "[s\u0254ne]",
    type: "",
    translation: "\u547c\u5524",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 360,
    word: "froidement",
    phonetic: "[frwadm\u0251\u0303]",
    type: "",
    translation: "adv. \u51b7\u6de1\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 361,
    word: "ceci",
    phonetic: "[s\u0259si]",
    type: "",
    translation: "pron.d\u00e9m. \u8fd9\uff0c \u8fd9\u4e2a\uff1b \u8fd9\u4e8b v.i. \u8dd1\uff1b\u8d5b\u8dd1\uff1b\u8d5b\u8f66\uff1b\u8d5b\u9a6c\uff1b\uff08\u65f6\u95f4\uff09\u6d41\u901d\uff1bv.t. \u8c0b\u53d6\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 362,
    word: "courir",
    phonetic: "[kurir]",
    type: "",
    translation: "\u8ffd\u6c42\uff1b\u8dd1\u904d\uff0c\u5728\u2026\u2026\u5954\u8dd1 n.f. \u4f7f\u547d\uff0c\u4efb\u52a1\uff1b\u5929\u804c\uff1b\u4ee3\u8868\u56e2\uff0c\u4f7f\u56e2\uff0c\u8003\u5bdf\u56e2\uff1b[\u5b97]\u5e03",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 363,
    word: "mission",
    phonetic: "[misj\u0254\u0303]",
    type: "",
    translation: "\u9053\uff0c\u4f20\u6559",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 364,
    word: "obtenir",
    phonetic: "[\u0254pt\u0259nir]",
    type: "",
    translation: "v.t. \u83b7\u5f97\uff0c\u53d6\u5f97\uff0c\u5f97\u5230",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 365,
    word: "parfaitement",
    phonetic: "[parf\u03b5tm\u0251\u0303]",
    type: "",
    translation: "adv. \u5b8c\u7f8e\u5730\uff0c\u6781\u597d\u5730\uff1b\u5b8c\u5168\u5730\uff0c\u5341\u5206\u5730\uff0c\u975e\u5e38\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 366,
    word: "libert\u00e9",
    phonetic: "[lib\u03b5rte]",
    type: "",
    translation: "n.f. \u81ea\u7531\uff0c\u81ea\u7531\u6743\uff1b\u72ec\u7acb\u81ea\u4e3b\uff0c\u65e0\u7ea6\u675f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 367,
    word: "admettre",
    phonetic: "[adm\u03b5tr]",
    type: "",
    translation: "v.t. \u63a5\u7eb3\uff0c\u63a5\u53d7\uff1b\u5f55\u53d6\uff1b\u627f\u8ba4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 368,
    word: "vue",
    phonetic: "[vy]",
    type: "",
    translation: "n.f. \u89c6\u89c9\uff1b\u89c6\u529b\uff1b\u770b\uff0c\u770b\u89c1\uff1b\u89c6\u91ce\uff1b\u666f\u8272\uff1b\u89c2\u70b9\uff0c\u770b\u6cd5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 369,
    word: "accomplir",
    phonetic: "[ak\u0254\u0303plir]",
    type: "",
    translation: "v.t. \u5b8c\u6210\uff0c\u5b9e\u73b0\uff1b\u5c65\u884c\uff0c\u6267\u884c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 370,
    word: "chemise",
    phonetic: "[\u222b(\u0259)miz]",
    type: "",
    translation: "n.f. \u7537\u5f0f\u886c\u886b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 371,
    word: "rond",
    phonetic: "[r\u0254\u0303, -d]",
    type: "",
    translation: "a. \u5706\u7684\uff1b\u77ee\u80d6\u7684\uff1b\u5706\u80d6\u7684\uff0c\u4e30\u6ee1\u7684\uff1b\u559d\u9189\u9152\u7684 10 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 372,
    word: "figurer",
    phonetic: "[figyre]",
    type: "",
    translation: "v.t. \u7528\u5f62\u8c61\u8868\u73b0\uff0c\u753b\u51fa\uff0c\u5851\u9020\uff1b\u8c61\u5f81\uff1b\u50cf\uff1b\u8868\u793a\uff0c\u4ee3\u8868",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 373,
    word: "bruit",
    phonetic: "[br\u0265i]",
    type: "",
    translation: "n.m. \u58f0\u97f3\uff0c\u566a\u58f0\uff0c\u5608\u6742\u58f0\uff1b\u6d88\u606f\uff0c\u98ce\u58f0\uff0c\u4f20\u95fb a. \u597d\u5947\u7684\uff1b\u7231\u6253\u542c\u7684\uff1b\u7a00\u5947\u7684\uff0c\u5947\u7279\u7684\uff0c\u53e4\u602a\u7684\uff1bn. \u597d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 374,
    word: "curieux",
    phonetic: "[kyrj\u00f8, -z]",
    type: "",
    translation: "\u5947\u7684\u4eba\uff0c\u597d\u5b66\u7684\u4eba\uff1b\u7231\u6253\u542c\u7684\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 375,
    word: "oreille",
    phonetic: "[\u0254r\u03b5j]",
    type: "",
    translation: "n.f. \u8033\uff1b\u542c\u89c9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 376,
    word: "devant",
    phonetic: "[d(\u0259)v\u0251\u0303]",
    type: "",
    translation: "pr\u00e9p. \u5728\u2026\u2026\u524d\u9762\uff0c\u5f53\u2026\u2026\u9762\uff1badv. \u5728\u524d\u9762",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 377,
    word: "ensuite",
    phonetic: "[\u0251\u0303s\u0265it]",
    type: "",
    translation: "adv. \u7136\u540e\uff0c\u540e\u6765\uff1b\u968f\u540e\uff0c\u63a5\u7740 v.t. \u7a7f\u5165\uff0c\u6e17\u5165\uff0c\u8fdb\u5165\uff1b\u770b\u900f\uff0c\u8bc6\u7834\uff1b\u6253\u8fdb\uff0c\u6253\u5165\uff1bv.i.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 378,
    word: "p\u00e9n\u00e9trer",
    phonetic: "[penetre]",
    type: "",
    translation: "\u8fdb\u5165\uff0c\u5165\u5185",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 379,
    word: "remarquer",
    phonetic: "[r\u0259marke]",
    type: "",
    translation: "v.t. \u6ce8\u610f\uff0c\u5bdf\u89c9\uff1b\u8fa8\u522b\uff0c\u8ba4\u51fa n.m. \u574f\uff0c\u7cdf\uff1b\u6076\uff1b\u635f\u5bb3\uff0c\u7978\u5bb3\uff1b\u75bc\u75db\uff1b\u4e0d\u9002\uff1b\u75be\u75c5\uff1b\u56f0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 380,
    word: "mal",
    phonetic: "[mal]",
    type: "",
    translation: "\u96be\uff1b\u574f\u8bdd\uff0c\u574f\u5904\uff1badv. \u574f\uff0c\u7cdf\uff0c\u4e0d\u597d\uff0c\u6076\u52a3\u5730 v.t. \u5207\uff0c\u5272\uff0c\u780d\uff0c\u526a\uff1b\u5220\u8282\uff08\u6587\u5b57\uff09\uff1b\u526a\u8f91\uff08\u5f71\u7247\uff09\uff1b\u6253",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 381,
    word: "couper",
    phonetic: "[kupe]",
    type: "",
    translation: "\u65ad\uff1b\u4e2d\u6b62\uff1b\u6a2a\u7a7f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 382,
    word: "salon",
    phonetic: "[sal\u0254\u0303]",
    type: "",
    translation: "n.m. \u5ba2\u5385\uff1b\u4e0a\u6d41\u793e\u4f1a\uff1b[\u6587]\u6c99\u9f99",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 383,
    word: "ranger",
    phonetic: "[r\u0251\u0303\u0292e]",
    type: "",
    translation: "v.t. \u4f7f\u6392\u6210\u884c\uff1b\u6392\u5217\uff1b\u6574\u7406\uff1b\u628a\u2026\u2026\u5217\u5165\uff0c\u628a\u2026\u2026\u5f52\u7c7b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 384,
    word: "court",
    phonetic: "[kur]",
    type: "",
    translation: "a. \u77ed\u7684\uff0c\u77ed\u5c0f\u7684\uff1b\u77ed\u4fc3\u7684\uff0c\u77ed\u6682\u7684\uff0c\u7b80\u77ed\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 385,
    word: "paroi",
    phonetic: "[parwa]",
    type: "",
    translation: "n.f. 1. \u9694\u5899\uff0c\u9694\u677f\uff1b 2.\u5185\u58c1\uff1b\u5ca9\u58c1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 386,
    word: "pr\u00eatre",
    phonetic: "[pr\u03b5tr]",
    type: "",
    translation: "n.m. \u796d\u53f8\uff1b\u7267\u5e08\uff1b\u795e\u752b\uff1b\u65b9\u4e08",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 387,
    word: "soulier",
    phonetic: "[sulje]",
    type: "",
    translation: "n.m. \u978b\uff1b \u76ae\u978b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 388,
    word: "cri",
    phonetic: "[kri]",
    type: "",
    translation: "n.m. \u53eb\u558a\u58f0\uff0c\u55a7\u54d7\u58f0 v.t. \u4f7f\u91cd\u65b0\u7ad9\u8d77\uff0c\u6276\u8d77\uff1b\u91cd\u5efa\uff0c\u4fee\u590d\uff1b\u6062\u590d\uff1b\u62ac\u8d77\uff1b\u64a9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 389,
    word: "relever",
    phonetic: "[r\u0259lve]",
    type: "",
    translation: "\u8d77\uff1b\u5347\u9ad8\uff0c\u63d0\u9ad8\uff1b\u8bb0\u4e0b\uff0c\u6284\u5f55\uff1b\u63a5\u66ff",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 390,
    word: "jambe",
    phonetic: "[\u0292\u0251\u0303b]",
    type: "",
    translation: "n.f. \u5c0f\u817f\uff1b\u4e0b\u80a2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 391,
    word: "bient\u00f4t",
    phonetic: "[bj\u025b\u0303to]",
    type: "",
    translation: "adv. \u9a6c\u4e0a\uff0c\u4e0d\u4e45\uff1b\u5f88\u5feb\uff1b\u4e00\u4f1a\u513f\u5de5\u592b\uff0c\u5728\u5f88\u77ed\u7684\u65f6\u95f4\u5185 n.m. \u51fa\u53d1\uff1b\u79bb\u5f00\uff1b\u8d77\u98de\uff1b\u542f\u822a\uff1b\u5f00\u7aef\uff0c\u5f00\u59cb\uff1b\u51fa\u53d1\u70b9\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 392,
    word: "d\u00e9part",
    phonetic: "[depar]",
    type: "",
    translation: "\u8d77\u70b9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 393,
    word: "chapeau",
    phonetic: "[\u222bapo]",
    type: "",
    translation: "n.m. \u5e3d\u5b50\uff1b[\u673a]\u5e3d\uff0c\u76d6\uff0c\u7f69\u5b50",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 394,
    word: "paquet",
    phonetic: "[pak\u03b5]",
    type: "",
    translation: "n.m. \u5305\uff0c\u675f\uff0c\u6346\uff1b\u5305\u88f9\uff0c\u76d2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 395,
    word: "quai",
    phonetic: "[k\u03b5]",
    type: "",
    translation: "ou [ke] n.m. \u7ad9\u53f0\uff0c\u6708\u53f0\uff1b\u7801\u5934\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 396,
    word: "pauvre",
    phonetic: "[povr]",
    type: "",
    translation: "a. \u8d2b\u7a77\u7684\uff1b\u53ef\u601c\u7684\uff1b\u8d2b\u4e4f\u7684\uff1b\u8d2b\u7620\u7684\uff1bn. \u7a77\u4eba\uff0c\u8d2b\u6c11",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 397,
    word: "dispara\u00eetre",
    phonetic: "[dispar\u03b5tr]",
    type: "",
    translation: "v.i. \u6d88\u5931\uff1b\u6d88\u6563\uff1b\u6d88\u901d\uff1b\u5931\u8e2a\uff1b\u6e9c\u8d70\uff1b\u9057\u5931\uff1b\u88ab\u76d7\uff1b\u6b7b\u4ea1 n\u00e0 xi\u0113 (\u5f62) ces (\u4ee3) les; ceux (celles) -l\u00e0; celui, 399 ceux celle, ceux, celles",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 398,
    word: "traverser",
    phonetic: "[trav\u03b5rse]",
    type: "",
    translation: "v.t.\uff08\u6a2a\uff09\u7a7f\u8fc7\uff0c\u7ecf\u8fc7\uff0c\u6a2a\u6e21\uff1b\u7a7f\u900f\uff0c\u6e17\u900f\uff1b\u7ecf\u53d7\uff0c\u7ecf\u5386",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 399,
    word: "lendemain",
    phonetic: "[l\u0251\u0303dm\u025b\u0303]",
    type: "",
    translation: "n.m. \u6b21\u65e5\uff0c\u7fcc\u65e5\uff1b\u672a\u6765\uff0c\u5c06\u6765 v.t. \u5141\u8bb8\uff0c\u5141\u8bfa\uff0c\u7b54\u5e94\uff1b\u4fdd\u8bc1\uff1b\u9884\u793a\uff0c\u7ed9\u4eba\u2026\u2026\u7684\u6307\u671b\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 400,
    word: "promettre",
    phonetic: "[pr\u0254m\u03b5tr]",
    type: "",
    translation: "\u6709\u2026\u2026\u7684\u53ef\u80fd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 401,
    word: "charmant",
    phonetic: "[\u222barm\u0251\u0303, -t]",
    type: "",
    translation: "a. \u8ff7\u4eba\u7684\uff0c\u5bcc\u4e8e\u8bf1\u60d1\u529b\u7684\uff1b\u53ef\u7231\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 402,
    word: "m\u00e9tier",
    phonetic: "[metje]",
    type: "",
    translation: "n.m. \u804c\u4e1a\uff1b\u6280\u80fd\uff1b\u884c\u4e1a\uff1b\u624b\u827a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 403,
    word: "aile",
    phonetic: "[\u03b5l]",
    type: "",
    translation: "n.f. \u7ffc\uff0c\u7fc5\u8180\uff1b\u673a\u7ffc\uff1b\u4fa7\u7ffc v.t. \u7a0d\u7a0d\u63d0\u8d77\uff0c\u7565\u5fae\u62ac\u8d77\uff1b\u6fc0\u8d77\uff0c\u5f15\u8d77\uff1b\u717d\u8d77\u66b4\u52a8\uff0c\u53d1\u52a8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 404,
    word: "soulever",
    phonetic: "[sulve]",
    type: "",
    translation: "\u9020\u53cd\uff1b\u6fc0\u6012",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 405,
    word: "nuage",
    phonetic: "[n\u0265a\u0292]",
    type: "",
    translation: "n.m. \u4e91\uff1b\u4e91\u72b6\u7269",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 406,
    word: "globe",
    phonetic: "[gl\u0254b]",
    type: "",
    translation: "n.m. \u7403\uff0c\u7403\u4f53\uff1b\u5730\u7403\uff1b\u4e16\u754c adv. \u540c\u6837\uff0c\u4e00\u6837\u591a\uff1b ...\u4e5f\u4e00\u6837\uff0c ...\u4e5f\u597d\uff0c \u8fd8\u662f...\u4e3a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 407,
    word: "autant",
    phonetic: "[ot\u0251\u0303]",
    type: "",
    translation: "\u597d\uff0c \u7b49\u4e8e\u662f\uff1b\u540c...\u4e00\u6837\u591a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 408,
    word: "gagner",
    phonetic: "[ga\u0272e]",
    type: "",
    translation: "v.t. \u8d5a\u5f97\uff1b\u8d62\uff1b\u83b7\u5f97\uff1b\u5230\u8fbe\uff1b\u8513\u5ef6\u5230\uff1b\u8282\u7701 11 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 409,
    word: "faute",
    phonetic: "[fot]",
    type: "",
    translation: "n.f. \u9519\u8bef\uff1b\u8fc7\u5931\uff0c\u8fc7\u9519\uff1b\u5dee\u9519\uff1b\u8fdd\u7ae0\uff1b\u72af\u89c4\uff1b\u5931\u8bef",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 410,
    word: "aider",
    phonetic: "[ede]",
    type: "",
    translation: "ou [\u025bde] v.t. \u5e2e\u52a9\uff0c\u63f4\u52a9\uff1b\u8865\u52a9\uff0c\u652f\u63f4\uff1b\u6551\u52a9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 411,
    word: "seul",
    phonetic: "[s\u0153l]",
    type: "",
    translation: "a. \u5b64\u72ec\u7684\uff0c\u5b64\u5355\u7684\uff1b\u60df\u4e00\u7684\uff1b\u53ea\u6709\uff0c\u4ec5\u4ec5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 412,
    word: "regarder",
    phonetic: "[r\u0259garde]",
    type: "",
    translation: "v.t. \u770b\uff1b\u6ce8\u89c6\uff1b\u5173\u5fc3\uff1b\u6d89\u53ca\uff0c\u548c\u2026\u2026\u6709\u5173\uff1b\u5bdf\u770b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 413,
    word: "refuser",
    phonetic: "[r\u0259fyze]",
    type: "",
    translation: "v.t. \u62d2\u7edd\uff1b\u62d2\u7edd\u7ed9\u4e88\uff1b\u62d2\u7edd\u63a5\u53d7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 414,
    word: "vouloir",
    phonetic: "[vulwar]",
    type: "",
    translation: "v.t. \u613f\u610f\uff0c\u5e0c\u671b\uff1b\u60f3\u8981\uff1b\u9700\u8981\uff1b\u8981\u4ef7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 415,
    word: "arriv\u00e9",
    phonetic: "[arive]",
    type: "",
    translation: "adj. \u5230\u8fbe\uff0c\u6765\u5230\uff1b\u8fdb\u53e3\uff1b\u5230\u8fbe\u5730\uff0c\u7ec8\u70b9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 416,
    word: "partir",
    phonetic: "[partir]",
    type: "",
    translation: "v.i. \u51fa\u53d1\uff0c\u79bb\u53bb\uff0c\u52a8\u8eab\uff1b\u8d77\u8dd1\uff1b\u542f\u52a8\uff0c\u53d1\u52a8 v.i. \u6d3b\u7740\uff1b\u751f\u5b58\uff1b\u5c45\u4f4f\u5728\uff0c\u751f\u6d3b\u5728\uff1b\u8fc7\u2026\u2026\u751f\u6d3b\uff1b\u751f\u6d3b\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 417,
    word: "vivre",
    phonetic: "[vivr]",
    type: "",
    translation: "\u5904\u4e16\uff0c\u505a\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 418,
    word: "flanc",
    phonetic: "[fl\u0251\u0303]",
    type: "",
    translation: "n.m. \u808b\u90e8[\u6307\u4eba\u6216\u52a8\u7269]\uff1b\u6bcd\u80ce\uff0c\u6bcd\u8179\uff1b\u4fa7\uff0c\u4fa7\u9762\uff0c\u65c1\u4fa7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 419,
    word: "affirmer",
    phonetic: "[afirme]",
    type: "",
    translation: "v.t. \u65ad\u8a00\uff0c\u80af\u5b9a\uff1b\u8bc1\u660e\uff0c\u786e\u8ba4\uff1b\u663e\u793a\uff0c\u8868\u660e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 420,
    word: "entier",
    phonetic: "[\u0251\u0303tje, -\u03b5r]",
    type: "",
    translation: "a. \u6574\u4e2a\u7684\uff0c\u5168\u90e8\u7684\uff1b\u5b8c\u6574\u7684\uff1b\u5b8c\u5168\u7684\uff1b\u7edd\u5bf9\u7684\uff1b\u65e0\u635f\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 421,
    word: "situation",
    phonetic: "[sit\u0265asj\u0254\u0303]",
    type: "",
    translation: "n.f. \u72b6\u51b5\uff0c\u5f62\u52bf\uff1b\u5730\u70b9\uff0c\u4f4d\u7f6e\uff1b\u804c\u4f4d\uff1b\u5730\u4f4d\uff1b\u5904\u5883\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 422,
    word: "qualit\u00e9",
    phonetic: "[kalite]",
    type: "",
    translation: "n.f. \u8d28\u91cf\uff1b\u6027\u8d28\uff1b\u4f18\u8d28\uff1b\u4f18\u826f\u54c1\u8d28\uff1b\u4f18\u70b9\uff1b\u8eab\u4efd\uff0c\u8d44\u683c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 423,
    word: "agent",
    phonetic: "[a\u0292\u0251\u0303]",
    type: "",
    translation: "n.m. \u4ee3\u7406\u4eba\uff0c\u7ecf\u7eaa\u4eba\uff1b\u8b66\u5bdf\uff0c\u8b66\u63a2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 424,
    word: "continuer",
    phonetic: "[k\u0254\u0303tin\u0265e]",
    type: "",
    translation: "v.t. \u7ee7\u7eed",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 425,
    word: "fait",
    phonetic: "[f\u03b5]",
    type: "",
    translation: "n.m. \u884c\u4e3a\uff0c\u884c\u52a8\uff1b\u4e8b\u4ef6\uff0c\u53d1\u751f\u7684\u4e8b\u60c5\uff1b\u4e8b\u5b9e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 426,
    word: "observation",
    phonetic: "[\u0254ps\u03b5rvasj\u0254\u0303]",
    type: "",
    translation: "n.f. \u89c2\u5bdf\uff0c\u89c2\u6d4b\uff1b\u76d1\u89c6\uff1b\u8bc4\u8bba\uff1b\u9075\u5b88\uff0c\u5949\u884c pr\u00e9p. \u4e3a\u4e86\uff1b\u5bf9\u4e8e\uff1b\u9002\u5408\u4e8e\uff1b\u5411\uff0c\u5f80\uff1b\u5728\u2026\u2026\u65f6\u95f4\u5185\uff1b\u7531",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 427,
    word: "pour",
    phonetic: "[pur]",
    type: "",
    translation: "\u4e8e\uff1b\u4f9d\u2026\u2026\u770b\u6765\uff1b\u81f3\u4e8e\uff1b\u6362\uff0c\u6bd4\uff1b\u4ee3\uff0c\u66ff",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 428,
    word: "temps",
    phonetic: "[t\u0251\u0303]",
    type: "",
    translation: "n.m. \u65f6\u95f4\uff1b\u9636\u6bb5\uff1b\u65f6\u4ee3\uff0c\u65f6\u671f\uff1b\u65f6\u5019\uff1b[\u8bed]\u65f6\u6001\uff1b\u5929\u6c14",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 429,
    word: "animal",
    phonetic: "[animal]",
    type: "",
    translation: "n.m. \u52a8\u7269\uff1b\u8822\u8d27\uff0c\u755c\u751f\uff1ba. \u52a8\u7269\u7684\uff1b\u517d\u6027\u7684 v.t. \u518d\u62ff\uff0c\u518d\u53d6\uff1b\u62ff\u56de\uff1b\u6536\u56de\uff1b\u6062\u590d\uff1b\u593a\u56de\uff0c\u6536\u590d\uff1b\u91cd\u65b0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 430,
    word: "reprendre",
    phonetic: "[r(\u0259)pr\u0251\u0303dr]",
    type: "",
    translation: "\u5f00\u59cb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 431,
    word: "saluer",
    phonetic: "[sal\u0265e]",
    type: "",
    translation: "v.t. \u62db\u547c\uff0c\u5411\u2026\u2026\u81f4\u610f\uff1b\u5411\u2026\u2026\u656c\u793c\uff1b\u8fce\u63a5\uff1b\u6b22\u547c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 432,
    word: "jean",
    phonetic: "[d\u0292in]",
    type: "",
    translation: "n.m. \u7c97\u659c\u7eb9\u68c9\u5e03\uff0c\u725b\u4ed4\u5e03\uff1b\u725b\u4ed4\u88e4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 433,
    word: "go\u00fbter",
    phonetic: "[gute]",
    type: "",
    translation: "v.t. \u5c1d\uff0c\u54c1\u5c1d\u5473\u9053\uff1b\u6b23\u8d4f\uff1b\u611f\u53d7\u5230\uff0c\u4f53\u5473\u5230",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 434,
    word: "vivant",
    phonetic: "[viv\u0251\u0303, -t]",
    type: "",
    translation: "a. \u6d3b\u7684\uff0c\u6d3b\u7740\u7684\uff1b\u6709\u751f\u547d\u7684\uff1b\u6d3b\u6cfc\u7684\uff1b\u751f\u52a8\u7684\uff0c\u903c\u771f\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 435,
    word: "justement",
    phonetic: "[\u0292yst\u0259m\u0251\u0303]",
    type: "",
    translation: "adv. \u6b63\u786e\u5730\uff0c\u786e\u5207\u5730\uff0c\u6070\u5f53\u5730\uff1b\u6b63\u597d\uff0c\u6070\u597d v.t. \u7ed1\uff0c\u7f1a\uff0c\u56fa\u5b9a\uff1b\u7cfb\uff0c\u6263\uff1b\u4f7f\u7cfb\u4e8e\uff0c\u4f7f\u7ed3\u5408\uff1b\u7ed9\u4e88\uff0c\u8d4b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 436,
    word: "attacher",
    phonetic: "[ata\u222be]",
    type: "",
    translation: "\u4e88",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 437,
    word: "vous",
    phonetic: "[vu]",
    type: "",
    translation: "pron.pers. \u60a8\uff0c\u4f60\uff1b\u4f60\u4eec",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 438,
    word: "oui",
    phonetic: "[wi]",
    type: "",
    translation: "adv. \u662f\uff0c\u662f\u7684\uff0c\u5bf9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 439,
    word: "sauce",
    phonetic: "[sos]",
    type: "",
    translation: "n.f. \u8c03\u5473\u6c41\uff0c\u9171\u6cb9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 440,
    word: "accepter",
    phonetic: "[aks\u03b5pte]",
    type: "",
    translation: "v.t. \u63a5\u53d7\uff0c\u9886\u53d7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 441,
    word: "croire",
    phonetic: "[krwar]",
    type: "",
    translation: "v.t. \u76f8\u4fe1\uff1b\u4fe1\u4efb\uff1b\u8ba4\u4e3a\uff1b\u89c9\u5f97",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 442,
    word: "autre",
    phonetic: "[otr]",
    type: "",
    translation: "a. \u522b\u7684\uff0c\u53e6\u5916\u7684\uff1b\u4e0d\u540c\u7684\uff0c\u4e0d\u4e00\u6837\u7684\uff1b\u7b2c\u4e8c\u4e2a\uff0c\u53e6\u4e00\u4e2a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 443,
    word: "entre",
    phonetic: "[\u0251\u0303tr]",
    type: "",
    translation: "pr\u00e9p. \u5728\u2026\u2026\u4e4b\u95f4\uff1b\u5728\u2026\u2026\u4e2d\u95f4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 444,
    word: "d\u00eener",
    phonetic: "[dine]",
    type: "",
    translation: "v.i. \u5403\u665a\u996d\uff1bn.m. \u665a\u996d\uff0c\u665a\u9910\uff1b\u665a\u9910\u83dc\u80b4 v.t. \u4e3a\u2026\u2026\u670d\u52a1\uff0c\u4e3a\u2026\u2026\u6548\u529b\uff1b\u670d\u4f8d\uff1b\u4f3a\u5019\u5403\u996d\uff1b\u63a5\u5f85\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 445,
    word: "servir",
    phonetic: "[s\u03b5rvir]",
    type: "",
    translation: "\u7aef\u4e0a\uff08\u996d\u83dc\uff09\uff0c\u4f9b\u5e94",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 446,
    word: "rendre",
    phonetic: "[r\u0251\u0303dr]",
    type: "",
    translation: "v.t. \u5f52\u8fd8\uff1b\u9000\u8fd8\uff1b\u4f7f\u6062\u590d\uff1b\u56de\u62a5\uff1b\u4f5c\u51fa\uff1b\u51fa\u4ea7\uff1b\u4f7f\u53d8\u4e3a v.i. \u51fa\u53bb\uff1b\u9732\u51fa\uff1b\u6563\u53d1\u51fa\uff1b\u6d41\u51fa\uff1b\u51fa\u7248\uff1b\u4e0a\u6620\uff1bv.t. \u62ff",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 447,
    word: "sortir",
    phonetic: "[s\u0254rtir]",
    type: "",
    translation: "\u51fa\uff1b\u4f7f\u6446\u8131\uff1b\u5e26\u2026\u2026\u5916\u51fa\uff1b\u51fa\u7248\uff0c\u53d1\u8868",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 448,
    word: "rassurer",
    phonetic: "[rasyre]",
    type: "",
    translation: "v.t. \u4f7f\u5b89\u5fc3\uff0c\u4f7f\u653e\u5fc3 12 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 449,
    word: "cacher",
    phonetic: "[ka\u222be]",
    type: "",
    translation: "v.t. \u85cf\uff0c\u85cf\u533f\uff1b\u63a9\u9970\uff0c\u63a9\u76d6\uff0c\u9690\u7792\uff1b\u906e\u76d6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 450,
    word: "cou",
    phonetic: "[ku]",
    type: "",
    translation: "n.m. \u9888\uff0c\u8116\u5b50",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 451,
    word: "rapprocher",
    phonetic: "[rapr\u0254\u222be]",
    type: "",
    translation: "v.t. \u4f7f\u66f4\u9760\u8fd1\uff0c\u4f7f\u66f4\u63a5\u8fd1\uff1b\u4f7f\u4e34\u8fd1\uff1b\u4f7f\u4eb2\u5bc6 v.i. \u5269\u4e0b\uff0c\u7559\u4e0b\uff0c\u505c\u7559\uff1b\u9017\u7559\uff1b\u7559\u5728\u67d0\u5904\u4e0d\u52a8\uff1b\u4fdd\u6301\uff0c\u5904",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 452,
    word: "rester",
    phonetic: "[r\u03b5ste]",
    type: "",
    translation: "\u4e8e\uff08\u67d0\u79cd\u72b6\u6001\uff09 n.m. \u5468\u56f4\uff0c\u5468\u957f\uff1b\u73af\u7ed5\uff0c\u73af\u884c\uff1b\u6563\u6b65\uff1b\u8f6c\u52a8\uff0c\u65cb\u8f6c\uff1b\u65cb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 453,
    word: "tour",
    phonetic: "[tur]",
    type: "",
    translation: "\u8f6c\u7684\u4e00\u5468\uff0c\u4e00\u5708\uff1b\u5de7\u5999\u7684\u52a8\u4f5c\uff0c\u6280\u827a\uff1b\u8be1\u8ba1\uff0c\u82b1\u62db\uff1b\u8f6e \u73ed\uff0c\u8f6e\u503c\uff1bn.f. \u5854\uff0c\u697c\uff1b\u57ce\u697c\uff0c\u70ae\u697c a. \u58ee\u4e3d\u7684\uff0c\u5b8f\u4f1f\u7684\uff1b\u8c6a\u534e\u7684\uff1b\u6781\u7f8e\u7684\uff1b\u6781\u597d\u7684\uff1b\u5f88\u51fa\u8272",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 454,
    word: "magnifique",
    phonetic: "[ma\u0272ifik]",
    type: "",
    translation: "\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 455,
    word: "h\u00f4tel",
    phonetic: "[ot\u03b5l]",
    type: "",
    translation: "n.m. \u65c5\u9986\uff0c\u5bbe\u9986\uff1b\u529e\u516c\u5927\u697c v.t. \u770b\u89c1\uff1b\u89c2\u770b\uff1b\u53c2\u89c2\uff1b\u7ecf\u5386\uff1b\u78b0\u89c1\uff1b\u4f1a\u89c1\uff1b\u770b\u671b\uff1b\u7ec6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 456,
    word: "voir",
    phonetic: "[vwar]",
    type: "",
    translation: "\u770b\uff1b\u67e5\u9605\uff1b\u67e5\u770b\uff1b\u8003\u8651\uff0c\u601d\u8003\uff1b\u7406\u89e3\uff0c\u61c2\u5f97\uff0c\u660e\u767d v.i. \u7ecf\u8fc7\uff1b\u901a\u8fc7\uff1b\u5230\u2026\u2026\u53bb\uff1b\u8f6c\u5165\uff1b\u4f20\u5165\uff0c\u4f20\u9001\uff1b\u6d41\u901d\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 457,
    word: "passer",
    phonetic: "[pase]",
    type: "",
    translation: "\u653e\u6620\uff0c\u4e0a\u6620\uff1bv.t. \u7a7f\u8fc7\uff0c\u901a\u8fc7\uff1b\u8d85\u51fa\uff0c\u8d85\u8d8a\uff1b\u5ea6\u8fc7\uff1b\u8df3 \u8fc7\uff0c\u9057\u6f0f\uff1b\u4f20\u9012\uff1b\u4f20\u67d3\uff1b\u653e\u6620 conj. \u597d\u50cf\uff0c\u5982\u540c\uff0c\u72b9\u5982\uff1b\u7b80\u76f4\uff0c\u53ef\u4ee5\u8bf4\uff1b\u4f5c\u4e3a\uff0c\u5f53\u4f5c\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 458,
    word: "comme",
    phonetic: "[k\u0254m]",
    type: "",
    translation: "\u4f8b\u5982\uff1b\u7531\u4e8e\uff0c\u56e0\u4e3a\uff1b\u65e2\u7136\uff1b\u591a\u4e48\uff1b\u600e\u4e48\uff0c\u600e\u6837",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 459,
    word: "r\u00e9gulier",
    phonetic: "[regylje, -\u03b5r]",
    type: "",
    translation: "a. \u6709\u89c4\u5f8b\u7684\uff1b\u89c4\u77e9\u7684\uff1b\u5b9a\u671f\u7684\uff1b\u7ecf\u5e38\u7684\uff1b\u5408\u6cd5\u7684 pr\u00e9p. [\u8868\u65f6\u95f4]\u5728\u2026\u2026\u4ee5\u524d\uff1b[\u8868\u7a7a\u95f4]\u5728\u2026\u2026\u524d\u9762\uff1b[\u8868\u6b21",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 460,
    word: "avant",
    phonetic: "[av\u0251\u0303]",
    type: "",
    translation: "\u5e8f\u3001\u7b49\u7ea7]\u5728\u2026\u2026\u4e4b\u4e0a\uff0c\u5728\u2026\u2026\u4e4b\u524d\uff1b\u4f18\u5148\uff1bn.m. \u524d\u90e8\uff1b [\u4f53]\u524d\u950b\uff1b[\u519b]\u524d\u7ebf n.f. \u65b9\u5f0f\uff0c\u65b9\u6cd5\uff1b\u98ce\u683c\uff0c\u624b\u6cd5\uff1bpl. \u6001\u5ea6\uff0c\u4e3e\u6b62\uff1b\u77eb\u63c9\u9020",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 461,
    word: "mani\u00e8re",
    phonetic: "[manj\u03b5r]",
    type: "",
    translation: "\u4f5c n.m. \u6700\u5c0f\u91cf\uff0c\u6700\u5c11\u91cf\uff0c\u6700\u4f4e\u989d\uff0c\u6700\u4f4e\u503c\uff0c\u6700\u4f4e\u7a0b\u5ea6\uff0c\u6700",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 462,
    word: "minimum",
    phonetic: "[minim\u0254m]",
    type: "",
    translation: "\u4f4e\u9650\u5ea6 v.t.,v.pr. \u8d85\u51fa\uff0c\u8ffd\u8fc7\uff1b\u9ad8\u51fa\uff1b\u80dc\u8fc7\uff1b\u4e92\u76f8\u8ffd\u8d76\uff1b\u8d85\u8fc7\u81ea",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 463,
    word: "d\u00e9passer",
    phonetic: "[depase]",
    type: "",
    translation: "\u5df1\u539f\u6709\u7684\u6c34\u5e73\u6216\u80fd\u529b\u7b49",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 464,
    word: "c\u00f4te",
    phonetic: "[kot]",
    type: "",
    translation: "n.f.\u5761\u9053\uff1b\u5c71\u5761\uff1b\u6d77\u5cb8\uff0c\u6d77\u6ee8\uff1b[\u89e3]\u808b\u9aa8\uff1b\u808b\uff0c\u808b\u90e8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 465,
    word: "pyramide",
    phonetic: "[piramid]",
    type: "",
    translation: "n.f. \u91d1\u5b57\u5854\uff1b[\u6570]\u68f1\u9525\uff08\u4f53\uff09\uff0c\u89d2\u9525\uff08\u4f53\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 466,
    word: "lui",
    phonetic: "[l\u0265i]",
    type: "",
    translation: "pron.pers. \u4ed6\uff0c\u5979\uff0c\u5b83 v.t. \u505a\u51fa\uff0c\u521b\u9020\uff0c\u5236\u9020\uff1b\u521b\u4f5c\uff1b\u5236\u8ba2\uff1b\u505a\uff0c\u5e72\uff0c\u8fdb\u884c\uff0c\u5b9e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 467,
    word: "faire",
    phonetic: "[f\u03b5r]",
    type: "",
    translation: "\u65bd\uff0c\u5b8c\u6210\uff1b\u4ece\u4e8b\uff0c\u5b66\u4e60\uff1b\u6574\u7406\uff0c\u6536\u62fe\uff1b\u57f9\u517b\uff1b\u4f7f\u53d8\u4e3a\uff0c\u4f7f \u6210\u4e3a adj.ind\u00e9f. \u67d0\u4e00\u4e2a\uff0c\u4e00\u4e2a\uff1b\u67d0\u4e9b\uff0c\u5c11\u8bb8\uff1b\u5927\u7ea6\uff0c\u5c06\u8fd1[\u53ea",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 468,
    word: "quelque",
    phonetic: "[k\u03b5lk\u0259]",
    type: "",
    translation: "ou [k\u03b5lk] \u4fee\u9970\u6570\u8bcd]\uff1bpl.\u51e0\u4e2a\uff1b\u5c11\u91cf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 469,
    word: "donner",
    phonetic: "[d\u0254ne]",
    type: "",
    translation: "v.t. \u7ed9\u4e88\uff1b\u8d60\u7ed9\uff1b\u732e\u51fa\uff1b\u4ed8\u51fa\uff1b\u4ea4\u7ed9\uff0c\u4ea4\u4ed8\uff1b\u63d0\u4f9b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 470,
    word: "partenaire",
    phonetic: "[part\u0259n\u03b5r]",
    type: "",
    translation: "n. \u4f19\u4f34\uff0c\u5408\u4f19\u4eba\uff1b\u642d\u6863",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 471,
    word: "donc",
    phonetic: "[d\u0254\u0303k]",
    type: "",
    translation: "conj. \u6240\u4ee5\uff0c\u56e0\u800c\uff0c\u56e0\u6b64\uff0c\u6545\uff1b\u90a3\u4e48\uff0c\u5f97\u5566\uff0c\u5230\u5e95\uff0c\u7a76\u7adf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 472,
    word: "r\u00e9el",
    phonetic: "[re\u03b5l]",
    type: "",
    translation: "a. \u771f\u7684\uff0c\u771f\u6b63\u7684\uff0c\u771f\u5b9e\u7684\uff1b\u73b0\u5b9e\u7684\uff1b\u786e\u5b9e\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 473,
    word: "huit",
    phonetic: "[\u0265it]",
    type: "",
    translation: "\u865a\u97f3H adj.num.card.\uff0c adj.inv. \u516b\uff1b\u7b2c\u516b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 474,
    word: "avoir",
    phonetic: "[avwar]",
    type: "",
    translation: "v.t. \u6709\uff1b\u662f\uff1bn.m. \u8d22\u4ea7\uff0c\u8d44\u4ea7\uff0c\u6240\u6709\u7269\uff1b\u8d37\u65b9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 475,
    word: "soir",
    phonetic: "[swar]",
    type: "",
    translation: "n.m. \u508d\u665a\uff0c\u9ec4\u660f\uff1b\u665a\u95f4\uff0c\u665a\u4e0a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 476,
    word: "heure",
    phonetic: "[\u0153r]",
    type: "",
    translation: "n.f. \u5c0f\u65f6\uff1b\u65f6\u95f4\uff1b\u70b9\u949f\uff1b\u949f\u70b9\uff1b\u65f6\u523b\uff0c\u65f6\u671f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 477,
    word: "face",
    phonetic: "[fas]",
    type: "",
    translation: "n.f. \u8138\uff0c\u9762\u90e8\uff1b\u8868\u9762\uff1b\uff08\u7269\u4f53\u7684\uff09\u9762\uff1b\u9762\u8c8c\uff1b\u65b9\u9762\uff1b\u5c40\u9762",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 478,
    word: "moins",
    phonetic: "[mw\u025b\u0303]",
    type: "",
    translation: "adv. \u51cf\uff1b\u5dee\uff1b\u8d1f\uff1b\u6bd4\u2026\u2026\u5c11\uff0c\u4e0d\u5982\uff1b\u6700\u5c11\uff0c\u6700\u4e0d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 479,
    word: "train",
    phonetic: "[tr\u025b\u0303]",
    type: "",
    translation: "n.m. \u5217\u8f66\uff0c\u706b\u8f66\uff1b\uff08\u8f66\u8239\u7b49\u7684\uff09\u961f\u5217\uff1b\u7cfb\uff0c\u7ec4\uff0c\u5217 adj.num.card.\uff0c adj.inv. \uff08\u7b2c\uff09\u5341\u4e00 \uff1b\u7b2c\u5341\u4e00\u53f7\u623f\u95f4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 480,
    word: "onze",
    phonetic: "[\u0254\u0303z]",
    type: "",
    translation: "\u6216\u684c\u5b50\uff1b\uff08\u4e00\u4e2a\u6708\u4efd\u7684\uff09\u5341\u4e00\u65e5\uff1b\uff0811\u4eba\u7ec4\u6210\u7684\uff09\u8db3\u7403 \u961f 13 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. n.m. \u6b65\uff0c\u6b65\u5b50\uff0c\u6b65\u4f10\uff0c\u6b65\u5c65\uff1b\u4e00\u6b65\u7684\u8ddd\u79bb\uff1b\u811a\u5370\uff0c\u8db3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 481,
    word: "pas",
    phonetic: "[pa]",
    type: "",
    translation: "\u8ff9\uff1b\u821e\u6b65",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 482,
    word: "seulement",
    phonetic: "[s\u0153lm\u0251\u0303]",
    type: "",
    translation: "adv. \u53ea\uff0c\u4ec5\u4ec5\uff1b\u521a\u521a\uff1b\u4e0d\u8fc7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 483,
    word: "trois",
    phonetic: "[trwa]",
    type: "",
    translation: "adj.num.card.\uff0c adj.inv. \u4e09 v.t. \u653e\uff0c\u7f6e\uff0c\u6446\uff1b\u9001\u5165\uff0c\u4f7f\u8fdb\u5165\uff1b\u5b89\u7f6e\uff1b\u6234\uff0c\u7a7f\uff1b\u914d\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 484,
    word: "mettre",
    phonetic: "[m\u03b5tr]",
    type: "",
    translation: "\u6dfb\uff0c\u52a0\uff0c\u8865\uff1b\u4f7f\u5904\u4e8e\u2026\u2026\u72b6\u6001\uff1b\u8bbe\u7f6e\uff0c\u5b89\u88c5\uff1b\u82b1\u8d39\uff08\u65f6 \u95f4\uff0c\u91d1\u94b1\uff09 pron.relat. \u8c01\uff0c\u4ec0\u4e48\u4eba\uff1b\u90a3\u4e2a\uff08\u4eba\u3001\u4e8b\u3001\u7269\uff09\uff1b\u90a3\u4e9b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 485,
    word: "qui",
    phonetic: "[ki]",
    type: "",
    translation: "\uff08\u4eba\u3001\u4e8b\u3001\u7269\uff09\uff1b\u4efb\u4f55\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 486,
    word: "repos",
    phonetic: "[r(\u0259)po]",
    type: "",
    translation: "n.m. \u4f11\u606f\uff1b\u7761\u7720\uff1b\u5b89\u9759\uff0c\u5b89\u5b81",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 487,
    word: "homme",
    phonetic: "[\u0254m]",
    type: "",
    translation: "n.m. \u4eba\uff1b\u4eba\u7c7b\uff1b\u7537\u4eba\uff1b\u7537\u5b50\u6c49",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 488,
    word: "pied",
    phonetic: "[pje]",
    type: "",
    translation: "n.m. \u811a\uff0c\u8db3\uff1b\u6b65\u4f10\uff1b\u57fa\u90e8\uff1b\u82f1\u5c3a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 489,
    word: "transport",
    phonetic: "[tr\u0251\u0303sp\u0254r]",
    type: "",
    translation: "n.m. \u8fd0\u8f93\uff0c\u642c\u8fd0\uff0c\u8fd0\u9001",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 490,
    word: "jour",
    phonetic: "[\u0292ur]",
    type: "",
    translation: "n.m. \u5929\uff0c\u65e5\u5b50\uff1b\u592a\u9633\u5149\uff1b\u767d\u5929",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 491,
    word: "chaque",
    phonetic: "[\u222bak]",
    type: "",
    translation: "a.ind\u00e9f.(\u6574\u4f53\u4e2d\u7684)\u6bcf\u4e2a, \u5404\u4e2a;\u6bcf\u4e00\u4e2a adv. \u4e5f\uff0c\u540c\u6837\uff0c\u4e00\u6837\uff1b\u8fd8\uff0c\u6b64\u5916\uff1b\u5982\u6b64\uff0c\u8fd9\u6837\uff1b\u56e0\u6b64\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 492,
    word: "aussi",
    phonetic: "[osi]",
    type: "",
    translation: "\u6240\u4ee5\uff0c\u56e0\u800c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 493,
    word: "plus",
    phonetic: "[plys]",
    type: "",
    translation: "[ply] adv. \u52a0\uff0c\u52a0\u4e0a\uff0c\u5916\u52a0\uff1b\u6bd4\u2026\u2026\u66f4\uff1b\u4e0d\u518d\uff0c\u518d\u6ca1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 494,
    word: "s\u00e9v\u00e8re",
    phonetic: "[sev\u03b5r]",
    type: "",
    translation: "a. \u4e25\u5389\u7684\uff1b\u4e25\u683c\u7684\uff0c\u4e25\u9177\u7684\uff1b\u6734\u7d20\u7684\uff1b\u4e25\u91cd\u7684\uff0c\u91cd\u5927\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 495,
    word: "fureur",
    phonetic: "[fyr\u0153r]",
    type: "",
    translation: "n.f. \u72c2\u6012\uff0c\u76db\u6012\uff0c\u66b4\u6012\uff1b\u6fc0\u70c8\uff0c\u731b\u70c8\uff0c\u72c2\u66b4\uff1b\u72c2\u70ed\uff0c\u8ff7\u604b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 496,
    word: "sauvage",
    phonetic: "[sova\u0292]",
    type: "",
    translation: "a. \u91ce\u751f\u7684\uff1b\u8352\u65e0\u4eba\u70df\u7684\uff1b\u51f6\u6b8b\u7684\uff1b\u7c97\u91ce\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 497,
    word: "vivement",
    phonetic: "[vivm\u0251\u0303]",
    type: "",
    translation: "adv. \u6025\u901f\u5730\uff0c\u8fc5\u901f\u5730\uff1b\u5f3a\u70c8\u5730\uff0c\u6df1\u6df1\u5730\uff1b\u975e\u5e38\uff0c\u5341\u5206 500 tous \u5168\u4f53\u7684\uff0c\u6240\u6709\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 498,
    word: "son",
    phonetic: "[s\u0254\u0303]",
    type: "",
    translation: "n.m. \u97f3\uff0c\u58f0\u97f3 / adj. \u4ed6\uff08\u5979\u3001\u5b83\uff09\u7684 n.m. \u5c0f\u5706\u70b9\uff1b\u6807\u70b9\uff1b\u53e5\u53f7\uff1b\u5206\u6570\uff1b\u767e\u5206\u70b9\uff1b\u5730\u65b9\uff1b\u8981",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 499,
    word: "point",
    phonetic: "[pw\u025b\u0303]",
    type: "",
    translation: "\u70b9\uff1b\u7a0b\u5ea6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 500,
    word: "peu",
    phonetic: "[p\u00f8]",
    type: "",
    translation: "adv. \u5c11\uff0c\u4e0d\u591a\uff1b\u4e0d\u592a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 501,
    word: "elle",
    phonetic: "[\u03b5l]",
    type: "",
    translation: "pron.pers.f. \u5979\uff0c\u5b83",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 502,
    word: "wagon",
    phonetic: "[vag\u0254\u0303]",
    type: "",
    translation: "n.m.\uff08\u706b\u8f66\uff09\u8f66\u53a2\uff1b\u4e00\u8f66\u53a2\u7684\u8d27\u7269 506 toute \uff08\u9634\u6027\uff09\u4efb\u4f55\uff0c\u6bcf\u4e00\u4e2a a. \u5927\u7684\uff0c\u9ad8\u5927\u7684\uff1b\u5e7f\u9614\u7684\uff0c\u5bbd\u5e7f\u7684\uff1b\u5f3a\u70c8\u7684\uff0c\u5267\u70c8\u7684\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 503,
    word: "grand",
    phonetic: "[gr\u0251\u0303, -d]",
    type: "",
    translation: "\u591a\u7684\uff0c\u5927\u91cf\u7684\uff1b\u957f\u5927\u7684\uff0c\u6210\u5e74\u7684\uff1b\u91cd\u8981\u7684\uff0c\u91cd\u5927\u7684\uff1b\u4f1f\u5927 \u7684\uff0c\u6770\u51fa\u7684 zh\u00e8i 1. (\u4ee3) (\u5e38\u7528\u5728\u91cf\u8bcd\u6216\u6570\u91cf\u8bcd\u524d) ce, cette ce livre",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 504,
    word: "cette",
    phonetic: "[s\u03b5t]",
    type: "",
    translation: "\u8fd9\u672c\u4e66 2. \u53e6\u89c1 zh\u00e8\u3002 zh\u00e8 1. (\u4ee3) (\u6307\u793a\u8f83\u8fd1\u7684\u4eba\u6216\u4e8b \u7269) ce; cet ...",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 505,
    word: "ville",
    phonetic: "[vil]",
    type: "",
    translation: "n.f. \u57ce\u5e02\uff0c\u90fd\u5e02\uff1b\u5168\u57ce\u5c45\u6c11\uff1b\u57ce\u5e02\u751f\u6d3b pr\u00e9p.\uff0c n.m. \u7ecf\u8fc7\uff0c\u901a\u8fc7\uff0c\u4ece\uff1b\u8d70\u904d\uff0c\u8dd1\u904d\uff1b\u5728\u2026\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 506,
    word: "par",
    phonetic: "[par]",
    type: "",
    translation: "\u65b9\uff1a\u5728\u2026\u65f6\u5019\uff1b\u6309\u7167\uff0c\u6bcf\uff1b\u88ab\uff0c\u7531\uff1b\u7528\uff0c\u4ee5\uff0c\u901a\u8fc7\uff1b\u7531 \u4e8e\uff0c\u51fa\u4e8e\uff1b\u4ee5\u2026\u7684\u540d\u4e49\uff1b\u4ee5 a. \u53ef\u6015\u7684\uff0c\u9a87\u4eba\u7684\uff1b\u4ee4\u4eba\u8ba8\u538c\u7684\uff0c\u53eb\u4eba\u96be\u53d7\u7684\uff1b\u731b\u70c8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 507,
    word: "terrible",
    phonetic: "[teribl]",
    type: "",
    translation: "ou [t\u03b5ribl] \u7684\uff1b\u975e\u5e38\u591a\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 508,
    word: "certain",
    phonetic: "[s\u03b5rt\u025b\u0303, -\u03b5n]",
    type: "",
    translation: "a. \u80af\u5b9a\u7684\uff1b\u786e\u5b9a\u7684\uff1b\u786e\u5b9e\u7684\uff0c\u786e\u51ff\u7684\uff1b\u786e\u4fe1\u7684\uff1b\u4e00\u4e9b pr\u00e9p. \u5728\u2026\u5bb6\uff0c\u5728\u2026\u90a3\u91cc\uff1b\u5230\u2026\u5bb6\uff0c\u5230\u2026\u90a3\u91cc\uff1b\u5728\u2026\u5bb6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 509,
    word: "chez",
    phonetic: "[\u222be]",
    type: "",
    translation: "\u4e61\uff1b\u5728\u2026\u5730\u65b9\uff1b\u5728\u2026\u65f6\u4ee3\uff1b\u5728\u2026\u4e2d\uff1b\u5728\u2026\u8eab\u4e0a\uff1b\u5728\u2026\u4f5c\u54c1 \u91cc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 510,
    word: "effet",
    phonetic: "[ef\u03b5]",
    type: "",
    translation: "n.m. \u6548\u679c\uff0c\u4f5c\u7528\uff1b\u7ed3\u679c\uff1b\u6548\u529b\uff1b\u5f71\u54cd\uff1b[\u7269\uff0c\u751f]\u6548\u5e94",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 511,
    word: "encore",
    phonetic: "[\u0251\u0303k\u0254r]",
    type: "",
    translation: "adv. \u8fd8\uff0c\u5c1a\uff0c\u4ecd\uff1b\u8fd8\u4e0d\uff0c\u8fd8\u6ca1\u6709\uff1b\u518d\uff0c\u53c8\uff0c\u91cd\u65b0 14 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. v.t. \u8bf4\uff0c\u8bb2\uff1b\u544a\u8bc9\uff0c\u8bb2\u8ff0\uff1b\uff08\u7528\u67d0\u4e00\u79cd\u8bed\u8a00\uff09\u8868\u8fbe\uff1b\u6717",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 512,
    word: "dire",
    phonetic: "[dir]",
    type: "",
    translation: "\u8bfb\uff0c\u5ff5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 513,
    word: "assez",
    phonetic: "[ase]",
    type: "",
    translation: "adv. \u591f\uff0c\u8db3\u591f\uff1b\u76f8\u5f53\uff1b\u975e\u5e38 v.t. \u6570\uff1b\u8ba1\u7b97\uff1b\u7b97\u4e0a\uff0c\u5305\u62ec\uff1b\u62e5\u6709\uff1b\u7b97\u5165\uff0c\u7b97\u4f5c\uff1bv.i.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 514,
    word: "compter",
    phonetic: "[k\u0254\u0303te]",
    type: "",
    translation: "\u6570\uff0c\u8ba1\u6570\uff1b\u8ba1\u7b97\uff1b\u5177\u6709\u4e00\u5b9a\u91cd\u8981\u6027\uff0c\u8d77\u4e00\u5b9a\u4f5c\u7528 adj. \u8bf4\u5b9a\u7684\uff0c\u8bf4\u59a5\u7684\uff0c\u8bf4\u597d\u7684\uff1b\u5916\u53f7\u53eb\u2026\u7684\uff0c\u7ef0\u53f7\u53eb\u2026",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 515,
    word: "dit",
    phonetic: "[di, -t]",
    type: "",
    translation: "\u7684\uff1b\u4e0a\u8ff0\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 516,
    word: "sou",
    phonetic: "[su]",
    type: "",
    translation: "n.m. \u82cf\uff1bpl. \u94b1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 517,
    word: "mai",
    phonetic: "[m\u03b5]",
    type: "",
    translation: "n.m. \u4e94\u6708 a. \u6982\u62ec\u7684\uff0c\u4e00\u822c\u7684\uff1b\u7b3c\u7edf\u7684\uff1b\u666e\u904d\u7684\uff0c\u666e\u901a\u7684\uff0c\u901a\u5e38",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 518,
    word: "g\u00e9n\u00e9ral",
    phonetic: "[\u0292eneral]",
    type: "",
    translation: "\u7684\uff1b\u603b\u7684\uff0c\u5168\u4f53\u7684\uff0c\u5168\u90e8\u7684\uff1bn.m. \u4e00\u822c\uff0c\u5168\u4f53\uff0c\u5168\u9762\uff1b \uff08\u9646\u3001\u7a7a\u519b\uff09\u4e0a\u5c06\uff1b\u5c06\u519b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 519,
    word: "cet",
    phonetic: "[s\u03b5t]",
    type: "",
    translation: "\u8fd9\uff0c \u8fd9\u4e9b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 520,
    word: "habitant",
    phonetic: "[abit\u0251\u0303]",
    type: "",
    translation: "n. \u5c45\u6c11\uff0c\u4eba\u53e3\uff1b\u5c45\u4f4f\u8005 n.m. \u767e\u4e07\uff1b\u767e\u4e07\u6cd5\u90ce\u3001\u767e\u4e07\u5143\u6216\u767e\u4e07\u9551\u7b49\uff1b\u5de8\u5927\u6570\u76ee\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 521,
    word: "million",
    phonetic: "[milj\u0254\u0303]",
    type: "",
    translation: "\u8bb8\u8bb8\u591a\u591a\uff0c \u65e0\u6570\uff1b\u4e00\u4e07\u6cd5\u90ce[\u6309\u65e7\u6cd5\u90ce\u4e00\u767e\u4e07\u6cd5\u90ce\u6298\u5408\u65b0 \u6cd5\u90ce\u4e00\u767e\u4e07\u751f\u4e01\u8ba1\u7b97]",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 522,
    word: "vingt",
    phonetic: "[v\u025b\u0303]",
    type: "",
    translation: "adj.num.card. \u4e8c\u5341",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 523,
    word: "population",
    phonetic: "[p\u0254pylasj\u0254\u0303]",
    type: "",
    translation: "n.f. \u4eba\u53e3\uff1b\uff08\u5168\u4f53\uff09\u5c45\u6c11",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 524,
    word: "comprendre",
    phonetic: "[k\u0254\u0303pr\u0251\u0303dr]",
    type: "",
    translation: "v.t. \u5305\u62ec\uff0c\u5305\u542b\uff1b\u61c2\u5f97\uff0c\u660e\u767d\uff1b\u7406\u89e3\uff1b\u610f\u8bc6\u5230 pron.relat.\uff0c conj.\uff0c adv. \u591a\u4e48\uff1b \u591a\u5c11\uff1b\u4e3a\u4ec0\u4e48\uff1b\u4ec0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 525,
    word: "que",
    phonetic: "[k\u0259]",
    type: "",
    translation: "\u4e48\uff0c \u4ec0\u4e48\u4e1c\u897f\uff0c \u4ec0\u4e48\u4e8b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 526,
    word: "enchant\u00e9",
    phonetic: "[\u0251\u0303\u222b\u0251\u0303te]",
    type: "",
    translation: "a. \u4e2d\u9b54\u6cd5\u7684\uff1b\u975e\u5e38\u9ad8\u5174\u7684 v.t. \u4f7f\u7194\u5316\uff1b\u4f7f\u6eb6\u89e3\uff0c\u4f7f\u878d\u5316\uff1b\u94f8\u9020\uff1b\u4f7f\u5408\u5e76\uff0c\u4f7f\u878d\u5408\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 527,
    word: "fondre",
    phonetic: "[f\u0254\u0303dr]",
    type: "",
    translation: "v.i. \u7194\u5316\uff1b\u6eb6\u89e3\uff1b\u878d\u5316",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 528,
    word: "chaussure",
    phonetic: "[\u222bosyr]",
    type: "",
    translation: "n.f. \u978b\uff0c\u9774",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 529,
    word: "quitter",
    phonetic: "[kite]",
    type: "",
    translation: "v.t. \u79bb\u5f00\uff1b\u8131\u79bb\uff0c\u653e\u5f03\uff1b\u53bb\u4e16",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 530,
    word: "trop",
    phonetic: "[tro]",
    type: "",
    translation: "adv. \u592a v.i. \u662f\uff1b\u5728\uff0c\u5904\u5728\uff1b\u5b58\u5728\uff0c\u6709\uff1bn.m. \u5b58\u5728\uff0c\u751f\u5b58\uff1b\u5b58\u5728",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 531,
    word: "\u00eatre",
    phonetic: "[\u03b5tr]",
    type: "",
    translation: "\u7269\uff1b\u751f\u7269\uff1b\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 532,
    word: "compagnon",
    phonetic: "[k\u0254\u0303pa\u0272\u0254\u0303]",
    type: "",
    translation: "n.m. \u540c\u4f34\uff0c\u4f19\u4f34\uff0c\u4f34\u4fa3\uff0c\u540c\u4e8b\uff1b\u540c\u5c45\u7537\u53cb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 533,
    word: "permettre",
    phonetic: "[p\u03b5rm\u03b5tr]",
    type: "",
    translation: "v.t. \u5141\u8bb8\uff0c\u51c6\u8bb8\uff0c\u8bb8\u53ef\uff1b\u4f7f\u6709\u53ef\u80fd\uff0c\u4f7f\u80fd\u591f\uff0c\u5bb9\u8bb8 v.t. \u518d\u653e\u4e0b\uff1b\u91cd\u65b0\u653e\u4e0b\uff1b\u653e\u56de\uff1b\u91cd\u65b0\u5b89\u7f6e\uff0c\u91cd\u65b0\u5b89\u653e\uff1b\u91cd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 534,
    word: "reposer",
    phonetic: "[r\u0259poze]",
    type: "",
    translation: "\u65b0\u63d0\u51fa\uff1bv.i. \u4f11\u606f\uff0c\u7761\uff1b\u5b89\u606f\uff1b\u5efa\u7b51\u5728\uff1b\u5efa\u7acb\u4e8e\uff1b\u4f9d\u9760",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 535,
    word: "meilleur",
    phonetic: "[m\u03b5j\u0153r]",
    type: "",
    translation: "a. \u8f83\u597d\u7684\uff0c\u66f4\u597d\u7684\uff1bn.m. \u6700\u597d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 536,
    word: "pr\u00e9venir",
    phonetic: "[prevnir]",
    type: "",
    translation: "v.t. \u9884\u9632\uff0c\u9632\u6b62\uff1b\u901a\u77e5\uff0c\u544a\u77e5 v.t. \u62ff\u7740\uff1b\u6267\uff0c\u6301\uff1b\u6293\u4f4f\uff0c\u902e\u4f4f\uff1b\u638c\u63e1\uff0c\u62e5\u6709\uff1b\u7ecf\u8425\uff0c\u5f00",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 537,
    word: "tenir",
    phonetic: "[t(\u0259)nir]",
    type: "",
    translation: "\u8bbe\uff1b\u638c\u7ba1\uff1b\u4fdd\u6301\uff0c\u4f7f\u5904\u4e8e\uff1b\u4fe1\u5b88\uff0c\u9075\u5b88\uff1b\u5bb9\u7eb3\uff0c\u88c5\u5f97\u4e0b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 538,
    word: "pr\u00eat",
    phonetic: "[pr\u03b5]",
    type: "",
    translation: "n.m. \u51fa\u501f\uff1b\u8d37\u6b3e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 539,
    word: "secours",
    phonetic: "[s\u0259kur]",
    type: "",
    translation: "n.m. \u63f4\u52a9\uff0c\u63f4\u6551\uff1b\u6551\u6d4e\uff1b\u6551\u62a4\uff1b\u5e2e\u52a9\uff1b\u63f4\u5175",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 540,
    word: "d\u00e9tacher",
    phonetic: "[deta\u222be]",
    type: "",
    translation: "v.t. \u89e3\u5f00\uff0c\u62c6\u5f00\uff1b\u5378\u4e0b\uff1b\u88c1\u4e0b\uff0c\u6495\u4e0b\uff1b\u6d3e\u9063\uff1b\u4f7f\u8131\u79bb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 541,
    word: "pression",
    phonetic: "[pr\u03b5sj\u0254\u0303]",
    type: "",
    translation: "n.f. \u538b\uff0c\u6309\uff0c\u63ff\uff1b[\u6280]\u538b\u529b\uff1b\u538b\u5f3a\uff1b\u903c\u8feb\uff0c\u538b\u5236\uff0c\u538b\u529b v.i. \u5439\u54e8\uff1b\u9e23\u7b1b\uff1b\u5618\u5618\u4f5c\u54cd\uff0c\u547c\u5578\uff1bv.t. \u7528\u53e3\u54e8\u5439\uff1b\u5439\u54e8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 542,
    word: "siffler",
    phonetic: "[sifle]",
    type: "",
    translation: "\u53eb\u5524\uff1b\u5439\u54e8\u5ba3\u5e03\uff1b\u53d1\u51fa\u5618\u58f0\u53cd\u5bf9\uff1b\u4e00\u996e\u800c\u5c3d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 543,
    word: "parmi",
    phonetic: "[parmi]",
    type: "",
    translation: "pr\u00e9p. \u5728\u2026\u2026\u4e4b\u4e2d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 544,
    word: "soin",
    phonetic: "[sw\u025b\u0303]",
    type: "",
    translation: "n.m. \u7ec6\u5fc3\uff0c\u7528\u5fc3\uff0c\u4ed4\u7ec6\uff1b\u7167\u7ba1\uff0c\u7167\u770b\uff1bpl. \u6cbb\u7597 v.t. \u4f7f\u6210\u5f62\uff1b\u7ec4\u6210\uff0c\u5efa\u7acb\uff1b\u6784\u6210\uff0c\u5f62\u6210\uff1b\u57f9\u517b\uff0c\u8bad\u7ec3\uff0c\u9020",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 545,
    word: "former",
    phonetic: "[f\u0254rme]",
    type: "",
    translation: "\u5c31",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 546,
    word: "fumer",
    phonetic: "[fyme]",
    type: "",
    translation: "v.t. \u5438\u70df\uff0c\u62bd\u70df\uff1b\u70df\u718f\uff0c\u718f\u5236\uff1bv.i. \u5192\u70df\uff1b\u5192\u6c14 15 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 547,
    word: "bois",
    phonetic: "[bwa]",
    type: "",
    translation: "n.m. \u6811\u6728\uff0c\u6811\u6797\uff1b\u6728\uff0c\u6728\u6750\uff1b\u6728\u5236\u54c1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 548,
    word: "capitaine",
    phonetic: "[kapit\u03b5n]",
    type: "",
    translation: "n.m. \u8239\u957f\uff1b\u4e0a\u5c09\uff1b\u961f\u957f\uff1b\u5934\u76ee",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 549,
    word: "cheveu",
    phonetic: "[\u222b(\u0259)v\u00f8]",
    type: "",
    translation: "n.m. \u5934\u53d1 v.t.\uff0c v.pr. 1.\u8fd0\u8f93\uff0c \u642c\u8fd0\uff1b 2.\u4f7f\u5341\u5206\u6fc0\u52a8\uff1b 3.\u8f6c\u8ba9\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 550,
    word: "transporter",
    phonetic: "[tr\u0251\u0303sp\u0254rte]",
    type: "",
    translation: "\u79fb\u8f6c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 551,
    word: "bateau",
    phonetic: "[bato]",
    type: "",
    translation: "n.m. \u8239\uff0c\u8247",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 552,
    word: "\u00e9t\u00e9",
    phonetic: "[ete]",
    type: "",
    translation: "n.m. \u590f\uff0c\u590f\u5b63\uff0c\u590f\u5929 v.t. \u5e26\uff0c\u9886\uff1b\u8fd0\u9001\uff1b\u5bfc\u5f80\uff0c\u901a\u5411\uff1b\u9886\u5bfc\uff0c\u6307\u6325\uff1b\u6267\u884c\uff1b\u8fdb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 553,
    word: "mener",
    phonetic: "[m\u0259ne]",
    type: "",
    translation: "\u884c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 554,
    word: "offre",
    phonetic: "[\u0254fr]",
    type: "",
    translation: "n.f. \u63d0\u4f9b\uff1b\u63d0\u51fa\uff0c\u63d0\u8bae\uff1b\u8981\u7ea6\uff1b\u5f00\u4ef7\uff0c\u62a5\u4ef7 v. t. \u5ba3\u5e03\uff0c\u5ba3\u544a\uff1b\u8bb2\uff0c\u8bf4\uff1b\u53d1\u8868\uff0c\u5ba3\u8bfb\uff1b v.i. \u5ba3\u5224\uff1b\u505a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 555,
    word: "prononcer",
    phonetic: "[pr\u0254n\u0254\u0303se]",
    type: "",
    translation: "\u51fa\u51b3\u5b9a\uff0c\u8868\u6001",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 556,
    word: "d\u00e9barquer",
    phonetic: "[debarke]",
    type: "",
    translation: "v.t. \u4e0b\uff08\u5ba2\uff09\uff1b\u5378\uff08\u8d27\uff09\uff1bv.i. \u4e0b\u8239\uff1b\u4e0b\u98de\u673a\uff1b\u4e0b\u706b\u8f66 v.t. \u518d\u5e26\u6765\uff1b\u5e26\u56de\u6765\uff1b\u628a\u2026\u2026\u653e\u56de\u539f\u5904\uff1b\u4f7f\u6062\u590d\u5230\u539f\u6765\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 557,
    word: "ramener",
    phonetic: "[ramne]",
    type: "",
    translation: "\u72b6\u6001 v.t. \u63a8\uff0c\u63a8\u8fdb\uff1b\u9a71\uff0c\u8d76\uff1b\u4fc3\u4f7f\uff0c\u4fc3\u8fdb\uff1b\u53d1\u51fa\uff08\u558a\u53eb\u58f0\uff09\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 558,
    word: "pousser",
    phonetic: "[puse]",
    type: "",
    translation: "v.i. \u751f\u957f\uff0c\u957f\u51fa",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 559,
    word: "d\u00e9cid\u00e9",
    phonetic: "[deside]",
    type: "",
    translation: "a. \u575a\u51b3\u7684\uff0c\u679c\u65ad\u7684\uff1b\u5df2\u51b3\u5b9a\u7684\uff0c\u65e2\u5b9a\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 560,
    word: "livrer",
    phonetic: "[livre]",
    type: "",
    translation: "v.t. \u4ea4\u51fa\uff0c\u4ea4\u7ed9\uff1b\u9001\u4ea4\uff1b\u4e22\u5f03\uff1b\u51fa\u5356\uff1b\u53db\u53d8\uff1b\u4ea4\uff08\u8d27\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 561,
    word: "profondeur",
    phonetic: "[pr\u0254f\u0254\u0303d\u0153r]",
    type: "",
    translation: "n.f. \u6df1\uff0c\u6df1\u5ea6\uff1b\u6df1\u523b\uff0c\u6df1\u5165\uff1b\u6df1\u5965 a. \u56fa\u4f53\u7684\uff1b\u575a\u56fa\u7684\uff0c\u7262\u56fa\u7684\uff0c\u7a33\u56fa\u7684\uff1b\u7ed3\u5b9e\u7684\uff0c\u5f3a\u58ee",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 562,
    word: "solide",
    phonetic: "[s\u0254lid]",
    type: "",
    translation: "\u7684\uff1b\u8010\u52b3\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 563,
    word: "bouquet",
    phonetic: "[buk\u03b5]",
    type: "",
    translation: "n.m. \u82b1\u675f\uff1b\u675f\uff0c\u624e\uff0c\u7c07\uff0c\u4e32 n.f. \u5730\u9053\uff1b\u8d70\u5eca\uff0c\u957f\u5eca\uff1b\uff08\u9648\u5217\u827a\u672f\u54c1\u7684\uff09\u5385\uff1b\u753b\u5eca\uff0c\u9648",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 564,
    word: "galerie",
    phonetic: "[galri]",
    type: "",
    translation: "\u5217\u5eca v.t. \u6307\u51fa\uff0c\u6307\u793a\uff1b\u51fa\u793a\uff1b\u70ab\u8000\uff0c\u5356\u5f04\uff1b\u8bf4\u660e\uff0c\u8868\u660e\uff1b\u663e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 565,
    word: "montrer",
    phonetic: "[m\u0254\u0303tre]",
    type: "",
    translation: "\u793a\uff0c\u8868\u73b0\u51fa",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 566,
    word: "charger",
    phonetic: "[\u222bar\u0292e]",
    type: "",
    translation: "v.t. \u88c5\u8f7d\uff0c\u88c5\u8fd0\uff1b\u88c5\u586b\uff0c\u88c5\u6ee1\uff1b\u59d4\u6258\uff0c\u4f7f\u627f\u62c5\uff1b\u5145\u7535",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 567,
    word: "trente",
    phonetic: "[tr\u0251\u0303t]",
    type: "",
    translation: "adj.num.card.\uff0c adj.inv. \u4e09\u5341",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 568,
    word: "indien",
    phonetic: "[\u025b\u0303dj\u025b\u0303, -\u03b5n]",
    type: "",
    translation: "adj.\uff0c n. \u5370\u5ea6\u7684\uff1b\u5370\u7b2c\u5b89\u7684\uff1b\u5370\u5ea6\u4eba\uff1b\u5370\u7b2c\u5b89\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 569,
    word: "commander",
    phonetic: "[k\u0254m\u0251\u0303de]",
    type: "",
    translation: "v.t. \u6307\u6325\uff0c\u7edf\u5e05\uff0c\u652f\u914d\uff1b\u8ba2\u8d2d\uff0c\u5b9a\u505a\uff1b\u70b9\u996e\u6599\uff1b\u70b9\u83dc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 570,
    word: "troupe",
    phonetic: "[trup]",
    type: "",
    translation: "n.f. \u519b\u961f\uff0c\u90e8\u961f\uff1b\u58eb\u5175\uff1b\u7fa4\uff0c\u961f\uff1b\u5267\u56e2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 571,
    word: "droit",
    phonetic: "[drwa, -t]",
    type: "",
    translation: "n.m. \u6743\u5229\uff1b\u7a0e\uff1b\u6cd5\u5f8b\uff0c\u6cd5\u89c4\uff1badj. \u76f4\u7684\uff1badv. \u7b14\u76f4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 572,
    word: "soci\u00e9t\u00e9",
    phonetic: "[s\u0254sjete]",
    type: "",
    translation: "n.f. \u793e\u4f1a\uff1b\u793e\u4ea4\u754c\uff1b\u534f\u4f1a\uff0c\u793e\u56e2\uff1b\u516c\u53f8\uff1b\u7fa4\u5c45\uff0c\u7fa4\u5c45\u751f\u6d3b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 573,
    word: "individu",
    phonetic: "[\u025b\u0303dividy]",
    type: "",
    translation: "n.m. \u4e2a\u4f53\uff1b\u4e2a\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 574,
    word: "repousser",
    phonetic: "[r\u0259puse]",
    type: "",
    translation: "v.t.\uff0c v.pr. 1.\u63a8\u5f00\uff1b\u51fb\u9000\uff1b 2.\u6392\u65a5\uff1b\u62d2\u7edd\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 575,
    word: "pay\u00e9",
    phonetic: "[peje]",
    type: "",
    translation: "\u53d7\u96c7\u7684\uff1b\u4ed8\u6e05\uff0c\u62a5\u507f a. \u8bda\u5b9e\u7684\uff1b\u6b63\u76f4\u7684\uff1b\u5584\u826f\u7684\uff1b\u9002\u5f53\u7684\uff0c\u9002\u4e2d\u7684\uff1b\u4ee4\u4eba\u6ee1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 576,
    word: "honn\u00eate",
    phonetic: "[\u0254n\u03b5t]",
    type: "",
    translation: "\u610f\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 577,
    word: "constater",
    phonetic: "[k\u0254\u0303state]",
    type: "",
    translation: "v.t. 1.\u770b\u5230\uff0c\u89c2\u5bdf\u5230\uff1b 2.\u786e\u8ba4\uff1b\u4e86\u89e3\uff0c\u67e5\u660e n.m. \u5ea7\u4f4d\uff0c\u6905\u5b50\uff1b\u5e2d\u4f4d\uff1b\u6240\u5728\u5730\uff1b\u4e2d\u5fc3\uff0c\u4e2d\u67a2\uff1b[\u519b]\u5305",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 578,
    word: "si\u00e8ge",
    phonetic: "[sj\u03b5\u0292]",
    type: "",
    translation: "\u56f4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 579,
    word: "impatience",
    phonetic: "[\u025b\u0303pasj\u0251\u0303s]",
    type: "",
    translation: "n.f. \u65e0\u8010\u5fc3\uff0c\u6027\u6025\uff1b\u7126\u6025\uff0c\u4e0d\u8010\u70e6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 580,
    word: "poche",
    phonetic: "[p\u0254\u222b]",
    type: "",
    translation: "n.f. \u8863\u888b\uff0c\u53e3\u888b\uff1b\u888b\uff0c\u5305",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 581,
    word: "confiance",
    phonetic: "[k\u0254\u0303fj\u0251\u0303s]",
    type: "",
    translation: "n.f. \u76f8\u4fe1\uff0c\u4fe1\u4efb\uff0c\u4fe1\u5fc3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 582,
    word: "rouler",
    phonetic: "[rule]",
    type: "",
    translation: "v.t. \u4f7f\u6eda\u52a8\uff0c\u4f7f\u8f6c\u52a8\uff1b\u5377\uff1b\u88f9\uff1bv.i. \u6eda\u52a8\uff1b\u8f6c\u52a8\uff1b\u884c\u9a76",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 583,
    word: "chant",
    phonetic: "[\u222b\u0251\u0303]",
    type: "",
    translation: "n.m. \u6b4c\u5531\uff1b\u6b4c\u58f0\uff1b\u6b4c\u66f2 16 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 584,
    word: "cesser",
    phonetic: "[sese]",
    type: "",
    translation: "ou [s\u025bse] v.t. \u505c\u6b62\uff0c\u7ec8\u6b62\uff1b\u4e2d\u65ad pr\u00e9p. \u4e0d\u7ba1\uff08\u67d0\u4eba\u7684\u963b\u6321\uff09\uff0c\u4e0d\u987e\uff08\u67d0\u4eba\u7684\u53cd\u5bf9\uff09\uff1b\u867d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 585,
    word: "malgr\u00e9",
    phonetic: "[malgre]",
    type: "",
    translation: "\u7136\uff0c\u5c3d\u7ba1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 586,
    word: "nourriture",
    phonetic: "[nurityr]",
    type: "",
    translation: "n.f. \u98df\u7269\uff1b\u81b3\u98df\uff1b\uff08\u7cbe\u795e\uff09\u98df\u7cae\uff0c\u517b\u6599",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 587,
    word: "interminable",
    phonetic: "[\u025b\u0303t\u03b5rminabl]",
    type: "",
    translation: "adj. \u65e0\u4f11\u6b62\u7684\uff0c\u65e0\u6b62\u5883\u7684\uff0c\u6ca1\u5b8c\u6ca1\u4e86\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 588,
    word: "membre",
    phonetic: "[m\u0251\u0303br]",
    type: "",
    translation: "n.m. \u6210\u5458\uff0c\u4e00\u5206\u5b50\uff1b\u80a2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 589,
    word: "sc\u00e8ne",
    phonetic: "[s\u03b5n]",
    type: "",
    translation: "n.f. \u821e\u53f0\uff1b\u5e03\u666f\uff1b\u73b0\u573a\uff1b\uff08\u620f\u5267\u7684\uff09\u573a\u6b21\uff1b\u573a\u9762\uff0c\u60c5\u666f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 590,
    word: "quelquefois",
    phonetic: "[k\u03b5lk\u0259fwa]",
    type: "",
    translation: "adv. \u6709\u65f6\uff0c\u5076\u5c14",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 591,
    word: "repas",
    phonetic: "[r\u0259p\u0251]",
    type: "",
    translation: "n.m. \u9910\uff0c\u996d\u98df",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 592,
    word: "organiser",
    phonetic: "[\u0254rganize]",
    type: "",
    translation: "v.t. \u7ec4\u7ec7\uff0c\u7ec4\u6210\uff1b\u7b79\u5907\uff1b\u5b89\u6392 597 poster n.m.[p\u0254st\u03b5r] / v.[p\u0254ste] v.t. \u4ed8\u90ae\uff0c\u90ae\u5bc4\uff0c\u6295\u5bc4 n.f. \u60c5\u611f\uff0c\u70ed\u60c5\uff1b\u6fc0\u60c5\uff1b\u7231\u60c5\uff1b\u60c5\u6b32\uff1b\u9177\u7231\uff0c\u8ff7\u604b\uff1b\u9177\u7231",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 593,
    word: "passion",
    phonetic: "[pasj\u0254\u0303]",
    type: "",
    translation: "\u7269",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 594,
    word: "condition",
    phonetic: "[k\u0254\u0303disj\u0254\u0303]",
    type: "",
    translation: "n.f. \u6761\u4ef6\uff1b\uff08\u793e\u4f1a\uff09\u5730\u4f4d\uff0c\u8eab\u4efd\uff1b\u72b6\u51b5\uff1b\u73af\u5883\uff0c\u5f62\u52bf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 595,
    word: "montagne",
    phonetic: "[m\u0254\u0303ta\u0272]",
    type: "",
    translation: "n.f. \u5c71\uff0c\u5c71\u5cb3\uff1b\u5c71\u533a\uff1b\u4e00\u5927\u5806 a. \u5e7f\u9614\u7684\uff0c\u5bbd\u5e7f\u7684\uff1b\u5bbd\u9614\u7684\uff0c\u5bbd\u655e\u7684\uff1b\u5b8f\u4f1f\u7684\uff1b\u5e7f\u6cdb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 596,
    word: "vaste",
    phonetic: "[vast]",
    type: "",
    translation: "\u7684\uff1b\u5e9e\u5927\u7684\uff1b\u5e7f\u535a\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 597,
    word: "champ",
    phonetic: "[\u222b\u0251\u0303]",
    type: "",
    translation: "n.m. \u7530\uff0c\u8015\u5730\uff1b\uff08\u6d3b\u52a8\u3001\u7814\u7a76\u7684\uff09\u8303\u56f4\uff0c\u9886\u57df\uff1b\u89c6\u91ce",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 598,
    word: "larme",
    phonetic: "[larm]",
    type: "",
    translation: "n.f. \u773c\u6cea adj. \u8fd9\u6837\u7684\uff0c\u8fd9\u79cd\u7684\uff1b\u5982\u6b64\u7684\uff1b\u5982\u540c\uff0c\u50cf\u2026\u4e00\u6837\uff1b\u8fd9\u7b49",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 599,
    word: "tel",
    phonetic: "[t\u03b5l]",
    type: "",
    translation: "\u7684\uff0c\u5982\u6b64\u8d28\u91cf\u7684\uff1b\u5230\u5982\u6b64\u7a0b\u5ea6\u7684\uff1b\u67d0\u4e00\u4e2a\uff1b\u67d0\u67d0\u4eba\uff1b\u67d0\u4e2a [\u4e0d\u7528\u51a0\u8bcd]\uff1b\u56e0\u800c\uff0c\u56e0\u6b64\uff0c\u4ee5\u81f4\uff1b\u4ee5\u4f7f\uff0c\u4ee5\u4fbf\uff0c\u4f7f\u5f97 v.t. \u5960\u5b9a\uff0c\u786e\u7acb\uff1b\u521b\u529e\uff0c\u8bbe\u7acb\uff0c\u5efa\u7acb\uff1b\u5b89\u6392\uff0c\u5b89\u7f6e\uff1b\u90e8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 600,
    word: "\u00e9tablir",
    phonetic: "[etablir]",
    type: "",
    translation: "\u7f72\uff1b\u7f16\u5236\uff0c\u5236\u5b9a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 601,
    word: "atteindre",
    phonetic: "[at\u025b\u0303dr]",
    type: "",
    translation: "v.t. \u5230\u8fbe\uff1b\u8fbe\u5230\uff1b\u9047\u5230\uff0c\u8054\u7cfb\u4e0a\uff1b\u51fb\u4e2d\uff0c\u547d\u4e2d n.f. \u5236\u4f5c\uff0c\u52a0\u5de5\uff1b\u5f0f\u6837\uff0c\u6837\u5b50\uff1b\u59ff\u52bf\uff1b\u65b9\u5f0f\uff1bpl. \u5ba2\u5957\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 602,
    word: "fa\u00e7on",
    phonetic: "[fas\u0254\u0303]",
    type: "",
    translation: "\u5ba2\u6c14",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 603,
    word: "admirer",
    phonetic: "[admire]",
    type: "",
    translation: "v.t.\u8d5e\u8d4f\uff0c\u8d5e\u7f8e\uff1b\u89c2\u8d4f\uff1b\u4ef0\u6155\uff0c\u94a6\u4f69",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 604,
    word: "hasard",
    phonetic: "[azar]",
    type: "",
    translation: "\u865a\u97f3H n.m. \u673a\u9047\uff0c\u5de7\u5408\uff1b\u98ce\u9669\uff1b\u5076\u7136\uff0c\u5076\u7136\u6027 v.t. \u76d6\uff0c\u8986\u76d6\uff1b\u4f7f\u5e03\u6ee1\uff1b\u8d70\u5b8c\uff0c\u884c\u9a76\uff08\u8def\u7a0b\uff09\uff1b\u4fdd\u62a4\uff0c\u63a9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 605,
    word: "couvrir",
    phonetic: "[kuvrir]",
    type: "",
    translation: "\u62a4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 606,
    word: "\u00eele",
    phonetic: "[il]",
    type: "",
    translation: "n.f. \u5c9b\uff0c\u5c9b\u5c7f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 607,
    word: "reconna\u00eetre",
    phonetic: "[r\u0259k\u0254n\u03b5tr]",
    type: "",
    translation: "v.t. \u8ba4\u51fa\uff1b\u627f\u8ba4\uff0c\u786e\u8ba4\uff1b\u8ba4\u8bc6\u5230\uff0c\u610f\u8bc6\u5230",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 608,
    word: "battre",
    phonetic: "[batr]",
    type: "",
    translation: "v.t. \u6253\uff0c\u63cd\uff1b\u6218\u80dc\uff0c\u6253\u57ae\uff0c\u51fb\u8d25\uff1b\u62cd\u6253\uff0c\u6572\uff0c\u6376 n.m. \u5de5\u5177\uff0c\u5668\u5177\uff0c\u5668\u68b0\uff0c\u4eea\u5668\uff1b\u4e50\u5668\uff1b\u88ab\u5229\u7528\u7684\u4eba\uff1b\u624b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 609,
    word: "instrument",
    phonetic: "[\u025b\u0303strym\u0251\u0303]",
    type: "",
    translation: "\u6bb5\uff0c\u65b9\u6cd5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 610,
    word: "couteau",
    phonetic: "[kuto]",
    type: "",
    translation: "n.m. \u5200",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 611,
    word: "roue",
    phonetic: "[ru]",
    type: "",
    translation: "n.f. \u8f66\u8f6e\uff1b\u9f7f\u8f6e\uff1b\u8f6e\u72b6\u7269 n.f. \u767d\u7684\uff0c\u767d\u8272\u7684\uff1b\u6d01\u767d\u7684\uff0c\u7eaf\u6d01\u7684\uff0c\u6e05\u6d01\u7684\uff1b\u7a7a\u767d\u7684\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 612,
    word: "blanche",
    phonetic: "[bl\u0251\u0303\u222b]",
    type: "",
    translation: "\u6e05\u767d\u7684\uff1b\u65e0\u901a\u5e38\u6548\u679c\u7684\uff0c\u5f62\u5f0f\u4e0a\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 613,
    word: "parole",
    phonetic: "[par\u0254l]",
    type: "",
    translation: "n.f. \u8bdd\uff0c\u8bdd\u8bed\uff1b\u8bb2\u8bdd\uff1b\u53d1\u8a00\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 614,
    word: "saisir",
    phonetic: "[s\u03b5zir]",
    type: "",
    translation: "v.t. \u6293\u4f4f\uff0c\u6293\u7d27\uff1b\u62b1\u4f4f\uff1b\u7406\u89e3\uff1b\u4fb5\u88ad",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 615,
    word: "ajouter",
    phonetic: "[a\u0292ute]",
    type: "",
    translation: "v.t. \u52a0\uff0c\u6dfb\uff1b\u8865\u5145\uff08\u8bf4\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 616,
    word: "soldat",
    phonetic: "[s\u0254lda]",
    type: "",
    translation: "n.m. \u519b\u4eba\uff1b\u58eb\u5175",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 617,
    word: "centaine",
    phonetic: "[s\u0251\u0303t\u03b5n]",
    type: "",
    translation: "n.f. \u767e\u4f4d\u6570\uff0c\u767e\u4e2a\uff1b\u767e\u6765\u4e2a\uff0c\u8fd1\u767e\u4e2a n.m. \u60c5\u51b5\uff0c\u573a\u5408\uff1b\u673a\u4f1a\uff1b\u4e8b\u4ef6\uff1b\u6848\u60c5\uff0c\u6848\u4ef6\uff1b\u5904\u5883\uff0c\u5883",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 618,
    word: "cas",
    phonetic: "[k\u0251, ka]",
    type: "",
    translation: "\u51b5\uff1b\u75c5\u4f8b 17 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. v.t.\uff0c v.pr. \u653b\u51fb\uff0c\u8fdb\u653b\uff1b\u62a8\u51fb\u63a7\u544a\uff0c\u8d77\u8bc9\uff1b\u8d23\u95ee\uff0c \u8d28",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 619,
    word: "attaquer",
    phonetic: "[atake]",
    type: "",
    translation: "\u8be2\uff1b\u529b\u6c42\u6218\u80dc\uff1b \u8150\u8680\uff0c\u4fb5\u8680\uff0c\u635f\u574f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 620,
    word: "mort",
    phonetic: "[m\u0254r]",
    type: "",
    translation: "n.f. \u6b7b\uff0c\u6b7b\u4ea1\uff1b\u706d\u4ea1\uff0c\u6bc1\u706d\uff0c\u5b8c\u7ed3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 621,
    word: "intention",
    phonetic: "[\u025b\u0303t\u0251\u0303sj\u0254\u0303]",
    type: "",
    translation: "n.f. \u610f\u56fe\uff0c\u610f\u5411\uff1b\u610f\u613f\uff1b\u76ee\u7684\uff0c\u6253\u7b97",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 622,
    word: "poursuivre",
    phonetic: "[purs\u0265ivr]",
    type: "",
    translation: "v.t. \u8ffd\uff0c\u8ffd\u9010\uff1b\u8ffd\u6355\uff1b\u8ffd\u6c42\uff1b\u7ee7\u7eed\uff1b\u7ea0\u7f20\uff1b[\u6cd5]\u8d77\u8bc9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 623,
    word: "volont\u00e9",
    phonetic: "[v\u0254l\u0254\u0303te]",
    type: "",
    translation: "n.f. \u613f\u671b\uff0c\u610f\u613f\uff1b\u610f\u5fd7\uff0c\u6bc5\u529b\uff1b\u610f\u56fe\uff0c\u610f\u5411",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 624,
    word: "masse",
    phonetic: "[mas]",
    type: "",
    translation: "n.f. 1.\u5757\uff1b\u80a1\uff0c\u56e2\uff1b\u5806\uff1b 2.\u603b\u91cf\uff0c\u5168\u4f53\uff1b\u7fa4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 625,
    word: "s\u00e9parer",
    phonetic: "[separe]",
    type: "",
    translation: "v.t. \u4f7f\u5206\u5f00\uff0c\u4f7f\u5206\u79bb\uff1b\u9694\u5f00\uff0c\u5206\u9694 adv. \u5982\u6b64\uff0c\u90a3\u4e48\u591a\uff0c \u5230\u8fd9\u822c\u7a0b\u5ea6\uff1b\u90a3\u4e48\u2026\u4ee5\u81f3\u4e8e\uff0c \u5982",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 626,
    word: "tant",
    phonetic: "[t\u0251\u0303]",
    type: "",
    translation: "\u6b64\u2026\u4ee5\u81f3\u4e8e n.m. \u6c99\u6f20\uff1b\u8352\u65e0\u4eba\u70df\u7684\u5730\u65b9\uff1b\u504f\u50fb\u7684\u5730\u65b9\uff1ba. \u8352\u65e0\u4eba\u70df",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 627,
    word: "d\u00e9sert",
    phonetic: "[dez\u03b5r, -t]",
    type: "",
    translation: "\u7684\uff0c\u8352\u51c9\u7684\uff1b\u51b7\u6e05\u7684\uff0c\u50fb\u9759\u7684 v.t.\uff0c v.pr. 1.\u4e0b\u964d\uff0c\u964d\u4f4e\uff0c 2.\u58f0\u97f3\u7b49\u51cf\u5f31\uff0c 3.\u8870\u9000\uff0c\u8dcc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 628,
    word: "baisser",
    phonetic: "[bese]",
    type: "",
    translation: "ou [b\u03b5se] \u4ef7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 629,
    word: "retirer",
    phonetic: "[r(\u0259)tire]",
    type: "",
    translation: "v.t. \u62bd\u51fa\uff0c\u62d4\u51fa\uff1b\u53d6\u56de\uff0c\u9886\u56de\uff1b\u53d6\u51fa\uff1b\u64a4\u9500\uff0c\u64a4\u56de",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 630,
    word: "fortune",
    phonetic: "[f\u0254rtyn]",
    type: "",
    translation: "n.f. \u8d22\u4ea7\uff0c\u8d22\u5bcc\uff1b\u547d\u8fd0\uff1b\u597d\u8fd0\uff1b\u6076\u8fd0 n.f. \u81ea\u7136\uff08\u754c\uff09\uff1b\u672c\u6027\uff0c\u672c\u8d28\uff1b\u6027\u683c\uff0c\u6027\u60c5\uff1b\u5b9e\u7269[\u4e0e\u8d27",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 631,
    word: "nature",
    phonetic: "[natyr]",
    type: "",
    translation: "\u5e01\u76f8\u5bf9\u800c\u8a00]",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 632,
    word: "neige",
    phonetic: "[n\u03b5\u0292]",
    type: "",
    translation: "n.f. \u96ea\uff1b\u6ed1\u96ea\u7ad9\uff1b\u6ed1\u96ea\u8fd0\u52a8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 633,
    word: "coucher",
    phonetic: "[ku\u222be]",
    type: "",
    translation: "v.t. \u4f7f\u4e0a\u5e8a\u7761\u4e0b\uff1b\u4f7f\u8eba\u4e0b\uff1b\u4f7f\u5e73\u653e\uff0c\u628a\u2026\u2026\u653e\u5012",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 634,
    word: "revenu",
    phonetic: "[r\u0259vny]",
    type: "",
    translation: "n.m. \u6536\u5165\uff0c\u6536\u76ca",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 635,
    word: "suite",
    phonetic: "[s\u0265it]",
    type: "",
    translation: "n.f. \u7ee7\u7eed\uff0c\u4e00\u7cfb\u5217\uff1b\u987a\u5e8f\uff1b\u8fde\u8d2f\uff1b\u540e\u679c\uff1b\u540e\u7eed\u90e8\u5206",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 636,
    word: "deviner",
    phonetic: "[d\u0259vine]",
    type: "",
    translation: "v.t. \u731c\u5230\uff0c\u731c\u4e2d\uff1b\u731c\u6d4b\uff0c\u63a8\u6d4b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 637,
    word: "voyageur",
    phonetic: "[vwaja\u0292\u0153r]",
    type: "",
    translation: "n. \u65c5\u884c\u8005\uff1b\u65c5\u5ba2\uff0c\u4e58\u5ba2\uff1b\u65c5\u884c\u5bb6\uff1b\u6e38\u5ba2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 638,
    word: "instant",
    phonetic: "[\u025b\u0303st\u0251\u0303]",
    type: "",
    translation: "a. \u7d27\u8feb\u7684\uff0c\u8feb\u5207\u7684\uff0c\u7d27\u6025\u7684\uff1bn.m. \u77ac\u95f4\uff0c\u77ac\u65f6\uff0c\u9877\u523b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 639,
    word: "satisfaction",
    phonetic: "[satisfaksj\u0254\u0303]",
    type: "",
    translation: "n.f. \u6ee1\u610f\uff0c\u6ee1\u8db3\uff1b\u9ad8\u5174\uff0c\u6109\u5feb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 640,
    word: "interrompre",
    phonetic: "[\u025b\u0303t\u03b5r\u0254\u0303pr]",
    type: "",
    translation: "v.t. \u4f7f\u4e2d\u65ad\uff0c\u4e2d\u6b62\uff1b\u4f7f\u505c\u6b62 v.t. \u5f3a\u884c\u5f04\u5f00\uff0c\u7528\u529b\u7834\u574f\uff1b\u5f3a\u884c\u593a\u53d6\uff1b\u5f3a\u5236\u83b7\u5f97\uff1b\u903c\u8feb\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 641,
    word: "forcer",
    phonetic: "[f\u0254rse]",
    type: "",
    translation: "\u5f3a\u8feb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 642,
    word: "banc",
    phonetic: "[b\u0251\u0303]",
    type: "",
    translation: "n.m. \u957f\u51f3\uff0c\u957f\u6905\uff1b\u5e2d\u4f4d v.t. \u4f7f\u518d\u63a5\u5408\uff1b\u548c\u2026\u2026\u76f8\u63a5\uff1b\u91cd\u65b0\u52a0\u5165\uff1b\u548c\u2026\u2026\u91cd\u805a\uff1b\u91cd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 643,
    word: "rejoindre",
    phonetic: "[r(\u0259)\u0292w\u025b\u0303dr]",
    type: "",
    translation: "\u8fd4\uff0c\u56de\u5230\uff1b\u8d76\u4e0a\uff0c\u8ffd\u4e0a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 644,
    word: "perdu",
    phonetic: "[p\u03b5rdy]",
    type: "",
    translation: "adj. \u5931\u53bb\u7684\uff1b\u9519\u8fc7\u7684\uff1b\u8ff7\u8def\u7684\uff1b\u6ca1\u6709\u5e0c\u671b\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 645,
    word: "envoyer",
    phonetic: "[\u0251\u0303vwaje]",
    type: "",
    translation: "v.t. \u6d3e\u9063\uff0c\u6d3e\u9001\uff1b\u90ae\uff0c\u5bc4\uff0c\u53d1\u9001\uff1b\u6254\uff0c\u63b7\uff0c\u629b\uff0c\u4e22\uff1b\u53d1\u5c04",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 646,
    word: "durer",
    phonetic: "[dyre]",
    type: "",
    translation: "v.i. \u6301\u7eed\uff0c\u5ef6\u7eed\uff1b\u6301\u7eed\u5f88\u4e45\uff0c\u62d6\u5ef6\u5f88\u957f\u65f6\u95f4\uff1b\u6301\u4e45\uff1b\u4fdd\u6301",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 647,
    word: "certainement",
    phonetic: "[s\u03b5rt\u03b5nm\u0251\u0303]",
    type: "",
    translation: "adv. \u80af\u5b9a\u5730\uff0c\u4e00\u5b9a\u5730\uff1b\u786e\u5b9e\u5730\uff0c\u5f53\u7136",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 648,
    word: "garder",
    phonetic: "[garde]",
    type: "",
    translation: "v.t. \u4fdd\u5b58\uff0c\u50a8\u85cf\uff1b\u770b\u7ba1\uff1b\u770b\u5b88\uff1b\u5b88\u536b\uff1b\u4fdd\u7559\uff1b\u4fdd\u6301",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 649,
    word: "fournir",
    phonetic: "[furnir]",
    type: "",
    translation: "v.t. \u4f9b\u5e94\uff0c\u4f9b\u7ed9\uff1b\u7ed9\uff1b\u63d0\u4f9b\uff1b\u51fa\u4ea7\uff1b\u4ed8\u51fa v.t. \u653e\u56de\uff1b\u9001\u56de\uff1b\u4f7f\u6062\u590d\u539f\u4f4d\uff0c\u4f7f\u91cd\u65b0\u5904\u4e8e\u2026\u2026\uff1b\u91cd\u65b0\u7a7f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 650,
    word: "remettre",
    phonetic: "[r(\u0259)m\u03b5tr]",
    type: "",
    translation: "\u4e0a\uff0c\u91cd\u65b0\u6234\u4e0a\uff1b\u518d\u914d\uff0c\u518d\u8865\uff0c\u518d\u52a0\uff0c\u518d\u6dfb\uff1b\u9001\u4ea4\uff1b\u63a8\u8fdf\uff1b \u62d6\u5ef6 v.t. \u62c9\uff0c\u7275\uff0c\u62d6\uff1b\u53d1\u5c04\uff1b\u5f00\u67aa\u5c04\u51fb\uff1b\u62bd\u51fa\uff1b\u4f7f\u6446\u8131\uff1b\u5f97",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 651,
    word: "tirer",
    phonetic: "[tire]",
    type: "",
    translation: "\u5230\uff1b\u63d0\u53d6\uff0c\u62bd\u53d6\uff1b\u63a8\u65ad\u51fa\uff1b\u62bd\uff08\u7b7e\uff09\uff0c\u6478\uff08\u5f69\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 652,
    word: "salle",
    phonetic: "[sal]",
    type: "",
    translation: "n.f. \u623f\u95f4\uff1b\u5ba2\u5385\uff1b\u5385\uff0c\u5ba4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 653,
    word: "poliment",
    phonetic: "[p\u0254lim\u0251\u0303]",
    type: "",
    translation: "adv. \u793c\u8c8c\u5730\uff0c\u5f6c\u5f6c\u6709\u793c\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 654,
    word: "honneur",
    phonetic: "[\u0254n\u0153r]",
    type: "",
    translation: "n.m. \u8363\u8a89\uff1b\u5c0a\u4e25\uff0c\u81ea\u5c0a\uff1b\u540d\u8a89\uff1b\u5149\u8363\uff1b\u5c0a\u656c\uff0c\u656c\u610f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 655,
    word: "presser",
    phonetic: "[pr\u03b5se]",
    type: "",
    translation: "v.t. \u538b\u69a8\uff0c\u6324\uff1b\u538b\uff0c\u6309\uff0c\u63ff\uff1b\u50ac\u4fc3\uff1b\u52a0\u901f\uff0c\u52a0\u5feb 18 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. v.i. \u518d\u4e0a\uff0c\u91cd\u65b0\u767b\u4e0a\uff1b\u91cd\u65b0\u5317\u4e0a\uff1b\u91cd\u65b0\u4e0a\u5347\uff1b\u56de\u6da8\uff0c\u91cd\u65b0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 656,
    word: "remonter",
    phonetic: "[r(\u0259)m\u0254\u0303te]",
    type: "",
    translation: "\u4e0a\u6da8\uff1b\u8ffd\u6eaf\uff0c\u56de\u6eaf\uff1b\u8d77\u59cb\u4e8e\uff1bv.t. \u91cd\u767b\uff0c\u518d\u4e0a\uff1b\u91cd\u65b0\u5f80\u4e0a \u642c\uff1b\u63d0\u9ad8\uff0c\u4f7f\u589e\u9ad8\uff1b\u4f7f\u7cbe\u795e\u632f\u4f5c\uff1b\u91cd\u65b0\u88c5\u914d n.f. \u4ef7\u503c\uff1b\u4ef7\u683c\uff1b\u624d\u80fd\uff1b\u6709\u6548\uff0c\u6709\u6548\u6027\uff1b[\u6570]\u503c\uff1bpl. \u51c6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 657,
    word: "valeur",
    phonetic: "[val\u0153r]",
    type: "",
    translation: "\u5219\uff0c\u6807\u51c6\uff1b\u82f1\u52c7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 658,
    word: "saint",
    phonetic: "[s\u025b\u0303, -t]",
    type: "",
    translation: "a. \u795e\u5723\u7684\uff1b\u5723\u6d01\u7684\uff1b\u5723\u7684\uff1bn. \u5723\u4eba\uff0c\u5723\u5f92 n.m. \u4f7f\u7528\uff0c\u5e94\u7528\uff1b\uff08\u5b98\u80fd\u7b49\u7684\uff09\u8fd0\u7528\uff1b\u7528\u9014\uff1b\u60ef\u4f8b\uff1b\u7528",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 659,
    word: "usage",
    phonetic: "[yza\u0292]",
    type: "",
    translation: "\u6cd5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 660,
    word: "avance",
    phonetic: "[av\u0251\u0303s]",
    type: "",
    translation: "n.f. \u524d\u8fdb\uff1b\u63d0\u524d\uff0c\u63d0\u65e9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 661,
    word: "rail",
    phonetic: "[r\u0251j]",
    type: "",
    translation: "n.m. \u94c1\u8f68\uff0c\u94a2\u8f68\uff1b\u8f68\u9053\uff1b\u94c1\u8def",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 662,
    word: "reconnaissance",
    phonetic: "[r\u0259k\u0254n\u03b5s\u0251\u0303s]",
    type: "",
    translation: "n.f. \u8ba4\u8bc6\uff0c\u8ba4\u51fa\uff1b\u627f\u8ba4\uff0c\u786e\u8ba4\uff1b\u4fa6\u5bdf\uff1b\u611f\u6fc0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 663,
    word: "grimace",
    phonetic: "[grimas]",
    type: "",
    translation: "n.f. \u9b3c\u8138\uff0c\u602a\u76f8 adv. \u5408\u4e4e\u81ea\u7136\u89c4\u5f8b\u5730\uff1b\u5929\u7136\u5730\uff1b\u5fc5\u7136\u5730\uff1b\u5f53\u7136\uff1b\u751f\u6765\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 664,
    word: "naturellement",
    phonetic: "[natyr\u03b5lm\u0251\u0303]",
    type: "",
    translation: "\u81ea\u7136\u5730\uff0c\u4e0d\u52a0\u505a\u4f5c\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 665,
    word: "loi",
    phonetic: "[lwa]",
    type: "",
    translation: "n.f. \u6cd5\uff0c\u6cd5\u5f8b\uff1b[\u5b97]\u6212\u5f8b\uff1b\u89c4\u5219\uff1b\u6cd5\u5219\uff1b\u89c4\u5f8b\uff0c\u5b9a\u5f8b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 666,
    word: "acte",
    phonetic: "[akt]",
    type: "",
    translation: "n.m. \u884c\u52a8\uff0c\u52a8\u4f5c\uff0c\u884c\u4e3a\uff1b\u8bc1\u4e66\uff1b\u6587\u4ef6\uff1b\u5951\u7ea6\uff1b[\u5267]\u5e55",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 667,
    word: "violence",
    phonetic: "[vj\u0254l\u0251\u0303s]",
    type: "",
    translation: "n.f. \u731b\u70c8\uff0c\u6fc0\u70c8\uff1b\u66b4\u529b\uff0c\u5f3a\u66b4\uff1b\u7c97\u66b4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 668,
    word: "fil",
    phonetic: "[fil]",
    type: "",
    translation: "n.m. \u7eb1\uff1b\u7ebf\uff1b\u4e1d\uff1b\u5bfc\u7ebf\uff0c\u7535\u7ebf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 669,
    word: "for\u00eat",
    phonetic: "[f\u0254r\u03b5]",
    type: "",
    translation: "n.f. \u6797\uff0c\u68ee\u6797\uff1b\u6797\u7acb pr\u00e9p.\uff0c adv. \u90a3\u662f\uff0c\u90a3\u5c31\u662f\uff1b\u8fd9\u662f\uff0c\u8fd9\u5c31\u662f\uff1b\u4ee5\u4e0a\u5c31",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 670,
    word: "voil\u00e0",
    phonetic: "[vwala]",
    type: "",
    translation: "\u662f\uff0c\u4e0a\u9762\u5c31\u662f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 671,
    word: "tenter",
    phonetic: "[t\u0251\u0303te]",
    type: "",
    translation: "v.t. \u8bd5\u56fe\uff0c\u5c1d\u8bd5\uff1b\u5f15\u8bf1\uff0c\u52fe\u5f15\uff0c\u5438\u5f15",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 672,
    word: "campagne",
    phonetic: "[k\u0251\u0303pa\u0272]",
    type: "",
    translation: "n.f. \u539f\u91ce\uff1b\u519c\u6751\uff0c\u4e61\u6751\uff1b\u51fa\u5f81\uff0c\u6218\u5f79\uff1b\u6d3b\u52a8\uff1b\u8fd0\u52a8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 673,
    word: "hauteur",
    phonetic: "[ot\u0153r]",
    type: "",
    translation: "\u865a\u97f3H n.f. \u9ad8\uff0c\u9ad8\u5ea6\uff1b\u6d77\u62d4\uff1b\u9ad8\u5730\uff1b\u9ad8\u8d85\uff1b\u9ad8\u5c1a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 674,
    word: "quartier",
    phonetic: "[kartje]",
    type: "",
    translation: "n.m. \u56db\u5206\u4e4b\u4e00\u90e8\u5206\uff1b\u5757\uff0c\u7247\uff1b\u8857\u533a\uff1b\u533a\uff1b\u4f4f\u5b85\u533a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 675,
    word: "nombreux",
    phonetic: "[n\u0254\u0303br\u00f8]",
    type: "",
    translation: "a. \u4e3a\u6570\u4f17\u591a\u7684\uff1b\u8bb8\u591a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 676,
    word: "surtout",
    phonetic: "[syrtu]",
    type: "",
    translation: "adv. \u7279\u522b\uff1b\u5c24\u5176 n.f. 1.\u900f\u89c6\uff1b\u666f\u8272\uff1b\u5c55\u671b\uff1b 2.\u524d\u666f\uff1b 3.\u89c2\u70b9\uff0c\u89d2\u5ea6\uff0c\u773c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 677,
    word: "perspective",
    phonetic: "[p\u03b5rsp\u03b5ktiv]",
    type: "",
    translation: "\u5149",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 678,
    word: "heureusement",
    phonetic: "[\u0153r\u00f8zm\u0251\u0303]",
    type: "",
    translation: "adv. \u5b8c\u6ee1\u5730\uff1b\u5e78\u597d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 679,
    word: "\u00e9motion",
    phonetic: "[emosj\u0254\u0303]",
    type: "",
    translation: "n.f. \u611f\u52a8\uff0c\u6fc0\u52a8\uff1b\u611f\u60c5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 680,
    word: "assurer",
    phonetic: "[asyre]",
    type: "",
    translation: "v.t. \u4fdd\u969c\uff1b\u6295\u4fdd\uff1b\u4fdd\u8bc1\uff1b\u80af\u5b9a\uff1b\u786e\u4fdd\uff1b\u4f7f\u7a33\u56fa v.t. \u62d6\uff0c\u62c9\uff0c\u66f3\uff1b\u5e26\u7740\uff0c\u9886\u7740\uff1b\u786c\u62c9\uff0c\u786c\u62d6\uff1bv.i. \u62d6\u5728\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 681,
    word: "tra\u00eener",
    phonetic: "[trene]",
    type: "",
    translation: "[tr\u03b5ne] \u4e0a\uff1b\u4e0b\u5782\uff1b\u62d6\u5ef6\uff1b\u4e45\u75c5\u4e0d\u6108\uff1b\uff08\u58f0\u97f3\uff09\u62d6\u957f\uff1b\u5230\u5904\u4e71\u6254\u4e71 \u653e\uff1b\u843d\u5728\u540e\u9762\uff1b\u884c\u52a8\u8fdf\u7f13",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 682,
    word: "visage",
    phonetic: "[viza\u0292]",
    type: "",
    translation: "n.m. \u8138\uff0c\u9762\u5b54\uff1b\u4eba\uff1b\u9762\u5bb9\uff0c\u8138\u8272\uff1b\u9762\u8c8c\uff0c\u5916\u89c2 v.t. \u7559\u75d5\u8ff9\uff1b\u7559\u4e0b\u5370\u8bb0\uff1b\u505a\u8bb0\u53f7\uff1b\u8bb0\u5f55\uff1b\uff08\u4eea\u5668\uff09\u6307\u793a\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 683,
    word: "marquer",
    phonetic: "[marke]",
    type: "",
    translation: "\u8868\u793a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 684,
    word: "dent",
    phonetic: "[d\u0251\u0303]",
    type: "",
    translation: "n.f. \u7259\uff0c\u7259\u9f7f\uff1b\u9f7f\u72b6\u7269",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 685,
    word: "retentir",
    phonetic: "[r\u0259t\u0251\u0303tir]",
    type: "",
    translation: "v.i. \u5145\u6ee1\u54cd\u58f0\uff0c\u4ea7\u751f\u56de\u54cd\uff1b\u56de\u8361\uff1b\u4ea7\u751f\u53cd\u54cd\uff0c\u5f15\u8d77\u53cd\u5e94 a. \u60b2\u4f24\u7684\uff1b\u5fe7\u6101\u7684\uff1b\u4ee4\u4eba\u96be\u8fc7\u7684\uff0c\u60b2\u60e8\u7684\uff1b\u9634\u6697\u7684\uff0c\u9634",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 686,
    word: "triste",
    phonetic: "[trist]",
    type: "",
    translation: "\u6c89\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 687,
    word: "\u00e9prouver",
    phonetic: "[epruve]",
    type: "",
    translation: "v.t. \u8bd5\u9a8c\uff0c\u68c0\u9a8c\uff1b\u8003\u9a8c\uff1b\u4f7f\u906d\u53d7\u82e6\u96be\uff1b\u4f53\u9a8c\u5230",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 688,
    word: "causer",
    phonetic: "[koze]",
    type: "",
    translation: "v.t. \u5f15\u8d77\uff0c\u9020\u6210\uff1bv.i. \u4ea4\u8c08\uff0c\u95f2\u8c08",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 689,
    word: "para\u00eetre",
    phonetic: "[par\u03b5tr]",
    type: "",
    translation: "v.i. \u51fa\u73b0\uff0c\u9732\u51fa\uff1b\u9732\u9762\uff0c\u5230\u6765\uff1b\u51fa\u7248\uff0c\u53d1\u8868\uff1b\u597d\u50cf\uff0c\u663e\u5f97",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 690,
    word: "d\u00e9penser",
    phonetic: "[dep\u0251\u0303se]",
    type: "",
    translation: "v.t. \u7528\uff08\u94b1\uff09\uff0c\u82b1\uff08\u94b1\uff09\uff1b\u6d88\u8017\uff1b\u8017\u8d39\uff0c\u82b1\u8d39",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 691,
    word: "meeting",
    phonetic: "[miti\u014b]",
    type: "",
    translation: "n.m. \u96c6\u4f1a\uff0c\u4f1a\u8bae\uff0c\u4f1a\uff1b\u8fd0\u52a8\u4f1a\uff0c\u6f14\u793a\u4f1a 19 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. n. 1.\u76ee\u51fb\u8005\uff0c \u76ee\u7779\u8005\uff1b 2.\u65c1\u89c2\u8005\u89c2\u4f17\uff08\u827a\u672f\u54c1\u6216\u5efa\u7b51\u7269",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 692,
    word: "spectateur",
    phonetic: "[sp\u03b5ktat\u0153r]",
    type: "",
    translation: "\u7684\uff09\u53c2 \u89c2\u8005 n.f. \u5f04\u788e\uff0c\u6253\u788e\uff0c\u5f04\u65ad\uff1b\u5f04\u788e\u7684\u4e1c\u897f\uff0c\u6253\u788e\u7684\u4e1c\u897f\uff0c\u5f04\u65ad",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 693,
    word: "casse",
    phonetic: "[kas]",
    type: "",
    translation: "\u7684\u4e1c\u897f v.t.\uff08\u7a81\u7136\uff09\u53d1\u73b0\uff0c\u53d1\u89c9\uff0c\u770b\u51fa\uff1b\u901a\u77e5\uff0c\u544a\u77e5\uff1bv.i. \u8003",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 694,
    word: "aviser",
    phonetic: "[avize]",
    type: "",
    translation: "\u8651\uff0c\u601d\u8003",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 695,
    word: "apercevoir",
    phonetic: "[ap\u03b5rs\u0259vwar]",
    type: "",
    translation: "v.t. \u89c9\u5bdf\uff0c\u8bc6\u522b\uff1b\u77a5\u89c1\uff0c\u9690\u7ea6\u770b\u89c1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 696,
    word: "erreur",
    phonetic: "[\u03b5r\u0153r]",
    type: "",
    translation: "ou [er\u0153r] n.f. \u9519\u8bef\uff0c\u8c2c\u8bef\uff1b\u8fc7\u9519\uff1b\u8c2c\u8bba\uff1b\u8bef\u5dee\uff0c\u504f\u5dee",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 697,
    word: "craindre",
    phonetic: "[kr\u025b\u0303dr]",
    type: "",
    translation: "v.t. \u62c5\u5fc3\uff1b\u5bb3\u6015\uff1b\u5bf9\u2026\u2026\u654f\u611f\uff1b\u6297\u4e0d\u4f4f\uff0c\u8010\u4e0d\u4f4f v.i. \u518d\u8dcc\u5012\uff0c\u518d\u843d\u4e0b\uff1b\u91cd\u65b0\u9677\u5165[\u6307\u56f0\u5883\u7b49]\uff1b\u56de\u590d\u5230[\u6307\u67d0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 698,
    word: "retomber",
    phonetic: "[r\u0259t\u0254\u0303be]",
    type: "",
    translation: "\u79cd\u72b6\u6001]\uff1b\u6d88\u5931\uff1b\u51cf\u5f31\uff0c\u51cf\u9000\uff1b\u843d\u5230\u67d0\u4eba\u5934\u4e0a\uff0c\uff08\u8d23\u4efb \u7b49\uff09\u7531\u67d0\u4eba\u8d1f\u62c5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 699,
    word: "l\u00e8vre",
    phonetic: "[l\u03b5vr]",
    type: "",
    translation: "n.f. \u5507\uff0c\u5634\u5507 v.t.\uff0c v.pr. 1.\u70b9\u706b\uff0c\u70b9\u71c3\u70b9\u4eae\uff1b\u7167\u4eae 2.\u6fc0\u8d77\uff0c\u5f15\u8d77\uff0c\u60f9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 700,
    word: "allumer",
    phonetic: "[alyme]",
    type: "",
    translation: "\u8d77 3.\u6253\u5f00\uff08\u6696\u6c14\uff0c\u6536\u97f3\u673a\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 701,
    word: "prier",
    phonetic: "[prije]",
    type: "",
    translation: "v.t. [\u5b97]\u5411\u2026\u2026\u7948\u7977\uff1b\u6073\u6c42\uff0c\u8bf7\u6c42",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 702,
    word: "plut\u00f4t",
    phonetic: "[plyto]",
    type: "",
    translation: "adv. \u5b81\u53ef\uff0c\u5b81\u613f\uff1b\u4e0e\u5176\u2026\u2026\u5012\u4e0d\u5982\uff1b\u6709\u70b9\u513f\uff1b\u76f8\u5f53\uff0c\u633a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 703,
    word: "lecture",
    phonetic: "[l\u03b5ktyr]",
    type: "",
    translation: "n.f. \u9605\u8bfb\uff0c\u9605\u89c8\uff1b\u6717\u8bfb\uff0c\u5ba3\u8bfb\uff1b\u89e3\u8bfb\uff1b\u8bfb\u7269",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 704,
    word: "d\u00e9sir",
    phonetic: "[dezir]",
    type: "",
    translation: "n.m. \u8981\u6c42\uff1b\u613f\u671b\uff0c\u6b32\u671b\uff1b\u6027\u6b32",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 705,
    word: "habitude",
    phonetic: "[abityd]",
    type: "",
    translation: "n.f. \u4e60\u60ef\uff0c\u4e60\u4fd7\uff0c\u60ef\u4f8b\uff1b\u719f\u7ec3\uff0c\u7ecf\u9a8c\uff0c\u719f\u6089",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 706,
    word: "contenter",
    phonetic: "[k\u0254\u0303t\u0251\u0303te]",
    type: "",
    translation: "v.t. \u4f7f\u9ad8\u5174\uff0c\u4f7f\u5feb\u4e50\uff1b\u4f7f\u6ee1\u610f\uff0c\u4f7f\u6ee1\u8db3 a. \u76f8\u90bb\u7684\uff0c\u90bb\u8fd1\u7684\uff1b\u76f8\u8fd1\u7684\uff0c\u76f8\u4f3c\u7684\uff1bn. \u90bb\u5c45\uff1b\u90bb\u5ea7\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 707,
    word: "voisin",
    phonetic: "[vwaz\u025b\u0303, -in]",
    type: "",
    translation: "\u4eba\uff1b\u90bb\u56fd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 708,
    word: "br\u00fbler",
    phonetic: "[bryle]",
    type: "",
    translation: "v.t. \u711a\u70e7\uff0c\u70e7\u6bc1\uff1b\u70e7\u7126\uff1b\u70eb\u4f24\uff0c\u70e7\u4f24",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 709,
    word: "victime",
    phonetic: "[viktim]",
    type: "",
    translation: "n.f. \u53d7\u5bb3\u8005\uff1b\u727a\u7272\u8005\uff1b\u906d\u96be\u8005\uff1b\u6b7b\u4ea1\u8005",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 710,
    word: "facile",
    phonetic: "[fasil]",
    type: "",
    translation: "a. \u5bb9\u6613\u7684\uff0c\u65b9\u4fbf\u7684\uff1b\u6d41\u5229\u7684\uff0c\u6d41\u7545\u7684\uff1b\u968f\u548c\u7684\uff0c\u5bbd\u5bb9\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 711,
    word: "v\u00e9ritable",
    phonetic: "[veritabl]",
    type: "",
    translation: "a. \u771f\u5b9e\u7684\uff0c\u786e\u5b9e\u7684\uff1b\u771f\u7684\uff1b\u771f\u6b63\u7684[\u6307\u540d\u526f\u5176\u5b9e\u7684] v.t. \u4f7f\u56fa\u5b9a\uff0c\u4f7f\u4e0d\u52a8\uff1b\u4f7f\u5b9a\u5c45\uff1b\u5b89\u7f6e\uff1b\u4f7f\u505c\u7559\uff1b\u786e\u5b9a\uff0c\u89c4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 712,
    word: "fixer",
    phonetic: "[fikse]",
    type: "",
    translation: "\u5b9a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 713,
    word: "chacun",
    phonetic: "[\u222bak\u0153\u0303]",
    type: "",
    translation: "pron.ind\u00e9f. \u5404\u4eba\uff0c\u6bcf\u4e2a\u4eba\uff1b\u6bcf\u4e00\u4e2a\uff1b\u5404\u7269",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 714,
    word: "offrir",
    phonetic: "[\u0254frir]",
    type: "",
    translation: "v.t. \u8d60\u9001\uff0c\u63d0\u4f9b\uff1b\u63d0\u51fa\uff1b\u663e\u793a v.i. \u98de\uff0c\u98de\u7fd4\uff1b\u98de\u884c\uff1b\u98de\u821e\uff1bv.t. \u5077\u7a83\uff0c\u62a2\u52ab\uff1b\u8bc8\u9a97\uff1b\u5bb0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 715,
    word: "voler",
    phonetic: "[v\u0254le]",
    type: "",
    translation: "\u4eba\uff0c\u83b7\u66b4\u5229",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 716,
    word: "toile",
    phonetic: "[twal]",
    type: "",
    translation: "n.f. \u5e03\uff0c \u753b\u5e03\uff0c \u753b\uff0c \u5e03\u666f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 717,
    word: "parfum",
    phonetic: "[parf\u0153\u0303]",
    type: "",
    translation: "n.m. \u82b3\u9999\uff0c\u9999\u5473\uff1b\u9999\u6599\uff0c\u9999\u6c34\uff1b\u9999\u7cbe",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 718,
    word: "promenade",
    phonetic: "[pr\u0254mnad]",
    type: "",
    translation: "n.f. \u6563\u6b65\uff1b\u6e9c\u8fbe\uff0c\u95f2\u901b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 719,
    word: "costume",
    phonetic: "[k\u0254stym]",
    type: "",
    translation: "n.m. \u670d\u88c5\uff1b\u7537\u5f0f\uff08\u6210\u5957\uff09\u897f\u670d v.t. \u5173\u95ed\uff0c\u5c01\u95ed\uff0c\u5835\u585e\uff1b\uff08\u7528\u5899\u7b49\uff09\u56f4\u4f4f\uff1b\u4f7f\u505c\u6b62\uff0c\u4f7f\u7ed3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 720,
    word: "clore",
    phonetic: "[kl\u0254r]",
    type: "",
    translation: "\u675f v.t. \u5e26\u8d70\uff0c\u62ff\u8d70\uff0c\u8fd0\u8d70\uff1b\u593a\u8d70\uff0c\u593a\u53bb\uff1b\u51b2\u8d70\uff0c\u5377\u8d70\uff1b\u4f7f\u65e0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 721,
    word: "emporter",
    phonetic: "[\u0251\u0303p\u0254rte]",
    type: "",
    translation: "\u6cd5\u81ea\u5236",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 722,
    word: "conscience",
    phonetic: "[k\u0254\u0303sj\u0251\u0303s]",
    type: "",
    translation: "n.f. \u610f\u8bc6\uff0c\u77e5\u89c9\uff0c\u826f\u5fc3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 723,
    word: "demeurer",
    phonetic: "[d\u0259m\u0153re]",
    type: "",
    translation: "v.i. \u9017\u7559\uff0c\u505c\u7559\uff1b\u5c45\u4f4f\uff1b\u7ee7\u7eed\u5b58\u5728\uff1b\u4f9d\u7136\u662f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 724,
    word: "moindre",
    phonetic: "[mw\u025b\u0303dr]",
    type: "",
    translation: "a. \u8f83\u5c0f\u7684\uff1b\u8f83\u5c11\u7684\uff1b\u8f83\u5f31\u7684\uff1b\u6700\u5c0f\u7684\uff1b\u6700\u5c11\u7684\uff1b\u6700\u5f31\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 725,
    word: "parfois",
    phonetic: "[parfwa]",
    type: "",
    translation: "adv. \u6709\u65f6\u5019\uff0c\u6709\u65f6\uff0c\u5f80\u5f80 v.t. \u5e26\u6765\uff0c\u9886\u6765\uff1b\u9001\u2026\u2026\u5230\uff08\u67d0\u5730\uff09\uff0c\u8fd0\u2026\u2026\u5230\uff08\u67d0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 726,
    word: "amener",
    phonetic: "[amne]",
    type: "",
    translation: "\u5730\uff09\uff1b\u4fc3\u4f7f\uff08\u67d0\u4eba\u505a\u67d0\u4e8b\uff09\uff1b\u5bfc\u81f4\uff0c\u9020\u6210",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 727,
    word: "sort",
    phonetic: "[s\u0254r]",
    type: "",
    translation: "n.m. \u547d\u8fd0\uff1b\u5883\u9047\uff1b\u8fd0\u6c14\uff0c\u673a\u7f18 20 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 728,
    word: "\u00e9viter",
    phonetic: "[evite]",
    type: "",
    translation: "v.t. \u907f\u514d\uff1b\u514d\u9664\uff0c\u4f7f\u907f\u514d\uff1b\u8eb2\u907f\uff08\u67d0\u4eba\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 729,
    word: "v\u00e9rit\u00e9",
    phonetic: "[verite]",
    type: "",
    translation: "n.f. \u771f\u7406\uff1b\u771f\u5b9e\uff08\u6027\uff09\uff1b\u771f\u76f8\uff1b\u771f\u8bdd a. \u5feb\u7684\uff1b\u8fc5\u901f\u7684\uff0c\u5306\u5fd9\u7684\uff1b\u654f\u6377\u7684\uff1b\u901f\u6210\u7684\uff1bn.m. \u7279\u5feb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 730,
    word: "rapide",
    phonetic: "[rapid]",
    type: "",
    translation: "\u5217\u8f66",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 731,
    word: "employer",
    phonetic: "[\u0251\u0303plwaje]",
    type: "",
    translation: "v.t. \u4f7f\u7528\uff0c\u5229\u7528\uff1b\u96c7\u7528\uff0c\u4efb\u7528",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 732,
    word: "conserver",
    phonetic: "[k\u0254\u0303s\u03b5rve]",
    type: "",
    translation: "v.t. \u4fdd\u5b58\uff0c\u8d2e\u85cf\uff1b\u4fdd\u7ba1\uff1b\u4fdd\u6301\uff0c\u4fdd\u7559 a. \u672c\u4eba\u7684\uff0c\u81ea\u5df1\u7684\uff1b\u7279\u6709\u7684\uff1b\u672c\u6765\u7684\uff0c\u56fa\u6709\u7684\uff1b\u6e05\u6d01",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 733,
    word: "propre",
    phonetic: "[pr\u0254pr]",
    type: "",
    translation: "\u7684\uff0c\u5e72\u51c0\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 734,
    word: "agir",
    phonetic: "[a\u0292ir]",
    type: "",
    translation: "v.i. \u884c\u52a8\uff0c\u5e72\uff1b\u8d77\u4f5c\u7528\uff0c\u4ea7\u751f\u529f\u6548\uff1b\u8868\u73b0\uff0c\u884c\u4e3a\uff0c\u4e3e\u6b62 a. \u786c\u7684\uff1b\u8d39\u52b2\u7684\uff1b\u56f0\u96be\u7684\uff1b\u96be\u89e3\u51b3\u7684\uff1b\u4e25\u5389\u7684\uff0c\u4e25\u9177",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 735,
    word: "dur",
    phonetic: "[dyr]",
    type: "",
    translation: "\u7684\uff0c\u4e25\u5cfb\u7684\uff1b\u56f0\u82e6\u7684\uff1b\u51b7\u9177\u7684\uff0c\u65e0\u60c5\u7684 adv. \u5728\u5916\u8fb9\uff0c\u5728\u5916\u9762\uff1bn.m. \u5916\u90e8\uff0c\u5916\u9762\uff0c\u5916\u8868\uff1b\u5468\u56f4\u73af",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 736,
    word: "dehors",
    phonetic: "[d\u0259\u0254r]",
    type: "",
    translation: "\u5883",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 737,
    word: "maintenir",
    phonetic: "[m\u025b\u0303t(\u0259)nir]",
    type: "",
    translation: "v.t. \u7ef4\u6301\uff0c\u4fdd\u6301\uff1b\u7ef4\u62a4\uff1b\u652f\u6491\uff1b\u4f7f\u4fdd\u6301\u4e00\u5b9a\u72b6\u6001 n.m. \u4e00\u5757\uff0c\u4e00\u7247\uff0c\u4e00\u6bb5\uff1b\u4e00\u53e3\uff1b\uff08\u6587\u827a\u4f5c\u54c1\u7684\uff09\u7247\u6bb5\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 738,
    word: "morceau",
    phonetic: "[m\u0254rso]",
    type: "",
    translation: "[\u4e50]\u9009\u6bb5 v.t. \u4e3e\u8d77\uff0c\u63d0\u8d77\uff1b\u62ff\u8d70\uff0c\u642c\u8d70\uff1b\u9664\u53bb\uff1b\u8131\u6389\uff08\u8863\u670d\u7b49\uff09\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 739,
    word: "enlever",
    phonetic: "[\u0251\u0303lve]",
    type: "",
    translation: "\u4f7f\u4e27\u5931\uff0c\u5265\u593a\uff1b\u7ed1\u67b6\uff1b\u62d0\u8d70 v.i.\uff08\u98ce\uff09\u5439\uff0c\u522e\uff1b\u5439\u6c14\uff1b\u5598\u6c14\uff1b\u5c0f\u6b47\uff1bv.t. \u5439\uff1b\u5439\u6765\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 740,
    word: "souffler",
    phonetic: "[sufle]",
    type: "",
    translation: "\u51b2\u51fb\uff0c\u522e\u5012\uff1b\u4f4e\u58f0\u8bf4 v.t. \u6295\uff0c\u63b7\uff0c\u629b\uff0c\u53d1\u5c04\uff1b\u6325\uff0c\u8e22\uff1b\u7a81\u7136\u8bf4\u51fa\uff1b\u53d1\u884c\uff0c\u53d1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 741,
    word: "lancer",
    phonetic: "[l\u0251\u0303se]",
    type: "",
    translation: "\u51fa\uff1b\u4ece\u4e8b\uff0c\u521b\u529e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 742,
    word: "mesurer",
    phonetic: "[m\u0259zyre]",
    type: "",
    translation: "v.t. \u6d4b\u91cf\uff1b\u8861\u91cf\uff1b\u7cbe\u6253\u7ec6\u7b97\uff1bv.i. \u5c3a\u5bf8\u4e3a\uff0c\u5927\u5c0f\u4e3a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 743,
    word: "consid\u00e9rer",
    phonetic: "[k\u0254\u0303sidere]",
    type: "",
    translation: "v.t. \u7ec6\u770b\uff0c\u5bdf\u770b\uff1b\u8003\u8651\uff1b\u8ba4\u4e3a\uff1b\u5c0a\u91cd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 744,
    word: "autrement",
    phonetic: "[otr\u0259m\u0251\u0303]",
    type: "",
    translation: "adv. \u5426\u5219\uff0c\u4e0d\u7136\uff1b\u4e0d\u540c\uff0c\u4e0d\u4e00\u6837",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 745,
    word: "hier",
    phonetic: "[j\u03b5r]",
    type: "",
    translation: "adv. \u6628\u5929\uff0c\u6628\u65e5\uff1b\u8fd1\u6765\uff0c\u6700\u8fd1\uff0c\u8fc7\u53bb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 746,
    word: "jeu",
    phonetic: "[\u0292\u00f8]",
    type: "",
    translation: "n.m. \u6e38\u620f\uff0c\u73a9\u800d\uff0c\u5a31\u4e50\uff1b\u6bd4\u8d5b\uff1b\u8d4c\u535a\uff1b\u624b\u6bb5\uff0c\u8ba1\u8c0b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 747,
    word: "carte",
    phonetic: "[kart]",
    type: "",
    translation: "n.f. \u5361\u7247\uff0c\u8584\u7eb8\u677f\uff1b\u7eb8\u724c\uff1b\u8bc1\u4ef6\uff1b\u5730\u56fe",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 748,
    word: "attirer",
    phonetic: "[atire]",
    type: "",
    translation: "v.t. \u5438\uff0c\u62c9\uff1b\u5438\u5f15\uff1b\u5f15\u8d77\uff0c\u62db\u81f4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 749,
    word: "favoriser",
    phonetic: "[fav\u0254rize]",
    type: "",
    translation: "v.t. \u4f18\u5f85\uff1b\u7167\u987e\uff1b\u652f\u6301\uff1b\u4fc3\u8fdb\uff1b\u5e2e\u52a9\uff1b\u6709\u5229\u4e8e\uff0c\u6709\u52a9\u4e8e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 750,
    word: "trajet",
    phonetic: "[tra\u0292\u03b5]",
    type: "",
    translation: "n.m. \u884c\u7a0b\uff0c\u65c5\u7a0b\uff0c\u8def\u7a0b\uff1b\u8def\u7ebf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 751,
    word: "perruque",
    phonetic: "[p\u03b5ryk]",
    type: "",
    translation: "n.f. \u5047\u53d1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 752,
    word: "bouillir",
    phonetic: "[bujir]",
    type: "",
    translation: "v.i. \u6cb8\u6eda\uff0c\u6cb8\u817e\uff1b\u5728\u5f00\u6c34\u91cc\u70eb\uff0c\u5728\u6cb8\u6eda\u7684\u6db2\u4f53\u4e2d\u716e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 753,
    word: "irr\u00e9sistible",
    phonetic: "[irezistibl]",
    type: "",
    translation: "a. \u4e0d\u53ef\u62b5\u6297\u7684\uff1b\u4e0d\u53ef\u6291\u5236\u7684\uff1b\u96be\u4ee5\u6291\u5236\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 754,
    word: "brise",
    phonetic: "[briz]",
    type: "",
    translation: "n.f. \u51c9\u723d\u7684\u5fae\u98ce\uff0c\u548c\u98ce n.f. \u4f4e\u97f3\uff0c\u4f4e\u97f3\u5f26\uff1b\u7537\u4f4e\u97f3\uff08\u6f14\u5458\uff09\uff1b\u4f4e\u97f3\u4e50\u5668\uff08\u6f14\u594f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 755,
    word: "basse",
    phonetic: "[b\u0251s]",
    type: "",
    translation: "\u8005\uff09\uff1b\u4f4e\u97f3\u53f7\uff1b\u6697\u7901",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 756,
    word: "\u00e9tabli",
    phonetic: "[etabli]",
    type: "",
    translation: "n.m. \u5de5\u4f5c\u53f0\uff0c\u94b3\u684c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 757,
    word: "sombrer",
    phonetic: "[s\u0254\u0303bre]",
    type: "",
    translation: "v.i.\uff0c v.t. \u6c89\u6ca1\uff1b\u6df1\u9677\uff0c\u6d88\u5931\uff0c\u6bc1\u706d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 758,
    word: "difficult\u00e9",
    phonetic: "[difikylte]",
    type: "",
    translation: "n.f. \u96be\uff0c\u56f0\u96be\u6027\uff1b\u8d39\u52b2\uff0c\u96be\u61c2\uff0c\u6df1\u5965\uff1b\u56f0\u96be\u7684\u4e8b\u60c5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 759,
    word: "fatigue",
    phonetic: "[fatig]",
    type: "",
    translation: "n.f. \u75b2\u4e4f\uff0c\u52b3\u7d2f n.m. \u5706\uff0c\u5706\u5708\uff1b\u5708\uff0c\u5706\u5f62\u7269\uff1b\u5708\u5b50[\u6307\u5e38\u89c1\u7684\u4eba\u3001\u5e38\u4ece\u4e8b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 760,
    word: "cercle",
    phonetic: "[s\u03b5rkl]",
    type: "",
    translation: "\u7684\u6d3b\u52a8]",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 761,
    word: "\u00e9paule",
    phonetic: "[epol]",
    type: "",
    translation: "n.f. \u80a9\uff0c\u80a9\u90e8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 762,
    word: "nez",
    phonetic: "[ne]",
    type: "",
    translation: "n.m. \u9f3b\u5b50\uff1b\u5934\u90e8\uff0c\u673a\u5934",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 763,
    word: "jeunesse",
    phonetic: "[\u0292\u0153n\u03b5s]",
    type: "",
    translation: "n.f. \u9752\u5e74\u65f6\u4ee3\uff0c\u9752\u6625\uff1b\u6210\u957f\u671f\uff1b\u521d\u671f v.t.\uff0c v.pr. 1.\u7167\u4eae\uff0c \u70b9\u71c3\uff1b 2.\u4f7f\u5177\u6709\u5149\u5f69 3.\u542f\u53d1\uff0c\u5f00",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 764,
    word: "\u00e9clairer",
    phonetic: "[ekl\u03b5re]",
    type: "",
    translation: "\u5bfc\uff1b\u8bf4\u660e\uff0c\u89e3\u91ca 21 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 765,
    word: "v\u00eatement",
    phonetic: "[v\u03b5tm\u0251\u0303]",
    type: "",
    translation: "n.m. \u8863\u670d\uff0c\u670d\u88c5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 766,
    word: "briller",
    phonetic: "[brije]",
    type: "",
    translation: "v.i. \u53d1\u5149\uff0c\u53d1\u4eae\uff1b\u95ea\u70c1\uff1b\u5f15\u4eba\u6ce8\u76ee\uff1b\u51fa\u4f17 n.m. \u7269\uff0c\u7269\u4f53\uff1b\u7269\u54c1\uff0c\u4e1c\u897f\uff1b\u5bf9\u8c61\uff1b\u539f\u7531\uff1b[\u54f2]\u5ba2\u4f53\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 767,
    word: "objet",
    phonetic: "[\u0254b\u0292\u03b5]",
    type: "",
    translation: "\u76ee\u7684\uff0c\u76ee\u6807\uff1b\u5185\u5bb9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 768,
    word: "indiquer",
    phonetic: "[\u025b\u0303dike]",
    type: "",
    translation: "v.t. \u6307\u660e\uff0c\u6307\u793a\uff1b\u8868\u660e\uff0c\u663e\u793a n.f. \u903b\u8f91\uff0c\u903b\u8f91\u5b66\uff1b\u903b\u8f91\u6027\uff1b\u63a8\u7406\u65b9\u5f0f\uff1b\u5fc5\u7136\uff0c\u5408\u7406\uff1ba.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 769,
    word: "logique",
    phonetic: "[l\u0254\u0292ik]",
    type: "",
    translation: "\u5408\u4e4e\u903b\u8f91\u7684\uff1b\u5fc5\u7136\u7684\uff0c\u5408\u7406\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 770,
    word: "op\u00e9ration",
    phonetic: "[\u0254perasj\u0254\u0303]",
    type: "",
    translation: "n.f. \u4f5c\u7528\uff0c\u6d3b\u52a8\uff1b[\u519b]\u4f5c\u6218\uff0c\u884c\u52a8\uff1b[\u533b]\u624b\u672f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 771,
    word: "sentiment",
    phonetic: "[s\u0251\u0303tim\u0251\u0303]",
    type: "",
    translation: "n.m. \u611f\u89c9\uff0c\u77e5\u89c9\uff0c\u610f\u8bc6\uff1b\u60c5\u611f\uff1b\u60c5\u7eea\uff1b\u610f\u89c1\uff0c\u770b\u6cd5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 772,
    word: "rapporter",
    phonetic: "[rap\u0254rte]",
    type: "",
    translation: "v.t. \u518d\u62ff\u6765\uff0c\u518d\u5e26\u6765\uff1b\u6dfb\u52a0\uff1b\u6c47\u62a5\uff1b\u5f52\u8fd8\u539f\u5904\uff1b\u9001\u8fd8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 773,
    word: "clown",
    phonetic: "[klun]",
    type: "",
    translation: "n.m. \u4e11\u89d2\uff0c\u5c0f\u4e11\uff1b\u6ed1\u7a3d\u53ef\u7b11\u7684\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 774,
    word: "char",
    phonetic: "[\u222bar]",
    type: "",
    translation: "n.m. \u53cc\u8f6e\u9a6c\u8f66\uff1b\u5f69\u8f66\uff1b\u5766\u514b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 775,
    word: "doigt",
    phonetic: "[dwa]",
    type: "",
    translation: "n.m. \u624b\u6307\uff0c\u8db3\u8dbe\uff1b\u4e00\u6307\u7684\u5bbd\u5ea6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 776,
    word: "malheureux",
    phonetic: "[mal\u0153r\u00f8, \u00f8z]",
    type: "",
    translation: "a. \u4e0d\u5e78\u7684\uff0c\u53ef\u601c\u7684\uff1b\u4e0d\u7965\u7684\uff1b\u4e0d\u5229\u7684\uff1b\u5012\u9709\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 777,
    word: "frisson",
    phonetic: "[fris\u0254\u0303]",
    type: "",
    translation: "n.m. \u5bd2\u98a4\uff0c\u98a4\u6296\uff0c\u53d1\u6296",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 778,
    word: "folie",
    phonetic: "[f\u0254li]",
    type: "",
    translation: "n.f. \u75af\u766b\uff0c\u7cbe\u795e\u9519\u4e71\uff1b\u53d1\u75af\uff0c\u75af\u72c2\uff0c\u8352\u5510\uff1b\u7656\u597d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 779,
    word: "principal",
    phonetic: "[pr\u025b\u0303sipal]",
    type: "",
    translation: "a. \u4e3b\u8981\u7684\uff0c\u9996\u8981\u7684\uff0c\u6700\u91cd\u8981\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 780,
    word: "supposer",
    phonetic: "[sypoze]",
    type: "",
    translation: "v.t. \u5047\u5b9a\uff0c\u5047\u8bbe\uff1b\u731c\u60f3\uff1b\u60f3\u8c61",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 781,
    word: "pari",
    phonetic: "[pari]",
    type: "",
    translation: "n.m. \u6253\u8d4c\uff1b\u8d4c\u6ce8\uff1b\u8d4c\u535a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 782,
    word: "turban",
    phonetic: "[tyrb\u0251\u0303]",
    type: "",
    translation: "n.m. \u5934\u5dfe",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 783,
    word: "fouler",
    phonetic: "[fule]",
    type: "",
    translation: "v.t.\uff0c v.pr. 1.\u538b\uff0c\u69a8\uff0c\u6324\uff1b 2.\u884c\u8d70\u5728...\u4e0a\uff1b 3.\u626d\u4f24",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 784,
    word: "regretter",
    phonetic: "[r\u0259gr\u03b5te]",
    type: "",
    translation: "v.t. \u61ca\u6094\uff0c\u6094\u6068\uff1b\u60cb\u60dc\uff1b\u60bc\u5ff5\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 785,
    word: "\u00e9loigner",
    phonetic: "[elwa\u0272e]",
    type: "",
    translation: "v.t. \u4f7f\u79bb\u5f00\uff0c\u79fb\u5f00\uff1b\u4f7f\u8fdc\u79bb\uff1b\u629b\u5f03\uff0c\u758f\u8fdc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 786,
    word: "varier",
    phonetic: "[varje]",
    type: "",
    translation: "v.t. \u4f7f\u591a\u6837\u5316\uff1b\u4f7f\u6709\u53d8\u5316\uff0c\u6539\u53d8\uff1bv.i. \u53d8\u5316\uff1b\u5404\u4e0d\u4e00\u6837",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 787,
    word: "r\u00e9ponse",
    phonetic: "[rep\u0254\u0303s]",
    type: "",
    translation: "n.f. \u56de\u7b54\uff0c\u7b54\u590d\uff1b\u56de\u4fe1\uff1b\u7b54\u6848",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 788,
    word: "\u00e9clater",
    phonetic: "[eklate]",
    type: "",
    translation: "v.i.\uff0c v.pr. 1.\u7206\u88c2\uff0c\u7206\u70b8\uff1b 2.\u7a81\u7136\u53d1\u51fa\u5de8\u54cd a. \u6b63\u65b9\u5f62\u7684\uff0c\u56db\u65b9\u7684\uff1b\u660e\u786e\u7684\uff0c\u65ad\u7136\u7684\uff1b\u5766\u7387\u7684\uff0c\u679c\u65ad",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 789,
    word: "carr\u00e9",
    phonetic: "[kare]",
    type: "",
    translation: "\u7684\uff1bn.m. \u6b63\u65b9\u5f62\uff0c\u56db\u65b9\u5f62\uff1b\u65b9\u5f62\uff0c\u65b9\u5f62\u7269",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 790,
    word: "reine",
    phonetic: "[r\u03b5n]",
    type: "",
    translation: "n.f. \u5973\u738b\uff1b\u738b\u540e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 791,
    word: "cependant",
    phonetic: "[s\u0259p\u0251\u0303d\u0251\u0303]",
    type: "",
    translation: "adv. \u53ef\u662f\uff0c\u7136\u800c\uff0c\u4f46\u662f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 792,
    word: "absolu",
    phonetic: "[aps\u0254ly]",
    type: "",
    translation: "a. \u7edd\u5bf9\u7684\uff0c\u5b8c\u5168\u7684\uff1b\u4e13\u5236\u7684\uff0c\u72ec\u88c1\u7684\uff1b\u4e13\u6a2a\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 793,
    word: "divers",
    phonetic: "[div\u03b5r, -s]",
    type: "",
    translation: "a. \u5404\u79cd\u5404\u6837\u7684\uff0c\u4e0d\u540c\u7684\uff1b\u591a\u53d8\u7684\uff0c\u53d8\u6362\u7684\uff0c\u591a\u6837\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 794,
    word: "aspect",
    phonetic: "[asp\u03b5]",
    type: "",
    translation: "n.m. \u5916\u89c2\uff0c\u5916\u8868\uff0c\u5916\u8c8c\uff1b\u65b9\u9762\uff0c\u89d2\u5ea6\uff1b\u89c2\u70b9 a. \u4e2d\u95f4\u7684\uff0c\u4e2d\u90e8\u7684\uff1b\u4e2d\u7b49\u7684\uff1b\u5e73\u5747\u7684\uff1bn.m. \u65b9\u6cd5\uff1b\u624b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 795,
    word: "moyen",
    phonetic: "[mwaj\u025b\u0303, -\u03b5n]",
    type: "",
    translation: "\u6bb5\uff1bpl. \u91d1\u94b1\uff0c\u8d44\u8d22",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 796,
    word: "moyenne",
    phonetic: "[mwaj\u03b5n]",
    type: "",
    translation: "n.f. \u4e2d\u7b49\uff1b\u5e73\u5747\u6570\uff1b\u53ca\u683c\u5206\u6570\uff1b\u5e73\u5747\u516c\u91cc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 797,
    word: "franchir",
    phonetic: "[fr\u0251\u0303\u222bir]",
    type: "",
    translation: "v.t. 1.\u8d8a\u8fc7\uff0c\u8de8\u8fc7\uff0c\u7a7f\u8fc7\uff1b 2.\u514b\u670d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 798,
    word: "tranquillement",
    phonetic: "[tr\u0251\u0303kilm\u0251\u0303]",
    type: "",
    translation: "adv. \u5e73\u9759\u5730\uff0c \u5b89\u7a33\u5730 \uff1b\u6e29\u987a\u5730\uff1b \u67d4\u548c\u5730\uff1b \u5fe0\u539a\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 799,
    word: "sacr\u00e9",
    phonetic: "[sakre]",
    type: "",
    translation: "a. [\u5b97]\u795e\u5723\u7684\uff1b\u4e0d\u53ef\u4fb5\u72af\u7684\uff1b\u53ef\u6076\u7684\uff1b\u7edd\u5999\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 800,
    word: "bonne",
    phonetic: "[b\u0254n]",
    type: "",
    translation: "adj.f. \u597d\u7684\uff1bn.f. \u5973\u4ec6\uff0c\u5973\u4f63",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 801,
    word: "charg\u00e9",
    phonetic: "[\u222bar\u0292e]",
    type: "",
    translation: "a. \u8f7d\u8377\u7684\uff0c\u6709\u8d1f\u8f7d\u7684\uff1b\u5145\u6ee1\u7684\uff1b\u8d1f\u8d23\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 802,
    word: "re\u00e7u",
    phonetic: "[r(\u0259)sy]",
    type: "",
    translation: "n.m. \u6536\u636e\uff0c\u6536\u6761\uff1ba.\u88ab\u63a5\u53d7\u7684\uff1b\u88ab\u63a5\u6536\u7684\uff1b\u6536\u5230\u7684 v.t. \u60ac\u6302\uff0c\u540a\u8d77\uff1b\u7ede\u6b7b\uff0c\u540a\u6b7b\uff1bv.i. \u6302\u7740\uff0c\u540a\u7740\uff1b\u4e0b\u5782\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 803,
    word: "pendre",
    phonetic: "[p\u0251\u0303dr]",
    type: "",
    translation: "\u62d6\u4e0b\u6765",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 804,
    word: "condamnation",
    phonetic: "[k\u0254\u0303danasj\u0254\u0303]",
    type: "",
    translation: "n.f. \u5224\u51b3\uff0c\u5ba3\u5224\uff1b\u5904\u7f5a\uff0c\u5224\u5211\uff1b\u8c34\u8d23\uff0c\u6307\u8d23",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 805,
    word: "concours",
    phonetic: "[k\u0254\u0303kur]",
    type: "",
    translation: "n.m. \u534f\u52a9\uff0c\u534f\u4f5c\uff1b\u7ade\u8d5b\uff0c\u6bd4\u8d5b\uff1b\u8003\u8bd5 22 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. a. \u6709\u667a\u529b\u7684\uff1b\u806a\u660e\u7684\uff0c\u7406\u89e3\u529b\u5f3a\u7684\uff1b\u673a\u667a\u7075\u5de7\u7684\uff0c\u7cbe\u660e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 806,
    word: "intelligent",
    phonetic: "[\u025b\u0303teli\u0292\u0251\u0303]",
    type: "",
    translation: "\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 807,
    word: "race",
    phonetic: "[ras]",
    type: "",
    translation: "n.f. \u4eba\u79cd\uff0c\u79cd\u65cf\uff1b[\u52a8]\u79cd\uff1b\u540c\u4e00\u6d3e\u4eba v.i. \u63d0\u4ea4\u6cd5\u5b98\u4ef2\u88c1\uff1bv.t. \u8fde\u7d2f\uff1b\u4f7f\u540d\u8a89\u53d7\u5230\u5f71\u54cd\uff1b\u5371\u5bb3\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 808,
    word: "compromettre",
    phonetic: "[k\u0254\u0303pr\u0254m\u03b5tr]",
    type: "",
    translation: "\u635f\u5bb3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 809,
    word: "entrevoir",
    phonetic: "[\u0251\u0303tr\u0259vwar]",
    type: "",
    translation: "v.t. \u9690\u7ea6\u770b\u89c1\uff0c\u6a21\u7cca\u770b\u89c1\uff1b\u77a5\u89c1\uff1b\u6a21\u7cca\u5730\u9884\u611f\u5230",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 810,
    word: "faillir",
    phonetic: "[fajir]",
    type: "",
    translation: "v.i. \u51e0\u4e4e\uff0c\u9669\u4e9b\u513f\uff0c\u5dee\u4e00\u70b9\u513f\uff1b\u7f3a\u4e4f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 811,
    word: "respecter",
    phonetic: "[r\u03b5sp\u03b5kte]",
    type: "",
    translation: "v.t. \u5c0a\u656c\uff0c\u656c\u91cd\uff1b\u5c0a\u91cd\uff1b\u9075\u5b88\uff1b\u91cd\u89c6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 812,
    word: "poing",
    phonetic: "[pw\u025b\u0303]",
    type: "",
    translation: "n.m. \u62f3\uff0c\u62f3\u5934 v.t. \u7ffb\u8f6c\uff1b\u98a0\u5012\uff1b\u5f04\u4e71\uff1b\u4f7f\u6df7\u4e71\uff1b\u6253\u7ffb\uff0c\u63a8\u5012\uff1b\u63a8\u7ffb\uff1b\u98a0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 813,
    word: "renverser",
    phonetic: "[r\u0251\u0303v\u03b5rse]",
    type: "",
    translation: "\u8986",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 814,
    word: "tracer",
    phonetic: "[trase]",
    type: "",
    translation: "v.t. \u6807\u51fa\uff08\u4f4d\u7f6e\uff09\uff1b\u5f15\uff08\u7ebf\uff09\uff0c\u753b\uff0c\u5212\uff1b\u63cf\u7ed8\uff0c\u52fe\u52d2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 815,
    word: "contenir",
    phonetic: "[k\u0254\u0303tnir]",
    type: "",
    translation: "v.t. \u542b\u6709\uff0c\u5305\u542b\uff1b\u88c5\u6709\uff1b\u963b\u6b62\uff0c\u904f\u5236\uff1b\u514b\u5236\uff0c\u5fcd\u4f4f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 816,
    word: "r\u00e9cit",
    phonetic: "[resi]",
    type: "",
    translation: "n.m. \u53d9\u8ff0\uff0c\u8bb0\u8ff0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 817,
    word: "lutter",
    phonetic: "[lyte]",
    type: "",
    translation: "v.i. \u640f\u6597\uff1b\u7ade\u4e89\uff0c\u89d2\u9010\uff1b\u6597\u4e89\uff0c\u6218\u6597",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 818,
    word: "navire",
    phonetic: "[navir]",
    type: "",
    translation: "n.m. \u8239\u8236\uff0c\u8239\uff0c\u519b\u8230",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 819,
    word: "b\u00e2timent",
    phonetic: "[b\u0251tim\u0251\u0303]",
    type: "",
    translation: "n.m. \u5efa\u7b51\u7269\uff1b\u5efa\u7b51\uff1b\u5efa\u7b51\u4e1a\uff1b\u8239\u8236\uff0c\u5de8\u8f6e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 820,
    word: "vapeur",
    phonetic: "[vap\u0153r]",
    type: "",
    translation: "n.f. \u84b8\u6c14\uff1b\u84b8\u6c7d\uff0c\u6c7d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 821,
    word: "consulter",
    phonetic: "[k\u0254\u0303sylte]",
    type: "",
    translation: "v.t. \u8bf7\u6559\uff0c\u54a8\u8be2\uff1b\u6c42\u533b\uff1b\u67e5\u9605\uff0c\u67e5\u8003",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 822,
    word: "obstacle",
    phonetic: "[\u0254pstakl]",
    type: "",
    translation: "n.m. \u969c\u788d\uff08\u7269\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 823,
    word: "perte",
    phonetic: "[p\u03b5rt]",
    type: "",
    translation: "n.f. \u4e22\u5931\uff1b\u4e27\u5931\uff1b\u6d88\u5931\uff1b\u635f\u5931\uff1b\u6b7b\u4ea1\uff1b\u8f93\uff0c\u5931\u8d25",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 824,
    word: "disposition",
    phonetic: "[dispozisj\u0254\u0303]",
    type: "",
    translation: "n.f. \u5b89\u6392\uff0c\u5e03\u7f6e\uff0c\u5e03\u5c40\uff1b\u652f\u914d\u6743\uff0c\u4f7f\u7528\u6743\uff1b\u6761\u6587\uff0c\u6761\u6b3e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 825,
    word: "paquebot",
    phonetic: "[pakbo]",
    type: "",
    translation: "n.m. \u5927\u578b\u5ba2\u8f6e\uff0c\u90ae\u8239\uff0c\u8fdc\u6d0b\u822a\u8f6e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 826,
    word: "bazar",
    phonetic: "[bazar]",
    type: "",
    translation: "n.m.\uff08\u4e1c\u65b9\u3001\u5317\u975e\u7684\uff09\u96c6\u5e02\uff0c\u5e02\u573a\uff1b\u5546\u573a\uff0c\u767e\u8d27\u5546\u5e97",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 827,
    word: "mets",
    phonetic: "[m\u03b5]",
    type: "",
    translation: "n.m. \u83dc\u80b4\uff0c \u76d8\u88c5\u83dc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 828,
    word: "m\u00e9tropolitain",
    phonetic: "[metr\u0254p\u0254lit\u025b\u0303]",
    type: "",
    translation: "a. \u5927\u90fd\u4f1a\u7684\uff0c\u5927\u57ce\u5e02\u7684\uff1b\u9996\u5e9c\u7684\uff0c\u9996\u90fd\u7684\uff1b\u5b97\u4e3b\u56fd\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 829,
    word: "physionomie",
    phonetic: "[fizj\u0254n\u0254mi]",
    type: "",
    translation: "n.f. \u76f8\u8c8c\uff0c\u5bb9\u8c8c\uff1b\u9762\u90e8\u8868\u60c5\uff1b\u9762\u8c8c\uff0c\u7279\u70b9\uff0c\u7279\u5f81",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 830,
    word: "moi",
    phonetic: "[mwa]",
    type: "",
    translation: "pron.pers. \u6211\uff1b \u81ea\u6211",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 831,
    word: "prolong\u00e9",
    phonetic: "[pr\u0254l\u0254\u0303\u0292e]",
    type: "",
    translation: "adj. \u6301\u4e45\u7684\uff0c\u6301\u7eed\u65f6\u95f4\u957f\u7684\uff1b\u5ef6\u957f\u7684\uff0c\u5ef6\u4f38\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 832,
    word: "fleuve",
    phonetic: "[fl\u0153v]",
    type: "",
    translation: "n.m. \u6c5f\uff0c\u6cb3\uff0c\u5ddd v.t.\uff0c v.pr. 1.\u4e0a\u8239\uff1b\u4e0a\u706b\u8f66\uff1b 2.\u5377\u5165\uff0c\u6295\u5165 3.\u88c5\u4e0a\u8239\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 833,
    word: "embarquer",
    phonetic: "[\u0251\u0303barke]",
    type: "",
    translation: "\u4f7f\u4e0a\u8f66\uff1b 4.\u5f00\u59cb\uff0c\u7740\u624b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 834,
    word: "connu",
    phonetic: "[k\u0254ny]",
    type: "",
    translation: "a. \u8ba4\u8bc6\u7684\uff0c\u5df2\u77e5\u7684\uff1b\u8457\u540d\u7684\uff0c\u4f17\u6240\u5468\u77e5\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 835,
    word: "foi",
    phonetic: "[fwa]",
    type: "",
    translation: "n.f. \u4fe1\u7528\uff1b\u4fe1\u4ef0\uff0c\u5b97\u6559\u4fe1\u4ef0\uff1b\u4fe1\u4efb\uff0c\u4fe1\u8d56\uff1b\u8bfa\u8a00\uff0c\u4fdd\u8bc1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 836,
    word: "pr\u00e9cieux",
    phonetic: "[presj\u00f8]",
    type: "",
    translation: "a. \u73cd\u8d35\u7684\uff0c\u8d35\u91cd\u7684\uff1b\u53ef\u8d35\u7684\uff0c\u5b9d\u8d35\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 837,
    word: "circonstance",
    phonetic: "[sirk\u0254\u0303st\u0251\u0303s]",
    type: "",
    translation: "n.f. \u60c5\u51b5\uff0c\u72b6\u51b5\uff0c\u73af\u5883\uff1b\u65f6\u673a\uff0c\u5f62\u52bf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 838,
    word: "franc",
    phonetic: "[fr\u0251\u0303]",
    type: "",
    translation: "a. \u5766\u7387\u7684\uff0c\u76f4\u7387\u7684\uff1b\u660e\u786e\u7684\uff1b\u514d\u7a0e\u7684\uff1bn.m. \u6cd5\u90ce",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 839,
    word: "fonder",
    phonetic: "[f\u0254\u0303de]",
    type: "",
    translation: "v.t. \u521b\u5efa\uff0c\u521b\u529e\uff0c\u521b\u7acb\uff0c\u7f14\u9020\uff1b\u8bbe\u7acb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 840,
    word: "comptoir",
    phonetic: "[k\u0254\u0303twar]",
    type: "",
    translation: "n.m. \u67dc\u53f0\uff1b\uff08\u9152\uff09\u5427\u53f0\uff1b\u5546\u884c\uff1b\u94f6\u884c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 841,
    word: "\u00e9gal",
    phonetic: "[egal]",
    type: "",
    translation: "a. \u76f8\u7b49\u7684\uff1b\u540c\u7b49\u7684\uff0c\u540c\u6837\u7684\uff1b\u52bf\u5747\u529b\u654c\u7684\uff1b\u5e73\u7b49\u7684 a. \u72ed\u7684\uff0c\u7a84\u7684\uff1b\u72ed\u9698\u7684\uff0c\u5c40\u9650\u7684\uff1b\u7d27\u7684\uff1b\u5bc6\u5207\u7684\uff0c\u4eb2\u5bc6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 842,
    word: "\u00e9troit",
    phonetic: "[etrwa, -t]",
    type: "",
    translation: "\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 843,
    word: "rafale",
    phonetic: "[rafal]",
    type: "",
    translation: "n.f. \u9635\u98ce\uff0c\u72c2\u98ce\uff1b\u610f\u5916\u4e8b\u6545\uff1b\u8fde\u5c04",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 844,
    word: "sacrifice",
    phonetic: "[sakrifis]",
    type: "",
    translation: "n.m. [\u5b97]\u796d\u54c1\uff0c\u4f9b\u54c1\uff0c\u727a\u7272\uff08\u54c1\uff09\uff1b\u727a\u7272\uff0c\u732e\u8eab n.f. \u8239\u8231\uff1b\u5c0f\u5ba4\uff1b\u7535\u68af\u95f4\uff1b\u7a7a\u4e2d\u7d22\u9053\u95f4\uff1b\u8f66\u8f86\u9a7e\u9a76\u5ba4\uff1b\u98de",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 845,
    word: "cabine",
    phonetic: "[kabin]",
    type: "",
    translation: "\u673a\u9a7e\u9a76\u8231 23 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 846,
    word: "guider",
    phonetic: "[gide]",
    type: "",
    translation: "v.t. \u5e26\u9886\uff1b\u7ed9\uff08\u67d0\u4eba\uff09\u505a\u5411\u5bfc\uff1b\u6307\u5bfc\uff1b\u5f15\u5bfc\uff1b\u6307\u6325",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 847,
    word: "coutume",
    phonetic: "[kutym]",
    type: "",
    translation: "n.f. \u4e60\u60ef\uff0c\u4e60\u4fd7\uff0c\u60ef\u4f8b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 848,
    word: "colonne",
    phonetic: "[k\u0254l\u0254n]",
    type: "",
    translation: "n.f. \u67f1\uff0c\u652f\u67f1\uff0c\u5706\u67f1\uff1b\uff08\u5370\u5237\u54c1\u7684\uff09\u680f\uff0c\u5217\uff1b[\u519b]\u7eb5\u961f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 849,
    word: "prisonnier",
    phonetic: "[priz\u0254nje]",
    type: "",
    translation: "n. \u4fd8\u864f\uff1b\u56da\u72af\uff1b\u88ab\u7981\u95ed\u7684\u519b\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 850,
    word: "pr\u00e9cipit\u00e9",
    phonetic: "[presipite]",
    type: "",
    translation: "a. \u5306\u5fd9\u7684\uff0c\u4ed3\u4fc3\u7684\uff1bn.m. [\u5316]\u6c89\u6dc0\u7684 v.i. \u9003\u8dd1\uff1b\u9003\u907f\uff1b\u98de\u901d\uff1b\u6d41\u51fa\uff1b\u6e17\u6f0f\uff1bv.t. \u9003\u907f\uff0c\u8eb2\u907f\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 851,
    word: "fuir",
    phonetic: "[f\u0265ir]",
    type: "",
    translation: "\u6d88\u5931",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 852,
    word: "traiter",
    phonetic: "[tr\u03b5te]",
    type: "",
    translation: "v.t. \u5bf9\u5f85\uff1b\u63a2\u8ba8\uff0c\u8bba\u8ff0\uff1b\u5546\u8c08\uff1b\u6cbb\u7597\uff1b\u52a0\u5de5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 853,
    word: "brume",
    phonetic: "[brym]",
    type: "",
    translation: "n.f. \u96fe\uff0c\u8f7b\u96fe\uff0c\u96fe\u972d\uff1b\u6a21\u7cca\uff0c\u7cca\u6d82\uff1b\u6a21\u7cca\u4e0d\u6e05\uff1b\u6d77\u96fe v.i. \u65cb\u8f6c\uff0c\u56de\u8f6c\uff1b\uff08\u8f66\u8f86\u7b49\uff09\u62d0\u5f2f\uff0c\u8f6c\u5f2f\uff1b\u76d8\u65cb\uff1bv.t.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 854,
    word: "virer",
    phonetic: "[vire]",
    type: "",
    translation: "[\u94f6\uff0c\u4f1a]\u8f6c\u8d26\uff0c\u5212\u8d26",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 855,
    word: "auparavant",
    phonetic: "[oparav\u0251\u0303]",
    type: "",
    translation: "adv. \u4ece\u524d\uff0c\u4ee5\u524d\uff1b\u5148\uff0c\u5728\u5148 1.\u51ff\u7a7f\uff0c\u6253\u7a7f\uff1b\u51ff\uff0c\u5f00\u8f9f\uff1b 2.\u7a7f\u8fc7\uff0c\u900f\u8fc7\uff1b\u770b\u7a7f\uff0c\u770b\u7834",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 856,
    word: "percer",
    phonetic: "[p\u03b5rse]",
    type: "",
    translation: "3.v.i. \u7a81\u7834\u800c\u51fa\uff1b\u7a81\u56f4\uff1b 4.\u663e\u9732\uff0c\u663e\u51fa\uff0c\u6d41\u9732\uff0c\u5d2d\u9732\u5934\u89d2 v.t. \u6405\u6d51\uff1b\u4f7f\u6a21\u7cca\u4e0d\u6e05\uff1b\u4f7f\u614c\u4e71\uff1b\u6270\u4e71\uff0c\u6253\u6270\uff1b\u4f7f\u5fc3\u7eea\u4e0d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 857,
    word: "troubler",
    phonetic: "[truble]",
    type: "",
    translation: "\u5b81 a. \u672b\u7aef\u7684\uff0c\u5c3d\u5934\u7684\uff1b\u6700\u540e\u7684\uff0c\u6700\u672b\u7684\uff1b\u6781\u5ea6\u7684\uff1b\u8fc7\u5206",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 858,
    word: "extr\u00eame",
    phonetic: "[\u03b5kstr\u03b5m]",
    type: "",
    translation: "\u7684\uff0c\u6781\u7aef\u7684\uff1bn.m. \u6781\u7aef",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 859,
    word: "signal",
    phonetic: "[si\u0272al]",
    type: "",
    translation: "n.m. \u4fe1\u53f7\uff0c\u6697\u53f7 n.f. \u8f6e\u821e\uff0c\u5706\u821e\uff1b\u8f6e\u821e\u66f2\uff1b\u5706\u4f53\u4e66\u6cd5\uff0c\u5706\u4f53\u5b57\uff1b\u5de1\u903b\uff0c\u5de1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 860,
    word: "ronde",
    phonetic: "[r\u0254\u0303d]",
    type: "",
    translation: "\u67e5\uff1b\u5de1\u903b\u961f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 861,
    word: "\u00e9vident",
    phonetic: "[evid\u0251\u0303]",
    type: "",
    translation: "a. \u660e\u663e\u7684\uff0c\u663e\u800c\u6613\u89c1\u7684\uff0c\u4e00\u76ee\u4e86\u7136\u7684\uff0c\u663e\u8457\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 862,
    word: "malle",
    phonetic: "[mal]",
    type: "",
    translation: "n.f.\uff08\u65c5\u884c\u7528\u7684\uff09\u7bb1\u5b50",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 863,
    word: "dedans",
    phonetic: "[d\u0259d\u0251\u0303]",
    type: "",
    translation: "adv. \u5728\u5185\uff0c\u5728\u91cc\u9762\uff1bn.m. \u5185\u90e8\uff0c\u91cc\u9762",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 864,
    word: "couverture",
    phonetic: "[kuv\u03b5rtyr]",
    type: "",
    translation: "n.f. \u88ab\u5b50\uff0c\u6bef\u5b50\uff1b\u5c4b\u9876\uff1b\u62a4\u5c01\uff1b\u5c01\u9762",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 865,
    word: "machinalement",
    phonetic: "[ma\u222binalm\u0251\u0303]",
    type: "",
    translation: "adv. \u6b7b\u8bb0\u786c\u80cc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 866,
    word: "soigneusement",
    phonetic: "[swa\u0272\u00f8zm\u0251\u0303]",
    type: "",
    translation: "adv. \u7ec6\u5fc3\u5730\uff0c\u4ed4\u7ec6\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 867,
    word: "coiffer",
    phonetic: "[kwafe]",
    type: "",
    translation: "v.t. \u7ed9\u2026\u2026\u68b3\u5934\uff1b\u7ed9\u2026\u2026\u7406\u53d1\uff1b\u7ed9\u2026\u2026\u6234\u5e3d\uff1b\u6234\u4e0a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 868,
    word: "bec",
    phonetic: "[b\u03b5k]",
    type: "",
    translation: "n.m.\uff08\u9e1f\uff09\u5634\uff0c\u5599\uff1b\u5c16\u7aef\uff0c\u7a81\u51fa\u90e8\u5206\uff1b\uff08\u5bb9\u5668\u7684\uff09\u53e3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 869,
    word: "certes",
    phonetic: "[s\u03b5rt]",
    type: "",
    translation: "adv. \u5f53\u7136\uff0c\u5fc5\u5b9a\uff0c\u7684\u786e a. \u5fe0\u8bda\u7684\uff0c\u5fe0\u5b9e\u7684\uff1b\u5fe0\u8d1e\u7684\uff0c\u53ef\u9760\u7684\uff1b\u5fe0\u4e8e\u4e8b\u5b9e\u7684\uff0c\u7b26",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 870,
    word: "fid\u00e8le",
    phonetic: "[fid\u03b5l]",
    type: "",
    translation: "\u5408\u771f\u5b9e\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 871,
    word: "soutenir",
    phonetic: "[sutnir]",
    type: "",
    translation: "v.t. \u652f\u6491\uff1b\u6400\u6276\uff1b\u7ef4\u6301\u4f53\u529b\uff1b\u652f\u6301\uff0c\u63f4\u52a9\uff1b\u4fdd\u6301\uff1b\u62e5\u62a4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 872,
    word: "toutefois",
    phonetic: "[tutfwa]",
    type: "",
    translation: "adv. \u5c3d\u7ba1\u5982\u6b64\uff0c\u4e0d\u8fc7\uff0c\u4ecd\u7136\uff0c\u8fd8\u662f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 873,
    word: "prolonger",
    phonetic: "[pr\u0254l\u0254\u0303\u0292e]",
    type: "",
    translation: "v.t. \u4f7f\uff08\u671f\u9650\u7b49\uff09\u5ef6\u957f\uff1b\u4f7f\u5ef6\u4f38\uff0c\u4f7f\u4f38\u5c55\uff0c\u52a0\u957f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 874,
    word: "fuite",
    phonetic: "[f\u0265it]",
    type: "",
    translation: "n.f. \u9003\u8dd1\uff1b\u9003\u907f\uff0c\u8eb2\u907f\uff1b\u6f0f\u6cc4\uff1b\u6cc4\u5bc6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 875,
    word: "d\u00e9finitif",
    phonetic: "[definitif]",
    type: "",
    translation: "a. \u6700\u540e\u7684\uff0c\u51b3\u5b9a\u6027\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 876,
    word: "rang\u00e9",
    phonetic: "[r\u0251\u0303\u0292e]",
    type: "",
    translation: "adj. \u6536\u62fe\u597d\u7684\uff0c \u6574\u6d01\u7684\uff0c \u89c4\u89c4\u77e9\u77e9\u7684\uff0c \u751f\u6d3b\u6709\u6761\u4e0d\u7d0a\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 877,
    word: "degr\u00e9",
    phonetic: "[d\u0259gre]",
    type: "",
    translation: "n.m. \u7b49\u7ea7\uff0c\u7ea7\u522b\uff1b\u7a0b\u5ea6\uff0c\u9636\u6bb5\uff1b\u5ea6\uff0c\u5ea6\u6570 v.t. \uff08\u4f7f\uff09\u7a7a\uff0c\u5012\u7a7a\uff1b\u559d\u5149\uff1b\u5403\u5149\uff1b\u4f7f\u64a4\u51fa\uff0c\u4f7f\u64a4\u79bb\uff1b\u758f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 878,
    word: "vider",
    phonetic: "[vide]",
    type: "",
    translation: "\u6563\uff1b\u6e05\u9664\uff0c\u6392\u7a7a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 879,
    word: "influence",
    phonetic: "[\u025b\u0303fly\u0251\u0303s]",
    type: "",
    translation: "n.f. \u5f71\u54cd\uff1b\u4f5c\u7528\uff1b\u5a01\u4fe1\uff0c\u6743\u52bf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 880,
    word: "paire",
    phonetic: "[p\u03b5r]",
    type: "",
    translation: "n.f. \u4e00\u53cc\uff0c\u4e00\u526f\uff1b\u4e00\u5bf9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 881,
    word: "liqueur",
    phonetic: "[lik\u0153:r]",
    type: "",
    translation: "n.f. \u751c\u70e7\u9152\uff0c\u5229\u53e3\u9152\uff1b\uff08\u836f\u7528\uff09\u6db2\uff0c\u6db2\u4f53",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 882,
    word: "gin",
    phonetic: "[d\u0292in]",
    type: "",
    translation: "n.m. \u675c\u677e\u5b50\u9152 a. \u62a5\u4e27\u7684\uff0c\u9884\u62a5\u6b7b\u4ea1\u7684\uff1b\u81f4\u547d\u7684\uff0c\u81f4\u6b7b\u7684\uff1b\u4e0d\u7965\u7684\uff1b\u62db",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 883,
    word: "funeste",
    phonetic: "[fyn\u03b5st]",
    type: "",
    translation: "\u81f4\u91cd\u5927\u635f\u5931\u7684\uff1b\u6709\u5bb3\u7684 24 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 884,
    word: "r\u00e9fugi\u00e9",
    phonetic: "[refy\u0292je]",
    type: "",
    translation: "a. \u907f\u96be\u7684\uff0c\u9003\u4ea1\u7684\uff1bn. \u96be\u6c11\uff1b\u907f\u96be\u8005\uff0c\u9003\u4ea1\u8005",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 885,
    word: "d\u00e9tective",
    phonetic: "[det\u03b5ktiv]",
    type: "",
    translation: "n. \u79c1\u5bb6\u4fa6\u63a2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 886,
    word: "r\u00e9sine",
    phonetic: "[rezin]",
    type: "",
    translation: "n.f. [\u5316]\u6811\u8102 v.i. \u98de\u6765\u98de\u53bb\uff0c\u98de\u821e\uff0c\u98de\u7fd4\uff1b\u98d8\u626c\uff0c\u98d8\u821e\uff1b\u8f7b\u6d6e\uff1b\u8d70\u94a2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 887,
    word: "voltiger",
    phonetic: "[v\u0254lti\u0292e]",
    type: "",
    translation: "\u4e1d\uff0c\u800d\u9a6c\u620f\uff0c\u6f14\u6742\u6280",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 888,
    word: "inqui\u00e9tude",
    phonetic: "[\u025b\u0303kjetyd]",
    type: "",
    translation: "n.f. \u62c5\u5fc3\uff0c\u62c5\u5fe7\uff0c\u4e0d\u5b89\uff0c\u7126\u6025",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 889,
    word: "r\u00e9flexion",
    phonetic: "[refl\u03b5ksj\u0254\u0303]",
    type: "",
    translation: "n.f. \u53cd\u5c04[\u6307\u6ce2]\uff1b\u601d\u8003\uff0c\u8003\u8651\uff1b\u53cd\u7701\uff1b\u611f\u60f3\uff0c\u60f3\u6cd5 n.f. \u5e26\u9886\uff0c\u5f15\u5bfc\uff1b\u9a7e\u9a76\uff1b\u6307\u6325\uff0c\u9886\u5bfc\uff1b\u884c\u4e3a\uff0c\u54c1\u884c\uff1b\u7ba1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 890,
    word: "conduite",
    phonetic: "[k\u0254\u0303d\u0265it]",
    type: "",
    translation: "\u9053\uff0c\u7ba1\u4ef6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 891,
    word: "cerveau",
    phonetic: "[s\u03b5rvo]",
    type: "",
    translation: "n.m. \u8111\uff1b\u5934\u8111\uff0c\u601d\u60f3\uff1b\u4e2d\u67a2\uff1b\u667a\u56ca\uff0c\u5173\u952e\u4eba\u7269",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 892,
    word: "crainte",
    phonetic: "[kr\u025b\u0303t]",
    type: "",
    translation: "n.f. \u5bb3\u6015\uff0c\u754f\u60e7\uff1b\u5fe7\u8651\uff0c\u62c5\u5fc3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 893,
    word: "pr\u00e9vision",
    phonetic: "[previzj\u0254\u0303]",
    type: "",
    translation: "n.f. \u9884\u89c1\uff0c\u9884\u6599\uff0c\u9884\u6d4b\uff0c\u9884\u62a5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 894,
    word: "conclure",
    phonetic: "[k\u0254\u0303klyr]",
    type: "",
    translation: "v.t. \u7f14\u7ed3\uff0c\u8fbe\u6210\uff0c\u5546\u5b9a\uff1b\u7ed3\u675f v.t. \u5b9e\u65bd\uff0c\u5b9e\u884c\uff0c\u6267\u884c\uff1b[\u6cd5]\u6267\u884c\u6b7b\u5211\uff0c\u5904\u51b3\uff1b\u6f14\u594f\uff0c\u8868",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 895,
    word: "ex\u00e9cuter",
    phonetic: "[\u03b5gzekyte]",
    type: "",
    translation: "ou [egzekyte] \u6f14",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 896,
    word: "subir",
    phonetic: "[sybir]",
    type: "",
    translation: "v.t. \u906d\u53d7\uff0c\u8499\u53d7\uff1b\u5bb9\u5fcd\uff0c\u5fcd\u53d7\uff1b\u7ecf\u53d7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 897,
    word: "fracas",
    phonetic: "[fraka]",
    type: "",
    translation: "n.m. \u7206\u88c2\u58f0\uff0c\u649e\u51fb\u58f0\uff0c\u54d7\u5566\u58f0\uff0c\u8f70\u9686\u58f0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 898,
    word: "lame",
    phonetic: "[lam]",
    type: "",
    translation: "n.f. \u8584\u7247\uff1b\u5200\u7247\uff1b\u8584\u677f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 899,
    word: "tort",
    phonetic: "[t\u0254r]",
    type: "",
    translation: "n.m. \u8fc7\u9519\uff0c\u9519\u8bef\uff1b\u635f\u5bb3\uff0c\u4f24\u5bb3\uff0c\u635f\u5931",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 900,
    word: "pr\u00e9caution",
    phonetic: "[prekosj\u0254\u0303]",
    type: "",
    translation: "n.f. \u9884\u9632\u63aa\u65bd\uff1b\u8c28\u614e\uff0c\u5c0f\u5fc3 a. \u4e0d\u89c4\u5219\u7684\uff0c\u65e0\u89c4\u5f8b\u7684\uff0c\u4e0d\u6574\u9f50\u7684\uff1b\u7ecf\u5e38\u53d8\u5316\u7684\uff0c\u4e0d\u7a33",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 901,
    word: "irr\u00e9gulier",
    phonetic: "[iregylje]",
    type: "",
    translation: "\u5b9a\u7684\uff1b\u4e0d\u5408\u5e38\u89c4\u7684\uff0c\u4e0d\u6b63\u5e38\u7684\uff1b\u4e0d\u6b63\u89c4\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 902,
    word: "barrer",
    phonetic: "[bare]",
    type: "",
    translation: "v.t.\uff08\u7528\u6a2a\u6746\u7b49\uff09\u62e6\u4f4f\uff1b\u6321\u4f4f\uff0c\u62e6\u963b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 903,
    word: "franchement",
    phonetic: "[fr\u0251\u0303\u222bm\u0251\u0303]",
    type: "",
    translation: "adv. \u5766\u7387\u5730\uff0c\u76f4\u7387\u5730\uff1b\u5766\u7387\u5730\u8bb2\uff1b\u975e\u5e38\uff0c\u786e\u5b9e\uff1b\u5b8c\u5168",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 904,
    word: "\u00e9lectrique",
    phonetic: "[el\u03b5ktrik]",
    type: "",
    translation: "a. \u7535\u7684\uff1b\u89e6\u7535\u822c\u7684\uff1b\u5341\u5206\u5f3a\u70c8\u7684 v.t.\uff0c v.pr. 1.\u6d82\uff0c\u6577\uff0c\u8d34\uff1b 2.\u8fd0\u7528\uff0c\u5e94\u7528\uff0c\u4f7f\u7528\uff0c\u63f4\u7528",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 905,
    word: "appliquer",
    phonetic: "[aplike]",
    type: "",
    translation: "3.\u5b9e\u65bd\uff0c\u5b9e\u884c\uff1b 4.\u4e13\u5fc3\u4e8e\uff0c\u5168\u795e\u8d2f\u6ce8\u4e8e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 906,
    word: "bassin",
    phonetic: "[bas\u025b\u0303]",
    type: "",
    translation: "n.m. \u76c6\uff1b\u6c34\u6c60\uff1b\u6c60\u5858\uff1b\u76c6\u5730 a. \u5bbd\u5b8f\u5927\u91cf\u7684\uff0c\u5bbd\u539a\u7684\uff1b\u6177\u6168\u7684\uff1b\u5bcc\u9976\u7684\uff0c\u80a5\u6c83\u7684\uff1b\u4e30",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 907,
    word: "g\u00e9n\u00e9reux",
    phonetic: "[\u0292ener\u00f8, -z]",
    type: "",
    translation: "\u5bcc\u7684 v.t. \u4e3a\u2026\u2026\u8fa9\u62a4\uff1b\u8bc1\u660e\u65e0\u7f6a\uff1b\u8bf4\u660e\u7406\u7531\uff1b\u89e3\u91ca\uff1b\u8bc1\u5b9e\uff1b\u8bba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 908,
    word: "justifier",
    phonetic: "[\u0292ystifje]",
    type: "",
    translation: "\u8bc1\uff0c\u8bc1\u660e\uff1b\u4f7f\u5408\u6cd5\uff0c\u4f7f\u6210\u4e3a\u6b63\u5f53\u7684\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 909,
    word: "besogne",
    phonetic: "[b\u0259z\u0254\u0272]",
    type: "",
    translation: "n.f. \u5de5\u4f5c\uff0c\u6d3b\u513f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 910,
    word: "caresser",
    phonetic: "[kar\u03b5se]",
    type: "",
    translation: "v.t. \u629a\u7231\uff0c\u629a\u6478\uff1b\u8f7b\u62c2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 911,
    word: "chauffer",
    phonetic: "[\u222bofe]",
    type: "",
    translation: "v.t. \u70e7\u70ed\uff0c\u52a0\u70ed\uff1b\u6fc0\u52b1\uff0c\u4f7f\u5174\u594b\uff1bv.i. \u53d8\u70ed\uff1b\u53d1\u70ed v.,v.pr. \u6298\u65ad\uff0c\u6253\u788e\uff1b\u505c\u6b62\uff0c\u4e2d\u6b62\uff1b\u5ba3\u544a\u5e9f\u9664\uff1b\u7edd\u4ea4\uff1b\u5173",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 912,
    word: "rompre",
    phonetic: "[r\u0254\u0303pr]",
    type: "",
    translation: "\u7cfb\u7834\u88c2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 913,
    word: "transformer",
    phonetic: "[tr\u0251\u0303sf\u0254rme]",
    type: "",
    translation: "v.t. \u4f7f\u53d8\u5f62\uff0c\u4f7f\u6539\u89c2\uff1b\u6539\u53d8\uff0c\u6539\u9020\uff0c\u53d8\u9769\uff1b\u4f7f\u7115\u53d1\u65b0\u8c8c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 914,
    word: "d\u00e9tour",
    phonetic: "[detur]",
    type: "",
    translation: "n.m. \u7ed5\u9053\uff0c\u8fc2\u56de\uff0c\u8d70\u5f2f\u8def\uff1b\u62d0\u5f2f\uff1b\u62d0\u5f2f\u62b9\u89d2\uff0c\u515c\u5708\u5b50",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 915,
    word: "hurlement",
    phonetic: "[yrl\u0259m\u0251\u0303]",
    type: "",
    translation: "\u865a\u97f3H n.m. \u55e5\u53eb\uff1b\u543c\u53eb\uff0c\u558a\u53eb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 916,
    word: "form\u00e9",
    phonetic: "[f\u0254rme]",
    type: "",
    translation: "adj. \u6210\u5f62\u7684, \u5f62\u6210\u7684, \u957f\u6210\u7684, \u6210\u719f\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 917,
    word: "typhon",
    phonetic: "[tif\u0254\u0303]",
    type: "",
    translation: "n.m. \u53f0\u98ce",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 918,
    word: "invariable",
    phonetic: "[\u025b\u0303varjabl]",
    type: "",
    translation: "a. \u4e0d\u53d8\u7684\uff0c\u4e0d\u6539\u53d8\u7684\uff1b[\u8bed]\u8bcd\u5f62\u4e0d\u53d8\u5316\u7684\uff0c\u8bcd\u5c3e\u4e0d\u53d8\u5316\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 919,
    word: "ahurir",
    phonetic: "[ayrir]",
    type: "",
    translation: "v.t. \u4f7f\u614c\u4e71\uff0c\u4f7f\u60ca\u5446",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 920,
    word: "appr\u00e9cier",
    phonetic: "[apresje]",
    type: "",
    translation: "v.t. \u4f30\u4ef7\uff0c\u8bc4\u4ef7\uff1b\u4f30\u8ba1\uff0c\u5224\u65ad\uff0c\u8861\u91cf\uff1b\u8d4f\u8bc6\uff0c\u6b23\u8d4f n.m. \u4f4e\u8bed\u58f0\uff0c\u7a83\u7a83\u8bae\u8bba\u58f0\uff1b\u57cb\u6028\u58f0\uff0c\u6028\u8a00\uff1b\u4f4e\u6c89\u8fde\u7eed\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 921,
    word: "murmure",
    phonetic: "[myrmyr]",
    type: "",
    translation: "\u58f0\u97f3 25 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 922,
    word: "concert",
    phonetic: "[k\u0254\u0303s\u03b5r]",
    type: "",
    translation: "n.m. \u534f\u8c03\uff0c\u4e00\u81f4\uff0c\u548c\u8c10\uff1b\u97f3\u4e50\u4f1a\uff1b\u5408\u5531\u56e2\uff0c\u4e50\u961f\uff1b\u9f50\u9e23",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 923,
    word: "religieux",
    phonetic: "[r(\u0259)li\u0292j\u00f8, -z]",
    type: "",
    translation: "a. \u5b97\u6559\u7684\uff1b\u4fee\u9053\u7684\uff1b\u7b03\u4fe1\u5b97\u6559\u7684\uff1bn. \u4fee\u9053\u58eb\uff0c\u4fee\u5973",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 924,
    word: "convoi",
    phonetic: "[k\u0254\u0303vwa]",
    type: "",
    translation: "n.m. \u8f66\u961f\uff1b\u8239\u961f\uff1b\u961f\u5217\uff1b\u5217\u8f66",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 925,
    word: "facilement",
    phonetic: "[fasilm\u0251\u0303]",
    type: "",
    translation: "adv. \u5bb9\u6613\u5730\uff0c \u8f7b\u6613\u5730\uff0c \u4e0d\u8d39\u529b\u5730\uff1b\u81f3\u5c11\uff0c \u8d77\u7801 v.t. \u653e\u4e0b\uff1b\u653e\u7f6e\uff1b\uff08\u7528\u8f66\uff09\u628a\u2026\u2026\u5e26\u5230\uff1b\u5bc4\u5b58\uff0c\u5b58\u653e\uff1b\u63d0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 926,
    word: "d\u00e9poser",
    phonetic: "[depoze]",
    type: "",
    translation: "\u4ea4\uff0c\u63d0\u5448\uff1b\u62ff\u6389\uff0c\u62c6\u4e0b v.t. \u5411\u2026\u2026\u6311\u8845\uff1b\u60f9\uff1b\uff08\u5973\u4eba\uff09\u6311\u9017\uff08\u7537\u4eba\uff09\uff1b\u5f15\u8d77\uff0c\u6fc0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 927,
    word: "provoquer",
    phonetic: "[pr\u0254v\u0254ke]",
    type: "",
    translation: "\u8d77",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 928,
    word: "tournant",
    phonetic: "[turn\u0251\u0303, -t]",
    type: "",
    translation: "a. \u65cb\u8f6c\u7684\uff0c\u80fd\u8f6c\u52a8\u7684\uff1b\u8fc2\u56de\u66f2\u6298\u7684, \u76d8\u65cb\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 929,
    word: "grimper",
    phonetic: "[gr\u025b\u0303pe]",
    type: "",
    translation: "v.i.\uff0c n.m. 1.\u5411\u4e0a\u722c\u884c\uff1b 2.\u6500\u767b\uff1b\u8fc5\u901f\u4e0a\u5347",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 930,
    word: "canal",
    phonetic: "[kanal]",
    type: "",
    translation: "n.m. 1.\u8fd0\u6cb3\uff0c\u6c34\u6e20\uff0c\u6d77\u5ce1\uff0c 2.\u7ba1\u9053\uff0c\u9014\u5f84",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 931,
    word: "dizaine",
    phonetic: "[diz\u03b5n]",
    type: "",
    translation: "n.f. \u5341\u4e2a\u5de6\u53f3\uff0c\u5341\u6765\u4e2a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 932,
    word: "ouverture",
    phonetic: "[uv\u03b5rtyr]",
    type: "",
    translation: "n.f. \u6253\u5f00\uff1b\u5f00\u542f\uff1b\u5f00\u53e3\uff1b\u5f00\u59cb\uff1b\u5f00\u5f20\uff0c\u5f00\u5e55\uff1b\u8425\u4e1a\uff1b\u5f00\u653e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 933,
    word: "manifester",
    phonetic: "[manif\u03b5ste]",
    type: "",
    translation: "v.t. \u8868\u793a\uff0c\u8868\u8fbe\uff1b\u663e\u793a\uff0c\u663e\u9732\uff1bv.i. \u53c2\u52a0\u6e38\u884c\uff0c\u4e3e\u884c\u793a\u5a01",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 934,
    word: "cons\u00e9quence",
    phonetic: "[k\u0254\u0303sek\u0251\u0303s]",
    type: "",
    translation: "n.f. \u540e\u679c\uff0c\u7ed3\u679c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 935,
    word: "redevenir",
    phonetic: "[r\u0259dv\u0259nir]",
    type: "",
    translation: "v.i. \u518d\u6b21\u6210\u4e3a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 936,
    word: "domination",
    phonetic: "[d\u0254minasj\u0254\u0303]",
    type: "",
    translation: "n.f. \u63a7\u5236\uff0c\u652f\u914d\uff1b\u7edf\u6cbb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 937,
    word: "gouverneur",
    phonetic: "[guv\u03b5rn\u0153r]",
    type: "",
    translation: "n.m. \u603b\u7763\uff1b\u7701\u957f\uff0c\u5dde\u957f\uff1b\u603b\u88c1\uff0c\u603b\u957f\uff1b\u3008\u519b\u4e8b\u3009\u53f8\u4ee4 adv. \u786e\u5207\u5730\uff0c\u51c6\u786e\u5730\uff1b\u4ee5\u672c\u4e49\uff1b\u6e05\u6d01\u5730\uff0c\u5e72\u51c0\u5730\uff0c\u6574\u6d01",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 938,
    word: "proprement",
    phonetic: "[pr\u0254pr\u0259m\u0251\u0303]",
    type: "",
    translation: "\u5730\uff1b\u5ec9\u6d01\u5730\uff0c\u6b63\u6d3e\u5730\uff0c\u6b63\u5f53\u5730\uff1b\u6070\u5f53\u5730\uff0c\u9002\u5f53\u5730",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 939,
    word: "modifier",
    phonetic: "[m\u0254difje]",
    type: "",
    translation: "v.t. \u6539\u53d8\uff0c\u4fee\u6539\uff1b\u4fee\uff1bv.pr. \u6539\u53d8\uff0c\u53d8\u5316",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 940,
    word: "antique",
    phonetic: "[\u0251\u0303tik]",
    type: "",
    translation: "a. \u53e4\u4ee3\u7684\uff1b\u53e4\u8001\u7684\uff1b\u8fc7\u65f6\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 941,
    word: "passager",
    phonetic: "[pasa\u0292e]",
    type: "",
    translation: "n. \u4e58\u5ba2\uff0c\u65c5\u5ba2\uff1ba. \u8fc7\u8def\u7684\uff0c\u7ecf\u8fc7\u7684\uff1b\u77ed\u6682\u7684\uff0c\u4e00\u65f6\u7684 n.m. \u5047\u671f\uff1b\u4f11\u5047\uff1b\u8282\u5047\u65e5\uff1b\u4e2d\u6b62\u5de5\u4f5c\u5408\u540c\uff1b\u4e2d\u6b62\u79df\u8d41\u5408",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 942,
    word: "cong\u00e9",
    phonetic: "[k\u0254\u0303\u0292e]",
    type: "",
    translation: "\u540c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 943,
    word: "recommander",
    phonetic: "[r\u0259k\u0254m\u0251\u0303de]",
    type: "",
    translation: "v.t. \u63a8\u8350\uff1b\u5efa\u8bae\uff1b\u53ee\u5631\uff1b\u5938\u5956\uff0c\u8d5e\u626c\uff1b\u6302\u53f7\u5bc4\u4fe1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 944,
    word: "rade",
    phonetic: "[rad]",
    type: "",
    translation: "n.f.\u3010\u822a\u6d77\u3011\u951a\u5730, \u505c\u6cca\u573a\uff1bn.m.\u3008\u884c\u8bdd\u3009\u9152\u5427",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 945,
    word: "contrer",
    phonetic: "[k\u0254\u0303tre]",
    type: "",
    translation: "v. [\u724c\u620f]\u52a0\u500d\uff1b\u53cd\u5bf9\uff0c\u963b\u788d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 946,
    word: "sieur",
    phonetic: "[sj\u0153r]",
    type: "",
    translation: "n.m. \u5148\u751f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 947,
    word: "chaussette",
    phonetic: "[\u222bos\u03b5t]",
    type: "",
    translation: "n.f. \u889c\u5b50",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 948,
    word: "procession",
    phonetic: "[pr\u0254sesj\u0254\u0303]",
    type: "",
    translation: "n.f. \u884c\u5217\uff0c\u6e38\u884c\u961f\u4f0d\uff1b\u8fce\u795e\uff1b\u957f\u5217\uff0c\u957f\u9f99 v.t. \u5f3a\u5978\uff1b\u8fdd\u53cd\uff0c\u8fdd\u72af\uff0c\u8fdd\u80cc\uff0c\u7834\u574f\uff1b\u95ef\u5165\uff1b\u4fb5\u72af\uff1b\uff08\u5bf9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 949,
    word: "violer",
    phonetic: "[vj\u0254le]",
    type: "",
    translation: "\u5723\u5730\u7684\uff09\u4eb5\u6e0e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 950,
    word: "adversaire",
    phonetic: "[adv\u03b5rs\u03b5r]",
    type: "",
    translation: "n. \u5bf9\u624b\uff0c\u654c\u624b\uff1b\u5bf9\u65b9 adj. \u88ab\u5360\u7528\u7684\uff1b\u88ab\u501f\u7528\u7684\uff1b\u5fd9\u788c\u7684\uff1b\u7f79\u75c5\u7684\uff0c\u906d\u53d7\u2026\u7684\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 951,
    word: "pris",
    phonetic: "[pri, -z]",
    type: "",
    translation: "\u5165\u8ff7\u7684\uff1b\u51dd\u7ed3\u7684\uff0c\u7ed3\u51b0\u7684\uff1b\u53d7\u9a97\u4e0a\u5f53\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 952,
    word: "navigation",
    phonetic: "[navigasj\u0254\u0303]",
    type: "",
    translation: "n.f. \u822a\u884c\uff0c\u822a\u6d77\uff1b\u822a\u6d77\u5b66\uff1b\u9886\u822a\uff1b\u822a\u7a7a\u5b66\uff1b\u822a\u7a7a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 953,
    word: "consid\u00e9rable",
    phonetic: "[k\u0254\u0303siderabl]",
    type: "",
    translation: "a. \u5927\u91cf\u7684\uff0c\u91cd\u5927\u7684\uff1b\u503c\u5f97\u6ce8\u610f\u7684\uff0c\u91cd\u8981\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 954,
    word: "d\u00e9lai",
    phonetic: "[del\u03b5]",
    type: "",
    translation: "n.m. \u671f\u9650\uff0c\u65f6\u9650\uff1b\u5ef6\u671f\uff0c\u5ef6\u8fdf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 955,
    word: "river",
    phonetic: "[rive]",
    type: "",
    translation: "v.t. \u9489\u6b7b\uff1b\u94c6\u63a5\uff1b\u6263\u7262",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 956,
    word: "marchandise",
    phonetic: "[mar\u222b\u0251\u0303diz]",
    type: "",
    translation: "n.f. \u5546\u54c1\uff0c\u8d27\u7269",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 957,
    word: "manier",
    phonetic: "[manje]",
    type: "",
    translation: "v.t. \u64cd\u4f5c\uff0c\u64cd\u7eb5\uff1b\u63a7\u5236\uff0c\u652f\u914d\uff1b\u4f7f\u7528\uff0c\u8fd0\u7528",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 958,
    word: "fonctionnaire",
    phonetic: "[f\u0254\u0303ksj\u0254n\u03b5r]",
    type: "",
    translation: "n. \u5b98\u5458\uff0c\u804c\u5458\uff0c\u516c\u52a1\u5458",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 959,
    word: "brigadier",
    phonetic: "[brigadje]",
    type: "",
    translation: "n.m. \u961f\u957f\uff0c\u73ed\u957f\uff0c\u7ec4\u957f\uff1b\u4e0b\u58eb\uff1b\u6c34\u624b\u957f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 960,
    word: "aucunement",
    phonetic: "[okyn\u0259m\u0251\u0303]",
    type: "",
    translation: "adv. \u4e00\u70b9\u4e0d\uff0c\u4e00\u70b9\u6ca1\u6709\uff0c\u7edd\u4e0d\uff0c\u4e1d\u6beb\u4e0d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 961,
    word: "impassible",
    phonetic: "[\u025b\u0303pasibl]",
    type: "",
    translation: "adj. \u65e0\u8868\u60c5\u7684\uff1b \u65e0\u52a8\u4e8e\u8877\u7684\uff1b \u6c89\u7740\u7684\uff0c \u9547\u5b9a\u7684 26 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 962,
    word: "foie",
    phonetic: "[fwa]",
    type: "",
    translation: "n.m. \u809d\uff0c\u809d\u810f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 963,
    word: "muraille",
    phonetic: "[myr\u0251j]",
    type: "",
    translation: "n.f. \u9ad8\u5899\uff0c\u57ce\u5899",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 964,
    word: "charbon",
    phonetic: "[\u222barb\u0254\u0303]",
    type: "",
    translation: "n.m. \u7164\uff1b\u6728\u70ad\u7b14\uff1b[\u533b]\u70ad\u75bd 1.\u7784\u51c6\uff0c \u5bf9\uff1b \"2.v.t. indir \uff08+ \u00e0\uff09\u4ee5...\u4e3a\u76ee\u7684\uff0c \u8ffd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 965,
    word: "viser",
    phonetic: "[vize]",
    type: "",
    translation: "\u6c42\uff0c \u529b\u6c42\u8fbe\u5230 \"",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 966,
    word: "favorable",
    phonetic: "[fav\u0254rabl]",
    type: "",
    translation: "a. \u597d\u610f\u7684\uff1b\u8d5e\u6210\u7684\uff0c\u652f\u6301\u7684\uff1b\u6709\u5229\u7684\uff1b\u6709\u4fc3\u8fdb\u4f5c\u7528\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 967,
    word: "oubli\u00e9",
    phonetic: "[ublije]",
    type: "",
    translation: "adj. \u88ab\u9057\u5fd8\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 968,
    word: "irriter",
    phonetic: "[irite]",
    type: "",
    translation: "v.t. \u6fc0\u6012\uff0c\u4f7f\u607c\u6012\uff0c\u4f7f\u751f\u6c14\uff1b\u523a\u6fc0\uff0c\u4f7f\u96be\u53d7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 969,
    word: "auditeur",
    phonetic: "[odit\u0153r, -tris]",
    type: "",
    translation: "n. \u542c\u4f17",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 970,
    word: "pavillon",
    phonetic: "[pavij\u0254\u0303]",
    type: "",
    translation: "n.m. \u72ec\u5bb6\u5c0f\u697c\uff1b\u697c\u9601\uff1b\u4ead\u5b50\uff1b[\u6d77]\u56fd\u7c4d\u65d7\uff0c\u4fe1\u53f7\u65d7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 971,
    word: "singulier",
    phonetic: "[s\u025b\u0303gylje, -\u03b5r]",
    type: "",
    translation: "a. \u72ec\u7279\u7684\uff0c\u7279\u6b8a\u7684\uff0c\u5947\u7279\u7684\uff0c\u5947\u5f02\u7684\uff0c\u53e4\u602a\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 972,
    word: "\u00e9tonn\u00e9",
    phonetic: "[et\u0254ne]",
    type: "",
    translation: "adj. \u88ab\u9707\u64bc\u7684\uff0c \u60ca\u6115\u7684\uff1b\u60ca\u8bb6\u7684\uff0c \u60ca\u5947\u7684\uff0c \u5403\u60ca\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 973,
    word: "maritime",
    phonetic: "[maritim]",
    type: "",
    translation: "a. \u6cbf\u6d77\u7684\uff0c\u6d77\u5cb8\u7684\uff0c\u6d77\u7684\uff1b\u822a\u6d77\u7684\uff1b\u6d77\u4e0a\u7684\uff1b\u6d77\u4e8b\u7684 adv. \u5e72\u51c0\u5730\uff0c\u6e05\u6d01\u5730\uff1b\u6e05\u695a\u5730\uff0c\u6e05\u6670\u5730\uff1b\u660e\u786e\u5730\uff1b\u660e\u663e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 974,
    word: "nettement",
    phonetic: "[n\u03b5tm\u0251\u0303]",
    type: "",
    translation: "\u5730\uff1b\u76f4\u622a\u4e86\u5f53\u5730\uff0c\u5e72\u8106\u5730\uff1b\u5f88\uff0c\u8bb8\u591a a. \u4e0d\u7531\u81ea\u4e3b\u7684\uff0c\u65e0\u610f\u8bc6\u7684\uff0c\u672c\u80fd\u7684\uff1b\u65e0\u610f\u7684\uff1b\u975e\u51fa\u672c\u610f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 975,
    word: "involontaire",
    phonetic: "[\u025b\u0303v\u0254l\u0254\u0303t\u03b5r]",
    type: "",
    translation: "\u7684 v.t. \u8fdb\u884c\uff0c\u5b9e\u65bd\uff1b\u7ed9\uff08\u67d0\u4eba\u6216\u8eab\u4f53\u67d0\u90e8\u5206\uff09\u65bd\u884c\u624b\u672f\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 976,
    word: "op\u00e9rer",
    phonetic: "[\u0254pere]",
    type: "",
    translation: "v.i. \u8fdb\u884c\uff0c\u5e72\uff0c\u505a\uff1b\u8d77\u4f5c\u7528\uff0c\u89c1\u6548\uff1b\u52a8\u624b\u672f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 977,
    word: "couch\u00e9",
    phonetic: "[ku\u222be]",
    type: "",
    translation: "adj.\u8eba\u7740\u7684\uff1b\u503e\u659c\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 978,
    word: "press\u00e9",
    phonetic: "[pr\u03b5se]",
    type: "",
    translation: "a. \u69a8\u8fc7\u7684\uff0c\u6324\u8fc7\u7684\uff1b\u5306\u5fd9\u7684\uff0c\u6025\u4fc3\u7684\uff1b\u7d27\u6025\u7684 n.m.\uff08\u4e00\u68f5\u6811\u7684\u5168\u90e8\uff09\u53f6\u5b50\uff0c\u53f6\u4e1b\uff1b\uff08\u4f10\u4e0b\u7684\uff09\u5e26\u53f6\u6811",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 979,
    word: "feuillage",
    phonetic: "[f\u0153ja\u0292]",
    type: "",
    translation: "\u679d n.f. \u50a8\u5907\uff08\u54c1\uff09\uff0c\u50a8\u85cf\uff08\u7269\uff09\uff1b\u50a8\u5b58\uff0c\u5907\u7528\uff1b\u5b58\u6b3e\uff1b\u90e8\u5206",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 980,
    word: "provision",
    phonetic: "[pr\u0254vizj\u0254\u0303]",
    type: "",
    translation: "\u4ed8\u6b3e\uff1b\u9884\u4ed8\u6b3e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 981,
    word: "remords",
    phonetic: "[r(\u0259)m\u0254r]",
    type: "",
    translation: "n.m. \u5185\u759a\uff0c\u6094\u6068\uff0c\u826f\u5fc3\u7684\u8d23\u5907",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 982,
    word: "principalement",
    phonetic: "[pr\u025b\u0303sipalm\u0251\u0303]",
    type: "",
    translation: "adv. \u4e3b\u8981\u5730\uff1b\u5c24\u5176\uff0c\u7279\u522b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 983,
    word: "fl\u00e8che",
    phonetic: "[fl\u03b5\u222b]",
    type: "",
    translation: "n.f. \u7bad\uff1b\u7bad\u5934\uff0c\u7bad\u5f62\u7b26\u53f7\uff0c\u7bad\u5f62\u6807\u5fd7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 984,
    word: "marine",
    phonetic: "[marin]",
    type: "",
    translation: "n.f. \u822a\u6d77\u672f\uff1b\u6d77\u5458\uff1b\u6d77\u8fd0\u4e1a\uff1b\u6d77\u519b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 985,
    word: "courant",
    phonetic: "[kur\u0251\u0303, -t]",
    type: "",
    translation: "a. \u6d41\u52a8\u7684\uff1b\u5f53\u524d\u7684\uff1b\u65e5\u5e38\u7684\uff0c\u5e73\u5e38\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 986,
    word: "renseignement",
    phonetic: "[r\u0251\u0303s\u03b5\u0272m\u0251\u0303]",
    type: "",
    translation: "n.m. \u60c5\u51b5\uff0c\u6d88\u606f\uff1b\u60c5\u62a5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 987,
    word: "facult\u00e9",
    phonetic: "[fakylte]",
    type: "",
    translation: "n.f. \u5b98\u80fd\uff0c\u80fd\u529b\uff1b\u624d\u80fd\uff1b\u5b66\u9662\uff1b\u7cfb\uff1b\u5927\u5b66",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 988,
    word: "tuyau",
    phonetic: "[t\u0265ijo]",
    type: "",
    translation: "n.m. \u7ba1\uff0c\u7ba1\u5b50\uff0c\u7ba1\u9053\uff0c\u5bfc\u7ba1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 989,
    word: "envers",
    phonetic: "[\u0251\u0303v\u03b5r]",
    type: "",
    translation: "n.m. \u53cd\u9762\uff0c\u80cc\u9762\uff1b\u76f8\u53cd\u7684\u4e00\u9762\uff0c\u53cd\u9762\uff1b\u80cc\u9634\u7684\u5c71\u5761",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 990,
    word: "gigantesque",
    phonetic: "[\u0292ig\u0251\u0303t\u03b5sk]",
    type: "",
    translation: "adj. 1.\u5de8\u4eba\u822c\u7684\uff1b\u9b41\u68a7\u7684\uff1b 2.\u5e9e\u5927\u7684\uff0c\u5b8f\u4f1f\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 991,
    word: "convenable",
    phonetic: "[k\u0254\u0303vnabl]",
    type: "",
    translation: "a. \u5408\u9002\u7684\uff0c\u9002\u5f53\u7684\uff1b\u5f97\u4f53\u7684\uff0c\u5408\u4e4e\u793c\u4eea\u7684\uff1b\u53ef\u63a5\u53d7\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 992,
    word: "moiti\u00e9",
    phonetic: "[mwatje]",
    type: "",
    translation: "n.f. \u4e00\u534a\uff1b\u4e00\u534a\u5de6\u53f3\uff1b\u8001\u5a46 n.f. \u4f11\u606f\uff0c\u6b47\u811a\uff1b\u4f11\u606f\u5904\uff0c\u6b47\u811a\u5904\uff1binterj. \u7ad9\u4f4f\uff01\u591f\u4e86\uff01",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 993,
    word: "halte",
    phonetic: "[alt]",
    type: "",
    translation: "\u865a\u97f3H \u884c\u4e86\uff01",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 994,
    word: "taillis",
    phonetic: "[taji]",
    type: "",
    translation: "n.m. \u77ee\u6797 100",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 995,
    word: "singe",
    phonetic: "[s\u025b\u0303\u0292]",
    type: "",
    translation: "n.m. \u7334 0 100",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 996,
    word: "ramper",
    phonetic: "[r\u0251\u0303pe]",
    type: "",
    translation: "v.i. \u722c\u884c\uff0c\u530d\u5310\u800c\u884c\uff1b\uff08\u690d\u7269\uff09\u8513\u751f\uff0c\u6500\u7f18 1 100",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 997,
    word: "tambour",
    phonetic: "[t\u0251\u0303bur]",
    type: "",
    translation: "n.m. \u9f13\uff1b\u9f13\u58f0\uff1b\u9f13\u624b\uff1b\u9f13\u5f62\u7269\uff1b\u7ede\u7b52\uff1b\u6eda\u7b52\uff1b\u5377\u7b52 2 100",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 998,
    word: "collier",
    phonetic: "[k\u0254lje]",
    type: "",
    translation: "n.m. \u9879\u94fe\uff0c\u9888\u9970\uff1b\uff08\u7272\u755c\u7684\uff09\u9888\u5708 3 27 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. 100",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 999,
    word: "tumulte",
    phonetic: "[tymylt]",
    type: "",
    translation: "n.m. \u9a9a\u4e71\uff0c\u5608\u6742\uff0c\u55a7\u95f9\uff1b\u6742\u4e71\uff0c\u70e6\u4e71\uff0c\u7eb7\u7e41 4 100",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1000,
    word: "supplice",
    phonetic: "[syplis]",
    type: "",
    translation: "n.m. \u9177\u5211\uff1b\uff08\u8089\u4f53\u7684\uff09\u5267\u75db\uff1b\u75db\u82e6\uff0c\u82e6\u607c\uff0c\u6298\u78e8 5 100",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1001,
    word: "courber",
    phonetic: "[kurbe]",
    type: "",
    translation: "v.t. \u4f7f\u5f2f\u66f2\uff0c\u4f7f\u5f2f\u4e0b\uff1b\u4f7f\u503e\u659c 6 100",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1002,
    word: "br\u00fbl\u00e9",
    phonetic: "[bryle]",
    type: "",
    translation: "n.m. \u7126\u7684\uff0c\u70e7\u7126\u7684\uff1b\u5931\u53bb\u4fe1\u7528\u7684\uff1b\u7126\u5473 7 100",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1003,
    word: "inspecteur",
    phonetic: "[\u025b\u0303sp\u03b5kt\u0153r]",
    type: "",
    translation: "n. \u89c6\u5bdf\u5458\uff0c\u68c0\u67e5\u5458\uff0c\u76d1\u5bdf\u5458 8 100 n. \u6307\u6325\u8005\uff0c\u957f\uff1b\u4e3b\u4eba\uff1b\u6559\u5e08\uff1bn.m. \u5e08\u5085\uff0c\u6559\u7ec3\uff1b\u5de5\u5934\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1004,
    word: "ma\u00eetre",
    phonetic: "[m\u03b5tr]",
    type: "",
    translation: "9 \u5927\u5e08 101",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1005,
    word: "bourreau",
    phonetic: "[buro]",
    type: "",
    translation: "n.m. \u523d\u5b50\u624b\uff1b\u6b8b\u5fcd\u7684\u4eba\uff0c\u8650\u5f85\u4ed6\u4eba\u7684\u4eba\uff1b\u62fc\u547d\u5e72\u6d3b\u7684\u4eba 0 101",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1006,
    word: "fourrure",
    phonetic: "[furyr]",
    type: "",
    translation: "n.f. \u6bdb\u76ae\uff0c\u76ae\u8d27\uff1b\u76ae\u8863\u670d\uff1b\u76ae\u6bdb 1 101",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1007,
    word: "industriel",
    phonetic: "[\u025b\u0303dystrij\u03b5l]",
    type: "",
    translation: "a. \u5de5\u4e1a\u7684\uff0c\u4ea7\u4e1a\u7684\uff1bn.m. \u4f01\u4e1a\u5bb6\uff0c\u5de5\u4e1a\u5bb6 2 101",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1008,
    word: "repr\u00e9sentation",
    phonetic: "[r\u0259prez\u0251\u0303tasj\u0254\u0303]",
    type: "",
    translation: "n.f. \u8868\u73b0\uff0c\u8868\u8fbe\uff1b\u8868\u793a\uff0c\u4f53\u73b0\uff0c\u8c61\u5f81\uff1b\u63cf\u7ed8 3 101 \u80af\u5b9a\u7684\uff0c\u786e\u5b9a\u7684\uff1b\u786e\u5b9e\u7684\uff0c\u786e\u51ff\u7684\uff1b\u786e\u4fe1\u7684\uff1b\u4e00\u4e9b\uff0c\u67d0 certaine 4 \u4e9b\uff1b\u67d0\u79cd\uff0c\u67d0\u4e2a\uff1b 101",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1009,
    word: "parti",
    phonetic: "[parti]",
    type: "",
    translation: "n.m. \u515a\uff0c\u653f\u515a\uff1b\u6d3e\uff0c\u6d3e\u522b 5 101",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1010,
    word: "farouche",
    phonetic: "[faru\u222b]",
    type: "",
    translation: "adj. 1.\u6613\u53d7\u60ca\u7684\uff0c\u80c6\u5c0f\u7684\uff1b 2.\u4e0d\u5408\u7fa4\u7684\uff1b\u91ce\u6027\u7684 6 101",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1011,
    word: "parcours",
    phonetic: "[parkur]",
    type: "",
    translation: "n.m. \u901a\u884c, \u901a\u8fc7, \u7ecf\u8fc7\uff1b\u822a\u7ebf\uff1b\u822a\u8def\uff1b\u8def\u7ebf\uff1b\u884c\u7a0b\uff0c\u91cc\u7a0b 7 101",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1012,
    word: "accro\u00eetre",
    phonetic: "[akrwatr]",
    type: "",
    translation: "v.t. \u589e\u52a0\uff0c\u589e\u957f\uff1b\u6269\u5927\uff0c\u58ee\u5927\uff1b\u589e\u5f3a\uff0c\u52a0\u5f3a 8 101",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1013,
    word: "domestique",
    phonetic: "[d\u0254m\u03b5stik]",
    type: "",
    translation: "a. \u5bb6\u5ead\u7684\uff0c\u5bb6\u5185\u7684\uff1b\u5bb6\u517b\u7684\uff0c\u9a6f\u517b\u7684\uff1bn. \u4ec6\u4eba\uff0c\u4f63\u4eba 9 102",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1014,
    word: "garer",
    phonetic: "[gare]",
    type: "",
    translation: "v.t. \u6536\u85cf\uff0c\u653e\u597d\uff1b\u505c\u653e\uff08\u8f66\u8f86\uff09\uff1b\u628a\uff08\u8f66\uff09\u5f00\u8fdb\u7ad9 0 102",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1015,
    word: "pendule",
    phonetic: "[p\u0251\u0303dyl]",
    type: "",
    translation: "n.m. \u6446\uff1bn.f. \u6446\u949f\uff0c\u6302\u949f\uff0c\u5ea7\u949f 1 102",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1016,
    word: "horloge",
    phonetic: "[\u0254rl\u0254\u0292]",
    type: "",
    translation: "n.f. \u949f\uff0c\u65f6\u949f 2 102",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1017,
    word: "mandat",
    phonetic: "[m\u0251\u0303da]",
    type: "",
    translation: "n.m. \u59d4\u6258\uff0c\u59d4\u4efb\uff1b\u59d4\u6258\u6743\uff1b\u59d4\u4efb\u671f\uff1b\u6c47\u7968\uff1b\u4ed8\u6b3e\u901a\u77e5 3 102",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1018,
    word: "affairer",
    phonetic: "[af\u03b5re]",
    type: "",
    translation: "v.pr. \u5fd9\u788c\uff0c\u5fd9 4 102",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1019,
    word: "compris",
    phonetic: "[k\u0254\u0303pri, -z]",
    type: "",
    translation: "a. \u5305\u62ec\u5728\u5185\u7684\uff1b\u7406\u89e3\u7684\uff0c\u61c2\u4e86\u7684 5 102",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1020,
    word: "nationalit\u00e9",
    phonetic: "[nasj\u0254nalite]",
    type: "",
    translation: "n.f. \u56fd\u7c4d\uff1b\u6c11\u65cf\uff1b\u6c11\u65cf\u6027\uff0c\u6c11\u65cf\u7279\u70b9 6 102",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1021,
    word: "\u00e9blouissant",
    phonetic: "[ebluis\u0251\u0303]",
    type: "",
    translation: "adj. \u4ee4\u4eba\u773c\u82b1\u7f2d\u4e71 7 102 n.m. \u5830\u5824\uff0c\u9632\u6ce2\u5824\uff0c\u5824\uff1b\u6d47\u94f8\uff1b\uff08\u88c5\u9970\u5bb6\u5177\u7684\uff09\u9970\u5e03\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1022,
    word: "jet\u00e9",
    phonetic: "[\u0292\u0259te]",
    type: "",
    translation: "8 \u3008\u4f53\u80b2\u3009\u633a\u4e3e 102 n.m. \u804c\u5458\uff0c\u96c7\u5458\uff0c\u529e\u4e8b\u5458\uff1b\u5e97\u5458\uff0c\u4f19\u8ba1\uff1b\u4ee3\u7406\u4eba\uff0c\u53d7\u6258",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1023,
    word: "commis",
    phonetic: "[k\u0254mi]",
    type: "",
    translation: "9 \u4eba 103",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1024,
    word: "locomotive",
    phonetic: "[l\u0254k\u0254m\u0254tiv]",
    type: "",
    translation: "n.f. \u673a\u8f66\uff0c\u706b\u8f66\u5934 0 103",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1025,
    word: "sifflet",
    phonetic: "[sifl\u03b5]",
    type: "",
    translation: "n.m. \u54e8\u5b50\uff1b\u6c7d\u7b1b\uff1bpl.\uff08\u8868\u793a\u53cd\u5bf9\u7684\uff09\u5618\u58f0\uff0c\u5012\u5f69\u58f0 1 103 v.t. \u4f7f\u6234\u4e0a\u9762\u7eb1\uff1b\u7528\u7f69\u5e03\u76d6\u4f4f\uff1b\u7528\u5e37\u5e54\u8499\u4f4f\uff1b\u63a9\u76d6\uff0c\u63a9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1026,
    word: "voiler",
    phonetic: "[vwale]",
    type: "",
    translation: "2 \u9970\uff1b\u9690\u7792\uff1b\u4f7f\u6697\u6de1\uff0c\u4f7f\u6a21\u7cca\uff0c\u4f7f\u6726\u80e7 28 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. 103 n.m. \u6811\u5e72\uff1b\u3008\u5efa\u7b51\u3009\u67f1\u8eab\uff1b\u6258\uff0c\u67c4\uff0c\u6746\uff0c\u67b6\uff0c\u652f\u67f1\uff1b\u9152",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1027,
    word: "f\u00fbt",
    phonetic: "[fy]",
    type: "",
    translation: "3 \u6876\uff0c\u5927\u6876 103",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1028,
    word: "coque",
    phonetic: "[k\u0254k]",
    type: "",
    translation: "n.f. \u679c\u58f3\uff1b\u7ed3 4 103",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1029,
    word: "intervalle",
    phonetic: "[\u025b\u0303t\u03b5rval]",
    type: "",
    translation: "n.m. \u95f4\u9694\uff0c\u95f4\u8ddd\uff1b\u95f4\u6b47\uff0c\u95f4\u9699\uff1b\u671f\u95f4\uff1b[\u4e50]\u97f3\u7a0b 5 103",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1030,
    word: "officier",
    phonetic: "[\u0254fisje]",
    type: "",
    translation: "n.m. \u519b\u5b98\uff1b\u5b98\u5458 6 103",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1031,
    word: "houle",
    phonetic: "[ul]",
    type: "",
    translation: "\u865a\u97f3H n.f. \u6d8c\u6d6a\uff0c\u6ce2\u6d9b\uff1b\u6ce2\u6d9b\u72b6\uff1b\u6fc0\u70c8 7 103",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1032,
    word: "rel\u00e2cher",
    phonetic: "[r\u0259l\u0251\u222be]",
    type: "",
    translation: "v.t. \u653e\u677e\uff0c\u4f7f\u677e\u5f1b\uff1b\u91ca\u653e\uff1b\u4f7f\u8212\u677e\uff1b\u4f7f\u677e\u61c8 8 103",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1033,
    word: "piloter",
    phonetic: "[pil\u0254te]",
    type: "",
    translation: "v.t. \u9886\u6e2f\uff0c\u9886\u822a\uff0c\u5f15\u6c34\uff1b\u9a7e\u9a76\uff1b\u9886\u8def\uff1b\u5728\u2026\u4e0a\u6253\u6869 9 104",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1034,
    word: "ruiner",
    phonetic: "[r\u0265ine]",
    type: "",
    translation: "v.t. \u4f7f\u7834\u4ea7\uff1b\u4f7f\u6bc1\u574f\uff0c\u4f7f\u706d\u4ea1\uff1b\u4f7f\u65e0\u529b\uff1b\u7834\u574f 0 104",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1035,
    word: "mis",
    phonetic: "[mi, -z]",
    type: "",
    translation: "adj. \u6446\u597d\u7684\uff1b\u7a7f\u7740\uff08\u8863\u670d\uff09\u7684 1 104",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1036,
    word: "promis",
    phonetic: "[pr\u0254mi]",
    type: "",
    translation: "a. \u5141\u8bfa\u7684\uff0c\u8bb8\u8bfa\u7684\uff0c\u7b54\u5e94\u7684 2 104 a. \u53ef\u5c0a\u656c\u7684\uff0c\u4ee4\u4eba\u5c0a\u656c\u7684\uff1b\u4f53\u9762\u7684\uff1b\u6709\u4fe1\u8a89\u7684\uff1b\u5149\u8363",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1037,
    word: "honorable",
    phonetic: "[\u0254n\u0254rabl]",
    type: "",
    translation: "3 \u7684\uff1b\u8fc7\u5f97\u53bb\u7684\uff0c\u8db3\u591f\u7684\uff0c\u76f8\u5f53\u597d\u7684 104",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1038,
    word: "compartiment",
    phonetic: "[k\u0254\u0303partim\u0251\u0303]",
    type: "",
    translation: "n.m. \u5206\u9694\u8f66\u5ba4\uff0c\u5305\u623f\uff0c\u5c0f\u95f4\uff1b\u683c\u5b50 4 104 adj. \u88ab\u8d85\u8fc7\u7684\uff0c\u88ab\u80dc\u8fc7\u7684\uff1b\u8fc7\u65f6\u7684\uff1b\u63a7\u5236\u4e0d\u4e86\u5c40\u9762\u7684\uff0c\u5e94",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1039,
    word: "d\u00e9pass\u00e9",
    phonetic: "[depase]",
    type: "",
    translation: "5 \u4ed8\u4e0d\u4e86\u5c40\u9762\u7684 104",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1040,
    word: "passerelle",
    phonetic: "[pasr\u03b5l]",
    type: "",
    translation: "n.f. \u6b65\u884c\u6865\uff0c\u5929\u6865\uff0c\u8df3\u677f\uff1b\u8237\u68af\uff0c\u5ba2\u68af\uff1b\u8fc7\u6e21\uff0c\u8854\u63a5 6 104",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1041,
    word: "bander",
    phonetic: "[b\u0251\u0303de]",
    type: "",
    translation: "v. \u5305\u624e\uff1b\u8499\u4f4f\uff0c\u5305\u4f4f\uff1b\u62c9\u7d27\uff1b\u88ab\u62c9\u7d27\uff0c \u88ab\u7ef7\u7d27 7 104",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1042,
    word: "terrestre",
    phonetic: "[t\u03b5r\u03b5str]",
    type: "",
    translation: "a. \u5730\u7403\u7684\uff1b\u9646\u5730\u7684\uff1b\u9646\u751f\u7684\uff1b\u9646\u4e0a\u7684\uff1b\u4eba\u95f4\u7684 8 104",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1043,
    word: "avanc\u00e9",
    phonetic: "[av\u0251\u0303se]",
    type: "",
    translation: "a. \u524d\u9762\u7684\uff0c\u524d\u65b9\u7684\uff1b\u5148\u8fdb\u7684\uff0c\u8fdb\u6b65\u7684\uff1b\u63d0\u524d\u7684\uff0c\u63d0\u65e9\u7684 9 105",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1044,
    word: "r\u00e9serv\u00e9",
    phonetic: "[rez\u03b5rve]",
    type: "",
    translation: "adj. \u9884\u5b9a\u7684\uff0c\u4fdd\u7559\u7684\uff1b\u7a33\u91cd\u7684\u4eba\uff1b\u8c28\u614e\u7684\uff0c\u7a33\u91cd\u7684 0 105 a. \u540c\u8c0b\u7684\uff0c\u5171\u72af\u7684\uff0c\u5e2e\u51f6\u7684\uff1b\u9ed8\u5951\u7684\uff0c\u4f1a\u5fc3\u7684\uff0c\u4e32\u901a\u597d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1045,
    word: "complice",
    phonetic: "[k\u0254\u0303plis]",
    type: "",
    translation: "1 \u7684\uff1bn. \u540c\u8c0b\u8005\uff0c\u5171\u72af\uff0c\u5e2e\u51f6 105",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1046,
    word: "parier",
    phonetic: "[parje]",
    type: "",
    translation: "v.t. \u6253\u8d4c\uff1b\u8d4c\uff1b\u80af\u5b9a\uff0c\u62c5\u4fdd 2 105",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1047,
    word: "parent",
    phonetic: "[par\u0251\u0303, -t]",
    type: "",
    translation: "n. \u4eb2\u5c5e\uff0c\u4eb2\u621a\uff1b\uff08\u5b66\u751f\uff09\u5bb6\u957f\uff1bn.m. pl. \u7236\u6bcd\uff0c\u53cc\u4eb2 3 105",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1048,
    word: "passant",
    phonetic: "[pas\u0251\u0303, -t]",
    type: "",
    translation: "a. \u884c\u4eba\u5f88\u591a\u7684\uff0c\u8f66\u8f86\u6765\u5f80\u9891\u7e41\u7684\uff1bn. \u8fc7\u8def\u4eba\uff0c\u884c\u4eba 4 105",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1049,
    word: "couvert",
    phonetic: "[kuv\u03b5r, -t]",
    type: "",
    translation: "a. \u7a7f\u8863\u7684\uff0c\u6234\u5e3d\u7684\uff1b\u5e26\u7bf7\u7684\uff0c\u6709\u5c4b\u9876\u7684\uff1bn.m. \u9910\u5177 5 105 v.t.\uff0c v.pr. \u6298\u78e8\uff0c\u4f7f\u75db\u82e6\uff0c\u4f7f\u82e6\u607c\uff0c\u4f7f\u5fe7\u8651\uff1b\u7ea0\u7f20\uff0c\u70e6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1050,
    word: "tourmenter",
    phonetic: "[turm\u0251\u0303te]",
    type: "",
    translation: "6 \u6270\uff1b\u4f7f\u98a0\u7c38\uff1b\u6b6a\u66f2\uff0c\u66f2\u89e3 105",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1051,
    word: "d\u00e9sesp\u00e9r\u00e9",
    phonetic: "[dez\u03b5spere]",
    type: "",
    translation: "a. \u7edd\u671b\u7684\uff1b\u65e0\u52a9\u7684\uff1b\u6beb\u65e0\u5e0c\u671b\u7684\uff1bn. \u7edd\u671b\u8005 7 105 n.f. \u94b1\u5305\uff0c\u94b1\u5939\uff1b\u5956\u5b66\u91d1\uff0c\u52a9\u5b66\u91d1\uff1b\u4ea4\u6613\u6240\uff0c\u8bc1\u5238\u4ea4\u6613",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1052,
    word: "bourse",
    phonetic: "[burs]",
    type: "",
    translation: "8 \u6240\uff1b\u8bc1\u5238\u4ea4\u6613 105",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1053,
    word: "invariablement",
    phonetic: "[\u025b\u0303varjabl\u0259m\u0251\u0303]",
    type: "",
    translation: "adv. \u4e0d\u53d8\u5730\uff0c \u603b\u662f 9 106 adj. 1.\u503c\u5f97\u6ce8\u610f\u7684\uff0c\u60f9\u4eba\u6ce8\u76ee\uff1b 2.\u5353\u8d8a\u7684\uff0c\u975e\u51e1\u7684\uff1b\u51fa",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1054,
    word: "remarquable",
    phonetic: "[r(\u0259)markabl]",
    type: "",
    translation: "0 \u8272\u7684 106",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1055,
    word: "valet",
    phonetic: "[val\u03b5]",
    type: "",
    translation: "n.m. \u4ec6\u4ece\uff0c\u4ec6\u4eba\uff1b\u5974\u6027\u5341\u8db3\u7684\u4eba\uff0c\u5974\u624d 1 29 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. 106",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1056,
    word: "foug\u00e8re",
    phonetic: "[fu\u0292\u03b5r]",
    type: "",
    translation: "n.f. \u8568 2 106",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1057,
    word: "\u00e9clair\u00e9",
    phonetic: "[eklere]",
    type: "",
    translation: "a. \u77e5\u8bc6\u6e0a\u535a\u7684\uff0c\u7ecf\u9a8c\u4e30\u5bcc\u7684\uff0c\u5185\u884c\u7684\uff0c\u6709\u89c1\u8bc6\u7684 3 106",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1058,
    word: "embarrass\u00e9",
    phonetic: "[\u0251\u0303barase]",
    type: "",
    translation: "a. \u88ab\u963b\u585e\u7684\uff0c\u53d7\u963b\u788d\u7684\uff1b\u4e3a\u96be\u7684\uff0c\u5c34\u5c2c\u7684 4 106",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1059,
    word: "\u00e9loign\u00e9",
    phonetic: "[elwa\u0272e]",
    type: "",
    translation: "a. \u8fdc\u79bb\u7684\uff0c\u8fdc\u9694\u7684\uff1b\u9065\u8fdc\u7684\uff1b\u8fdc\u5904\u7684 5 106",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1060,
    word: "cinquantaine",
    phonetic: "[s \u025b\u0303k\u0251\u0303t\u025bn]",
    type: "",
    translation: "n.f. \u4e94\u5341\uff0c\u4e94\u5341\u5de6\u53f3\uff1b\u4e94\u5341\u5c81\uff0c\u4e94\u5341\u5c81\u5de6\u53f3 6 106 v.t. \u6d88\u8017\uff0c\u6d88\u8d39\uff1b\u5b8c\u6210\uff1b\u98df\u7528\uff1b\uff08\u5728\u5496\u5561\u9986\u3001\u9152\u9986\u7b49\uff09\u559d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1061,
    word: "consommer",
    phonetic: "[k\u0254\u0303s\u0254me]",
    type: "",
    translation: "7 \u996e\u6599 106",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1062,
    word: "compliment",
    phonetic: "[k\u0254\u0303plim\u0251\u0303]",
    type: "",
    translation: "n.m. \u79f0\u8d5e\u7684\u8bdd\uff1b\u606d\u7ef4\u8bdd\uff1b\u795d\u8bcd\uff0c\u8d3a\u8bcd 8 106",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1063,
    word: "cape",
    phonetic: "[kap]",
    type: "",
    translation: "n.f. \u6597\u7bf7\uff0c\u62ab\u98ce 9 107",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1064,
    word: "photographier",
    phonetic: "[f\u0254t\u0254grafje]",
    type: "",
    translation: "v.t. \u62cd\u6444\uff0c\u7ed9\u2026\u2026\u7167\u76f8\uff1b\u94ed\u8bb0\uff0c\u628a\u2026\u2026\u5370\u5165\u8111\u4e2d 0 107 n.m. \u5e8a\u5934\uff0c\u6795\u8fb9\uff1b\u3010\u5efa\u7b51\u3011(\u6559\u5802\u4e2d\u6bbf\u5185)\u53f8\u796d\u5e2d\u7684\u540e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1065,
    word: "chevet",
    phonetic: "[\u222b\u0259v\u03b5]",
    type: "",
    translation: "1 \u90e8\uff1b\u3010\u77ff\u7269\u3011\u77ff\u8109\u5e95\u90e8 107",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1066,
    word: "renvers\u00e9",
    phonetic: "[r\u0251\u0303v\u03b5rse]",
    type: "",
    translation: "adj. \u98a0\u5012\u7684\uff1b\u53cd\u5411\u7684 2 107 v.t. \u7763\u4fc3\uff0c\u6566\u4fc3\uff0c\u50ac\u544a\uff0c\u8b66\u544a\uff1b\u52d2\u4ee4\uff0c\u8d23\u4ee4\uff1b\u8981\u6c42\uff1b\u3008\u6cd5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1067,
    word: "sommer",
    phonetic: "[s\u0254me]",
    type: "",
    translation: "3 \u5b66\u3009\u4f20\u5524\uff1b\u3008\u6570\u5b66\u3009\u6c42\u548c 107 v.i. \u51fa\u6c57\uff0c\u6d41\u6c57\uff1b\u5192\u6c34\u6c7d\uff0c\u6e17\u6c34\uff0c\u6ef4\u6c34\u73e0\uff1b\u8f9b\u52b3\uff0c\u8d39\u529b\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1068,
    word: "suer",
    phonetic: "[s\u0265e]",
    type: "",
    translation: "4 \u8d39\u52b2 107",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1069,
    word: "gentleman",
    phonetic: "[d\u0292\u03b5ntl\u0259man]",
    type: "",
    translation: "n.m. \u7ec5\u58eb 5 107",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1070,
    word: "voulu",
    phonetic: "[vuly]",
    type: "",
    translation: "adj. \u9700\u8981\u7684\uff0c \u89c4\u5b9a\u7684\uff1b\u6545\u610f\u7684 6 107 v.i. \u884c\u8fdb\uff0c\u8d70\u8def\uff0c\u884c\u8d70\uff1b\u7f13\u8fdb\uff0c\u6e10\u8fdb\uff1b\u8fdb\u884c\uff0c\u524d\u8fdb\uff1b\u3008\u519b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1071,
    word: "cheminer",
    phonetic: "[\u222bmine]",
    type: "",
    translation: "7 \u4e8b\u3009\u903c\u8fd1\uff0c\u63a8\u8fdb 107 v.t.\uff0c v.pr. \u4f7f\u70e6\u607c\uff0c\u4f7f\u64cd\u5fc3\uff1b\u64cd\u52b3\uff0c\u82e6\u5e72\uff0c\u75b2\u4e8e\uff1b\u82b1\u6c14",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1072,
    word: "peiner",
    phonetic: "[p\u03b5ne]",
    type: "",
    translation: "8 \u529b\uff0c\u52aa\u529b 107",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1073,
    word: "destination",
    phonetic: "[d\u03b5stinasj\u0254\u0303]",
    type: "",
    translation: "n.f. \u7528\u9014\uff1b\u76ee\u7684\u5730\uff0c\u7ec8\u70b9 9 108",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1074,
    word: "soit",
    phonetic: "[swa]",
    type: "",
    translation: "adj. \u5373\uff0c\u5c31\u662f\uff0c\u7b49\u4e8e\u8bf4\uff1b\u5047\u5b9a\uff1b\u597d\u5427\uff0c\u884c\u5427\uff0c\u4e5f\u597d 0 108 adj. \u6c89\u7740\u7684\uff0c \u9547\u5b9a\u7684\uff1b \u51b7\u9759\u7684\uff0c \u575a\u5b9a\u7684\uff0c \u4e0d\u53ef\u52a8\u6447",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1075,
    word: "imperturbable",
    phonetic: "[\u025b\u0303p\u03b5rtyrbabl]",
    type: "",
    translation: "1 \u7684\uff1a 108",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1076,
    word: "\u00e9mu",
    phonetic: "[emy]",
    type: "",
    translation: "a. \u6fc0\u52a8\u7684\uff0c\u611f\u52a8\u7684 2 108",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1077,
    word: "circulaire",
    phonetic: "[sirkyl\u03b5r]",
    type: "",
    translation: "a. \u5706\u7684\uff1b\u5706\u5468\u7684\uff1b\u73af\u7ed5\u7684\uff0c\u5faa\u73af\u7684\uff1bn.f. \u901a\u62a5\uff0c\u901a\u77e5 3 108 n.m. \u83b7\u80dc\uff0c\u80dc\u5229\uff0c\u8d62\u5f97\uff1b\u6536\u76ca\uff0c\u6536\u83b7\uff1b\u6536\u5165\uff1b\u597d\u5904\uff0c\u5229",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1078,
    word: "gain",
    phonetic: "[g\u025b\u0303]",
    type: "",
    translation: "4 \u76ca 108",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1079,
    word: "m\u00e9canicien",
    phonetic: "[mekanisj\u025b\u0303]",
    type: "",
    translation: "n. \u673a\u68b0\u5e08\uff1b\u529b\u5b66\u4e13\u5bb6 5 108",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1080,
    word: "haute",
    phonetic: "['ot]",
    type: "",
    translation: "\u865a\u97f3H n.f. \u4e0a\u6d41\u793e\u4f1a 6 108",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1081,
    word: "contredire",
    phonetic: "[k\u0254\u0303tr\u0259dir]",
    type: "",
    translation: "v.t.\uff0c v.pr. 1.\u53cd\u9a73\uff0c\u8fa9\u9a73\uff1b 2.\u4e0e...\u76f8\u53cd 7 adj. \u7f29\u5c0f\u7684\uff0c\u7f29\u51cf\u4e86\u7684\uff1b\u51cf\u4f4e\u7684\uff0c\u964d\u4f4e\u7684\uff1b\u524a\u51cf\u7684\uff1a\u5730\u5904 108 \u4e0d\u663e\u773c\u5730\u65b9\u7684\u5c0f\u623f\u95f4\uff1b\u964b\u5ba4\uff0c\u7834\u65e7\u7684\u5c0f\u5c4b\uff1b\u5c4b\u9685\uff0c\u58c1\u51f9\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1082,
    word: "r\u00e9duit",
    phonetic: "[red\u0265i]",
    type: "",
    translation: "8 \uff08\u57ce\u5821\u6700\u91cc\u5c42\u7684\uff09\u5185\u5821\uff1b\uff08\u519b\u8230\u7684\uff09\u5185\u70ae\u5854\uff1b\u888b\u5f62\u62b5\u6297\u9635 \u5730\uff1b\u9690\u853d\u5904\uff0c \u907f\u96be\u6240 30 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. 108",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1083,
    word: "v\u00eatu",
    phonetic: "[vety]",
    type: "",
    translation: "a. \u7a7f\u7740\u8863\u670d\u7684 9 109 n.m. \u51b3\u5b9a\uff0c\u51b3\u8bae\uff0c\u547d\u4ee4\uff1b\u51b3\u7b97\uff0c\u7ed3\u7b97\uff1b\u5224\u51b3\uff1b\u51b3\u5b9a\u7684\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1084,
    word: "arr\u00eat\u00e9",
    phonetic: "[ar\u03b5te]",
    type: "",
    translation: "0 \u4e0d\u53ef\u52a8\u6447\u7684 109 a. \u62ac\u8d77\u7684\uff1b\u52a0\u9ad8\u7684\uff1b\u7ffb\u8d77\u7684\uff0c\u5377\u8d77\u7684\uff1bn.m. \u6284\u5f55\uff0c\u8bb0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1085,
    word: "relev\u00e9",
    phonetic: "[r\u0259lve]",
    type: "",
    translation: "1 \u5f55\uff1b\u6e05\u5355\uff1b\u8d26\u5355\uff1b\u7edf\u8ba1\u8868 109",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1086,
    word: "robuste",
    phonetic: "[r\u0254byst]",
    type: "",
    translation: "a. \u5f3a\u58ee\u7684\uff0c\u7ed3\u5b9e\u7684\uff1b\u575a\u56fa\u7684\uff0c\u8010\u7528\u7684 2 109",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1087,
    word: "maudire",
    phonetic: "[modir]",
    type: "",
    translation: "v.t. \u8bc5\u5492\uff0c\u5492\u9a82\uff1b\u8d23\u9a82\uff0c\u62b1\u6028 3 109",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1088,
    word: "consul",
    phonetic: "[k\u0254\u0303syl]",
    type: "",
    translation: "n.m. \u9886\u4e8b\uff1b\u5546\u4e8b\u88c1\u5224\u5b98 4 109",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1089,
    word: "m\u00e2t",
    phonetic: "[m\u0251]",
    type: "",
    translation: "n.m. \u6845\uff0c\u6845\u6746\uff1b\u65d7\u6746 5 109",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1090,
    word: "prodiguer",
    phonetic: "[pr\u0254dige]",
    type: "",
    translation: "v.t.\uff0c v.pr. \u6325\u970d\uff0c\u6d6a\u8d39\uff1b\u6ee5\u7528\uff1b\u6177\u6168\u5730\u7ed9\u4e88 6 109",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1091,
    word: "pacifique",
    phonetic: "[pasifik]",
    type: "",
    translation: "a. \u70ed\u7231\u548c\u5e73\u7684\uff1b\u5e73\u548c\u7684\uff0c\u6e29\u548c\u7684\uff1b\u548c\u5e73\u7684\uff1b\u592a\u5e73\u7684 7 109",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1092,
    word: "douane",
    phonetic: "[dwan]",
    type: "",
    translation: "n.f. \u6d77\u5173\uff1b\u6d77\u5173\u603b\u7f72\uff1b\u5173\u7a0e 8 109",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1093,
    word: "oblig\u00e9",
    phonetic: "[\u0254bli\u0292e]",
    type: "",
    translation: "a. \u8d1f\u6709\u4e49\u52a1\u7684\uff1b\u88ab\u8feb\u7684\uff1b\u4e0d\u53ef\u907f\u514d\u7684\uff1b\u611f\u6069\u7684 9 110",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1094,
    word: "cons\u00e9quent",
    phonetic: "[k\u0254\u0303sek\u0251\u0303]",
    type: "",
    translation: "a. \u59cb\u7ec8\u4e0d\u6e1d\u7684\uff0c\u4e00\u8d2f\u7684\uff1b\u91cd\u8981\u7684\uff0c\u91cd\u5927\u7684 0 110",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1095,
    word: "invraisemblable",
    phonetic: "[\u025b\u0303vr\u03b5s\u0251\u0303blabl]",
    type: "",
    translation: "a. \u4e0d\u50cf\u771f\u7684\uff0c \u672a\u5fc5\u786e\u5b9e\u7684\uff0c\u4e0d\u53ef\u9760\u7684\uff1b\u5947\u7279\u7684 1 110 a. \u5bb9\u6613\u7684\uff0c\u8f7b\u4fbf\u7684\uff0c\u4fbf\u5229\u7684\uff1b\u81ea\u5728\u7684\uff1b\u65e0\u62d8\u65e0\u675f\u7684\uff1b\u5bcc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1096,
    word: "ais\u00e9",
    phonetic: "[eze]",
    type: "",
    translation: "2 \u88d5\u7684 110",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1097,
    word: "royale",
    phonetic: "[rwajal]",
    type: "",
    translation: "n.f. \u7687\u65cf 3 110",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1098,
    word: "joueur",
    phonetic: "[\u0292w\u0153r]",
    type: "",
    translation: "n. \u6e38\u620f\u8005\uff1b\u8fd0\u52a8\u5458\uff1b\u8d4c\u5f92\uff1b\u6f14\u594f\u8005 4 110",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1099,
    word: "commune",
    phonetic: "[k\u0254myn]",
    type: "",
    translation: "n.f. \u5e02\u9547\uff1b[\u53f2]\u516c\u793e 5 110 a. \u52c7\u6562\u7684\uff0c\u5927\u80c6\u7684\uff0c\u6709\u52c7\u6c14\u7684\uff1b\u575a\u5b9a\u7684\uff0c\u679c\u65ad\u7684\uff1b\u653e\u8086",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1100,
    word: "hardi",
    phonetic: "[ardi]",
    type: "",
    translation: "\u865a\u97f3H 6 \u7684\uff1b\u539a\u989c\u7684 110",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1101,
    word: "trot",
    phonetic: "[tro]",
    type: "",
    translation: "n.m. \uff08\u9a6c\u7b49\u7684\uff09\u5feb\u6b65\uff0c\u5c0f\u8dd1 7 110",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1102,
    word: "s\u00fbret\u00e9",
    phonetic: "[syrte]",
    type: "",
    translation: "n.f. \u5b89\u5168\uff1b\u5b89\u5168\u6027\uff0c\u53ef\u9760\u6027\uff1b\u4fdd\u9669\uff1b\u51c6\u786e\uff1b\u53ef\u9760\uff0c\u7a33\u5f53 8 110",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1103,
    word: "f\u00e2cheux",
    phonetic: "[f\u0251\u222b\u00f8]",
    type: "",
    translation: "a. \u4ee4\u4eba\u4e0d\u5feb\u7684\uff0c\u4ee4\u4eba\u607c\u706b\u7684\uff1b\u6709\u635f\u5bb3\u7684\uff1b\u4e0d\u9002\u5f53\u7684 9 111",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1104,
    word: "musicien",
    phonetic: "[myzisj\u025b\u0303]",
    type: "",
    translation: "n. \u97f3\u4e50\u5bb6\uff0c\u4f5c\u66f2\u5bb6\uff1b\u6f14\u594f\u5bb6\uff0c\u4e50\u5e08 0 111",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1105,
    word: "d\u00e9couvert",
    phonetic: "[dekuv\u03b5r, -t]",
    type: "",
    translation: "a. \u66b4\u9732\u7684\uff0c\u65e0\u906e\u76d6\u7684\uff1bn.m. \u900f\u652f\u91d1\u989d 1 111",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1106,
    word: "surveillance",
    phonetic: "[syrv\u03b5j\u0251\u0303s]",
    type: "",
    translation: "n.f. 1.\u76d1\u89c6\uff1b \u76d1\u7763\uff1b 2.\u8b66\u6212\uff1b 3.\u53d7\u76d1\u89c6\uff1b \u53d7\u770b\u7ba1 2 111 n.f. \u6a2a\u6863\uff0c\u6a2a\u6881\uff1b\u8f68\u6795\uff0c\u6795\u6728\uff1b\u6a2a\u9053\uff0c\u8fd1\u8def\uff0c\u6377\u5f84\uff1b\u56f0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1107,
    word: "traverse",
    phonetic: "[trav\u03b5rs]",
    type: "",
    translation: "3 \u96be\uff0c\u969c\u788d\uff0c\u632b\u6298 111 n.m. \u8349\u56fe\uff0c\u56fe\u6837\uff1b\u822a\u7ebf\uff0c\u8def\u7ebf\uff1b\u3008\u6280\u672f\u3009\u5b9a\u7ebf\uff0c\u8f6e\u5ed3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1108,
    word: "trac\u00e9",
    phonetic: "[trase]",
    type: "",
    translation: "4 \u7ebf\uff0c\u653e\u6837\u7ebf 111",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1109,
    word: "lier",
    phonetic: "[lje]",
    type: "",
    translation: "v.t. \u7ed1\uff0c\u6346\uff1b\u8fde\u63a5\uff1b\u7ed3\u5408\uff0c\u8054\u7cfb\uff1b\u8054\u5408\uff1b\u675f\u7f1a 5 111",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1110,
    word: "ceinture",
    phonetic: "[s\u025b\u0303tyr]",
    type: "",
    translation: "n.f. \u8170\u5e26\uff0c\u88e4\u5e26\uff1b\u88e4\u8170\uff0c\u88d9\u8170\uff1b\uff08\u8eab\u4f53\u7684\uff09\u8170\u90e8\uff1b\u56f4\u7ed5\u7269 6 111",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1111,
    word: "contempler",
    phonetic: "[k\u0254\u0303t\u0251\u0303ple]",
    type: "",
    translation: "v.t. \u51dd\u89c6\uff0c\u6ce8\u89c6\uff1b\u51fa\u795e\u5730\u770b\uff0c\u6b23\u8d4f\u5730\u770b\uff0c\u60ca\u8bb6\u5730\u770b 7 31 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. 111",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1112,
    word: "suivant",
    phonetic: "[s\u0265iv\u0251\u0303, -t]",
    type: "",
    translation: "adj. \u968f\u540e\u7684\uff0c\u4e0b\u4e00\u4e2a\u7684\uff1bpr\u00e9p. \u6309\u7167\uff0c\u6839\u636e 8 111 adj.num.card.\uff0c adj.inv. \u5341\u516d\uff1b\u7b2c\u5341\u516d\uff1b\uff08\u4e00\u4e2a\u6708\u4efd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1113,
    word: "seize",
    phonetic: "[s\u03b5z]",
    type: "",
    translation: "9 \u7684\uff09\u5341\u516d\u65e5 112 n.m. \u77ee\u6811\u6797\uff0c\u77ee\u6811\u4e1b\uff0c\u4e1b\u6797\uff1b\u6709\u76ae\u6bdb\u5939\u91cc\u7684\uff1b\u6709\u6d53\u6bdb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1114,
    word: "fourr\u00e9",
    phonetic: "[fure]",
    type: "",
    translation: "0 \u7684\uff1b\u5939\u9985\u7684\uff0c\u5939\u5fc3\u7684 112",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1115,
    word: "\u00e9clair",
    phonetic: "[ekl\u03b5r]",
    type: "",
    translation: "n.m. 1.\u7535\u5149\uff0c\u95ea\u5149\uff1b\u95ea\u8fc7\uff1b\u5239\u90a3\u95f4 2.\u95ea\u73b0\u5f0f\u7684\uff0c\u6781\u5feb\u7684 1 112 a. \u8fde\u7eed\u7684\uff0c\u4e0d\u65ad\u7684\uff1b\u7ecf\u5e38\u7684\uff1b\u8fde\u8d2f\u7684\uff1b\u542c\u4f17\u591a\u7684\uff0c\u89c2\u4f17",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1116,
    word: "suivi",
    phonetic: "[s\u0265ivi]",
    type: "",
    translation: "2 \u591a\u7684 112",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1117,
    word: "atteint",
    phonetic: "[at\u025b\u0303]",
    type: "",
    translation: "adj. \u88ab\u51fb\u4e2d\u7684\uff1b\u5f97\u75c5\u7684\uff0c\u67d3\u4e0a\u75be\u75c5\u7684 3 112",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1118,
    word: "employ\u00e9",
    phonetic: "[\u0251\u0303plwaje]",
    type: "",
    translation: "n. \u804c\u5458\uff0c\u96c7\u5458 4 112",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1119,
    word: "brouette",
    phonetic: "[bru\u03b5t]",
    type: "",
    translation: "n.f. \u72ec\u8f6e\u624b\u63a8\u5c0f\u8f66 5 112",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1120,
    word: "merveilleusement",
    phonetic: "[m\u03b5rv\u03b5j\u00f8zm\u0251\u0303]",
    type: "",
    translation: "adv. \u5947\u5999 6 112",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1121,
    word: "agile",
    phonetic: "[a\u0292il]",
    type: "",
    translation: "a. \u7075\u6d3b\u7684\uff0c\u654f\u6377\u7684\uff0c\u4f36\u4fd0\u7684 7 112",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1122,
    word: "emport\u00e9",
    phonetic: "[\u0251\u0303p\u0254rte]",
    type: "",
    translation: "adj. \u66b4\u8e81\u7684\uff0c\u6613\u6012\u7684\uff0c\u6025\u6027\u5b50\u7684 8 112",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1123,
    word: "pouss\u00e9",
    phonetic: "[puse]",
    type: "",
    translation: "adj. \u63d0\u9ad8\u7684\uff0c\u52a0\u5f3a\u7684\uff0c\u6df1\u5165\u7684\uff0c\u7cbe\u5de5\u7ec6\u4f5c\u7684 9 113",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1124,
    word: "golfe",
    phonetic: "[g\u0254lf]",
    type: "",
    translation: "n.m. \u6d77\u6e7e 0 113 a. \u72c2\u70ed\u7684\uff0c\u76f2\u4fe1\u7684\uff1b\u72c2\u70ed\u5d07\u62dc\u7684\uff0c\u72c2\u70ed\u7231\u597d\u7684\uff1bn. \u72c2\u70ed",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1125,
    word: "fanatique",
    phonetic: "[fanatik]",
    type: "",
    translation: "1 \u8005\uff0c\u76f2\u4fe1\u8005\uff1b\u72c2\u70ed\u5d07\u62dc\u8005\uff0c\u72c2\u70ed\u7231\u597d\u8005 113",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1126,
    word: "magistrat",
    phonetic: "[ma\u0292istra]",
    type: "",
    translation: "n.m. \u53f8\u6cd5\u5b98\u5458\uff1b\u884c\u653f\u5b98\u5458\uff1b\u6cd5\u5b98\uff1b\u5ba1\u5224\u5b98\uff1b\u68c0\u5bdf\u5b98 2 113",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1127,
    word: "sonn\u00e9",
    phonetic: "[s\u0254ne]",
    type: "",
    translation: "adj.\uff08\u949f\u70b9\u7b49\uff09\u5df2\u6572\u8fc7\u7684\uff1b\u88ab\u51fb\u5012\u7684\uff1b \u88ab\u51fb\u660f\u7684 3 113",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1128,
    word: "capricieux",
    phonetic: "[kaprisj\u00f8]",
    type: "",
    translation: "a. \u4efb\u6027\u7684\uff0c\u53cd\u590d\u65e0\u5e38\u7684\uff1b\u591a\u53d8\u7684\uff0c\u53d8\u5e7b\u83ab\u6d4b\u7684 4 113",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1129,
    word: "insuffisant",
    phonetic: "[\u025b\u0303syfiz\u0251\u0303, -t]",
    type: "",
    translation: "a. \u4e0d\u8db3\u7684\uff0c\u4e0d\u591f\u7684\uff0c\u7f3a\u4e4f\u7684\uff1b\u7f3a\u4e4f\u80fd\u529b\u7684 5 113",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1130,
    word: "mollir",
    phonetic: "[m\u0254lir]",
    type: "",
    translation: "v.i. \u53d8\u5f97\u8f6f\u5f31\u65e0\u529b\uff0c\u51cf\u5f31\uff1b\u9000\u8ba9\uff1b\u964d\u4f4e 6 113",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1131,
    word: "vigoureusement",
    phonetic: "[vigur\u00f8zm\u0251]",
    type: "",
    translation: "adv. \u5927\u529b 7 113 a. \u5bf9\u5f53\u4ee3\u95ee\u9898\u8868\u6001\u6216\u91c7\u53d6\u884c\u52a8\u7684[\u6307\u4f5c\u5bb6\u3001\u827a\u672f\u5bb6]\uff0c\u4ecb\u5165",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1132,
    word: "engag\u00e9",
    phonetic: "[\u0251\u0303ga\u0292e]",
    type: "",
    translation: "8 \uff08\u653f\u6cbb\uff09\u7684\uff0c\u5377\u5165\u7684\uff1b\u5e94\u52df\u5165\u4f0d\u7684 113",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1133,
    word: "bourrasque",
    phonetic: "[burask]",
    type: "",
    translation: "n.f. \u72c2\u98ce\uff0c\u9635\u98ce\uff0c\u66b4\u98ce\uff1b\u4e00\u65f6\u6fc0\u6012\uff1b\u7206\u53d1\uff0c\u7a81\u53d1 9 114",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1134,
    word: "canon",
    phonetic: "[kan\u0254\u0303]",
    type: "",
    translation: "n.m. \u70ae\uff0c\u5927\u70ae\uff1b\u70ae\u7ba1\uff0c\u70ae\u7b52\uff1b\u67aa\u7ba1\uff0c\u67aa\u7b52\uff1b\u6559\u89c4 0 114 adj. \u7ea6\u5b9a\uff0c\u5546\u59a5\uff0c\u5546\u5b9a\uff1b\u4e60\u60ef\uff1b\u7ea6\u5b9a\u7684\uff0c\u5546\u59a5\u7684\uff0c\u5546\u5b9a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1135,
    word: "convenu",
    phonetic: "[k\u0254\u0303vny]",
    type: "",
    translation: "1 \u7684\uff1b\u4e60\u60ef\u7684 114",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1136,
    word: "ramure",
    phonetic: "[ramyr]",
    type: "",
    translation: "n.f. \uff08\u4e00\u68f5\u6811\u7684\uff09\u679d\u53f6\uff1b\u9e7f\u7c7b\u7684\u89d2 2 114",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1137,
    word: "violent",
    phonetic: "[vj\u0254l\u0251\u0303]",
    type: "",
    translation: "a. \u731b\u70c8\u7684\uff0c\u5267\u70c8\u7684\uff1b\u4f7f\u7528\u66b4\u529b\u7684\uff1b\u7c97\u66b4\u7684 3 114",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1138,
    word: "dock",
    phonetic: "[d\u0254k]",
    type: "",
    translation: "n.m. \u7801\u5934\uff1b\u8239\u575e\uff1b\u7801\u5934\u4ed3\u5e93 4 114",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1139,
    word: "consciencieusement",
    phonetic: "[k\u0254\u0303sj\u0251\u0303sj\u00f8zm\u0251\u0303]",
    type: "",
    translation: "adv. \u5207\u5b9e 5 114",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1140,
    word: "pus",
    phonetic: "[py]",
    type: "",
    translation: "n.m. \u8113 6 32 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. 114",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1141,
    word: "braver",
    phonetic: "[brave]",
    type: "",
    translation: "v.t. \u5192\uff0c\u4e0d\u987e\uff1b\u85d0\u89c6\uff1b\u9876\u649e 7 114",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1142,
    word: "appuy\u00e9",
    phonetic: "[ap\u0265ije]",
    type: "",
    translation: "adj. \u652f\u6301 8 114",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1143,
    word: "notice",
    phonetic: "[n\u0254tis]",
    type: "",
    translation: "n.f. \u6982\u8ff0\uff0c\u7b80\u4ecb\uff1b\u8bf4\u660e\u4e66 9 115",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1144,
    word: "admirablement",
    phonetic: "[admirabl\u0259m\u0251\u0303]",
    type: "",
    translation: "adv. \u4ee4\u4eba\u94a6\u4f69 0 115",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1145,
    word: "cit\u00e9",
    phonetic: "[site]",
    type: "",
    translation: "n.f. \u57ce\u5e02\uff1b\u5168\u57ce\u5c45\u6c11\uff1b\u57ce\u90a6\uff0c\u56fd\u5bb6\uff1b\u5c45\u4f4f\u533a 1 115",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1146,
    word: "coiff\u00e9",
    phonetic: "[kwafe]",
    type: "",
    translation: "adj. \u6234\u5e3d\u5b50\u7684\uff0c \u6234\u5934\u9970\u7684\uff1b \u68b3\u8fc7\u5934\u7684\uff0c \u5934\u53d1\u68b3\u597d\u7684 2 115",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1147,
    word: "secr\u00e8te",
    phonetic: "[s\u0259kr\u03b5t]",
    type: "",
    translation: "n.f. \u79d8\u5bc6\u7684\uff0c\u673a\u5bc6\u7684\uff0c\u795e\u79d8\u7684\uff1b\u9690\u85cf\u7684 3 115",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1148,
    word: "commer\u00e7ant",
    phonetic: "[k\u0254m\u03b5rs\u0251\u0303, -t]",
    type: "",
    translation: "n. \u5546\u4eba\uff1ba. \u7ecf\u5546\u7684\uff1b\u5546\u4e1a\u7e41\u76db\u7684\uff1b\u5f88\u4f1a\u505a\u751f\u610f\u7684 4 115",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1149,
    word: "cloche",
    phonetic: "[kl\u0254\u222b]",
    type: "",
    translation: "n.f. \u949f\uff1b\u949f\u5f62\u7f69\uff1b\u8822\u4eba\uff0c\u7b28\u86cb\uff1ba. \u611a\u8822\u7684\uff0c\u7b28\u7684 5 115",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1150,
    word: "gang",
    phonetic: "[g\u0251\u0303g]",
    type: "",
    translation: "[ga\u014b] n.m. \u515a 6 115",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1151,
    word: "distancer",
    phonetic: "[dist\u0251\u0303se]",
    type: "",
    translation: "v.t.\uff0c v.pr. \u4fdd\u6301\u8ddd\u79bb\uff0c\u758f\u8fdc 7 115",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1152,
    word: "pagode",
    phonetic: "[pag\u0254d]",
    type: "",
    translation: "n.f. \u5bfa\u5e99\uff0c\u5bfa\u9662\uff1b\u5854\uff0c\u5b9d\u5854\uff0c\u6d6e\u5c60 8 115",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1153,
    word: "acquisition",
    phonetic: "[akizisj\u0254\u0303]",
    type: "",
    translation: "n.f. \u83b7\u5f97\uff0c\u53d6\u5f97\uff1b\u8d2d\u5f97\uff1b\u83b7\u5f97\u7269\uff0c\u8d2d\u5f97\u7269 9 116 a. \u571f\u751f\u571f\u957f\u7684\uff0c\u672c\u5730\u51fa\u751f\u7684\uff1b[\u690d]\u672c\u5730\u7684\uff1b\u51fa\u751f\u4e8e\u6d77\u5916",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1154,
    word: "indig\u00e8ne",
    phonetic: "[\u025b\u0303di\u0292\u03b5n]",
    type: "",
    translation: "0 \u7684\uff1bn. \u672c\u5730\u4eba\uff0c\u5f53\u5730\u4eba\uff1b\u672c\u5730\u690d\u7269\uff1b\u51fa\u751f\u4e8e\u6d77\u5916\u7684\u4eba 116",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1155,
    word: "appareiller",
    phonetic: "[apareje]",
    type: "",
    translation: "v.t.\uff0c v.pr. \u542f\u822a\uff0c\u51c6\u5907\u5f00\u8239 1 116",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1156,
    word: "damer",
    phonetic: "[dame]",
    type: "",
    translation: "v.t. \u592f\u5b9e\uff0c\u6253\u592f\uff0c\u6363\u5b9e 2 116 adj. [\u5b97]\u88ab\u795d\u5723\u7684\uff0c \u795d\u5723\u7684\uff1b \u60ef\u7528\u7684\uff0c \u7ea6\u5b9a\u4fd7\u6210\u7684\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1157,
    word: "consacr\u00e9",
    phonetic: "[k\u0254\u0303sakre]",
    type: "",
    translation: "3 \u6709\u540d\u671b\u7684\uff0c \u77e5\u540d\u7684\uff0c \u8457\u540d\u7684 116",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1158,
    word: "fine",
    phonetic: "[fin]",
    type: "",
    translation: "n.f. \u4e0a\u7b49\u70e7\u9152\uff0c \u767d\u5170\u5730 4 116",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1159,
    word: "accus\u00e9",
    phonetic: "[akyze]",
    type: "",
    translation: "n. \u88ab\u544a\uff0c\u88ab\u544a\u4eba 5 116 a.\u7834\u574f\u4e86\u7684, \u6bc1\u574f\u4e86\u7684;\u574d\u584c\u7684;\u6bc1\u706d\u4e86\u7684, \u706d\u4ea1\u4e86\u7684;\u7834\u4ea7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1160,
    word: "ruin\u00e9",
    phonetic: "[r\u0265ine]",
    type: "",
    translation: "6 \u7684 116",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1161,
    word: "sensiblement",
    phonetic: "[s\u0251\u0303sibl\u0259m\u0251\u0303]",
    type: "",
    translation: "adv. \u663e\u8457\u5730, \u660e\u663e\u5730, \u663e\u7136;\u51e0\u4e4e 7 116",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1162,
    word: "math\u00e9matique",
    phonetic: "[matematik]",
    type: "",
    translation: "a. \u6570\u5b66\u7684\uff1b\u7cbe\u786e\u7684\uff0c\u4e25\u5bc6\u7684\uff1bn.f. pl. \u6570\u5b66 8 116",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1163,
    word: "minuter",
    phonetic: "[minyte]",
    type: "",
    translation: "v.t. \u7cbe\u786e\u5b89\u6392\u2026\u7684\u65f6\u95f4\uff1b\u8349\u62df\uff0c\u8d77\u8349 9 117 n.m. \u610f\u5916\u4e8b\u6545\uff0c\u4f34\u968f\u7684\u9ebb\u70e6\uff1b\u4e8b\u4ef6\uff0c\u4e8b\u53d8\uff1b\uff08\u620f\u5267\u3001\u5c0f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1164,
    word: "incident",
    phonetic: "[\u025b\u0303sid\u0251\u0303]",
    type: "",
    translation: "0 \u8bf4\u4e2d\u7684\uff09\u63d2\u66f2\uff0c\u63d2\u53d9 117",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1165,
    word: "chronom\u00e8tre",
    phonetic: "[kr\u0254n\u0254m\u03b5tr]",
    type: "",
    translation: "n.m. \u79d2\u8868\uff1b\u65f6\u8ba1\uff0c\u6807\u51c6\u65f6\u8868\uff0c\u7cbe\u5bc6\u65f6\u8ba1\uff0c\u5929\u6587\u949f 1 117",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1166,
    word: "vive",
    phonetic: "[viv]",
    type: "",
    translation: "interj. \u4e07\u5c81 2 117",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1167,
    word: "embranchement",
    phonetic: "[\u0251\u0303br\u0251\u0303\u222bm\u0251\u0303]",
    type: "",
    translation: "n.m. \u5206\u679d\uff0c\u5206\u6748\uff1b\u5c94\u8def\u53e3\uff1b\uff08\u52a8\u690d\u7269\u5206\u7c7b\u5b66\u4e2d\u7684\uff09\u95e8 3 117",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1168,
    word: "abasourdir",
    phonetic: "[abazurdir]",
    type: "",
    translation: "v.t. \u4f7f\u9707\u60ca\uff0c\u4f7f\u60ca\u6115\uff1b\u9707\u8033\u6b32\u804b\uff1b\u9707\u5f97\u5934\u660f\u8111\u80c0 4 117",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1169,
    word: "piper",
    phonetic: "[pipe]",
    type: "",
    translation: "v.i. \u5439\u7b1b\u8005 5 33 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. 117",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1170,
    word: "signalement",
    phonetic: "[si\u0272alm\u0251\u0303]",
    type: "",
    translation: "n.m. \u4f53\u8c8c\u7279\u5f81 6 117",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1171,
    word: "coquin",
    phonetic: "[k\u0254k\u025b\u0303, -in]",
    type: "",
    translation: "n. \u8c03\u76ae\u7684\uff08\u4eba\uff09\uff0c\u6dd8\u6c14\u7684\uff08\u4eba\uff09 7 117",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1172,
    word: "apposer",
    phonetic: "[apoze]",
    type: "",
    translation: "v.t. \u7c98\u8d34\uff0c\u8d34\uff1b\u5b89\u653e\uff1b\u6dfb\u52a0\uff1b\u7f72\uff08\u540d\uff09\uff0c\u76d6\uff08\u7ae0\uff09 8 117 n.f. \u4e0d\u52a8\u58f0\u8272\uff0c\u65e0\u8868\u60c5\uff1b\u51b7\u6de1\uff0c\u51b7\u6f20\uff0c\u65e0\u52a8\u4e8e\u8877\uff1b\u6c89\u7740\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1173,
    word: "impassibilit\u00e9",
    phonetic: "[\u025b\u0303pasibilite]",
    type: "",
    translation: "9 \u51b7\u9759\uff0c\u9547\u5b9a\uff0c\u9547\u9759 118",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1174,
    word: "richement",
    phonetic: "[ri\u222bm\u0251\u0303]",
    type: "",
    translation: "adv. \u4e30\u5bcc\u5730 0 118",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1175,
    word: "contretemps",
    phonetic: "[k\u0254\u0303tr\u0259t\u0251\u0303]",
    type: "",
    translation: "n.m. \u610f\u5916\u60c5\u51b5\uff0c\u610f\u5916\u4e8b\u6545 1 118",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1176,
    word: "roulis",
    phonetic: "[ruli]",
    type: "",
    translation: "n.m. \u6eda 2 118 n.f. [\u6280]\u5e95\u677f\uff1b\uff08\u5e73\u5e95\u8239\u7684\uff09\u8239\u5e95\uff1b[\u91c7]\u5e73\u5df7\u5e95\uff1b \u5e95\u6881\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1177,
    word: "sole",
    phonetic: "[s\u0254l]",
    type: "",
    translation: "3 [\u519c]\u8f6e\u4f5c\u7530\uff1b\u9cce\uff0c \u7bac\u9cce\u9c7c\uff0c \u820c\u9cce\uff1b\uff08\u9a6c\u3001\u9a74\u7b49\u7684\uff09\u8e44\u5e95 118",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1178,
    word: "primer",
    phonetic: "[prime]",
    type: "",
    translation: "v.t. \u8d85\u8fc7\uff0c\u80dc\u8fc7\uff1b\u5956\u8d4f\uff0c\u7ed9\u4e88\u5956\u91d1\uff1b\u5360\u5148\uff0c\u9886\u5148\uff0c\u5360\u9996\u4f4d 4 118",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1179,
    word: "co\u00fbt",
    phonetic: "[ku]",
    type: "",
    translation: "n.m. \u8d39\u7528\uff1b\u6210\u672c\uff1b\u4ef7\u683c\uff0c\u4ef7\u94b1 5 118",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1180,
    word: "briquer",
    phonetic: "[brike]",
    type: "",
    translation: "v.t. \u629b\u5149 6 118",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1181,
    word: "pulluler",
    phonetic: "[pylyle]",
    type: "",
    translation: "v.i. \u4e00\u7fa4 7 118",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1182,
    word: "goutter",
    phonetic: "[gute]",
    type: "",
    translation: "v.i. \u6ef4\u843d\uff0c\u6ef4\u7b54\uff0c\u5600\u55d2 8 118",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1183,
    word: "aper\u00e7u",
    phonetic: "[ap\u03b5rsy]",
    type: "",
    translation: "n.m. \u6982\u51b5\uff0c\u6982\u8ff0\uff1b\u6982\u89c2 9 119",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1184,
    word: "pittoresque",
    phonetic: "[pit\u0254r\u03b5sk]",
    type: "",
    translation: "a. \u98ce\u666f\u5982\u753b\u7684\uff1b\u522b\u81f4\u7684\uff0c\u751f\u52a8\u7684\uff0c\u7eda\u4e3d\u591a\u5f69\u7684 0 119 v.t.\uff0c v.pr. [\u56ed\u827a]\u57f9\u571f\uff0c \u58c5\u571f\uff1b\uff08\u52a8\u7269\uff09\u8eb2\u8fdb\u6d1e\u7a74\uff0c\u4f4f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1185,
    word: "terrer",
    phonetic: "[t\u03b5re]",
    type: "",
    translation: "1 \u5728\u5730\u5e95\u4e0b\uff1b\u8eb2\u85cf\uff1b\u3008\u519b\u4e8b\u3009\u9690\u853d 119",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1186,
    word: "formalit\u00e9",
    phonetic: "[f\u0254rmalite]",
    type: "",
    translation: "n.f. \u624b\u7eed\uff0c\u7a0b\u5e8f\uff1b\u793c\u8282\uff0c\u793c\u4eea\uff0c\u5ba2\u5957\uff1b\u5f62\u5f0f 2 119",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1187,
    word: "brancher",
    phonetic: "[br\u0251\u0303\u222be]",
    type: "",
    translation: "v.t. \u8054\u63a5\uff0c\u63a5\u901a\uff1b\u4f7f\uff08\u673a\u68b0\u7b49\uff09\u8fd0\u8f6c\uff1bv.i. \u6816\u5728\u6811\u679d\u4e0a 3 119 a. \u5927\u80c6\u7684\uff0c\u52c7\u6562\u7684\uff1b\u679c\u6562\u7684\uff1b\u9c81\u83bd\u7684\uff0c\u65e0\u793c\u7684\uff1bn. \u5927\u80c6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1188,
    word: "audacieux",
    phonetic: "[odasj\u00f8]",
    type: "",
    translation: "4 \u7684\u4eba\uff0c\u52c7\u6562\u7684\u4eba\uff0c\u83bd\u649e\u7684\u4eba 119",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1189,
    word: "mont\u00e9",
    phonetic: "[m\u0254\u0303te]",
    type: "",
    translation: "adj. \u5b89\u88c5 5 119",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1190,
    word: "pr\u00e9paratif",
    phonetic: "[preparatif]",
    type: "",
    translation: "n.m. \u51c6\u5907\uff1b\u51c6\u5907\u5de5\u4f5c[\u591a\u7528\u590d\u6570] 6 119",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1191,
    word: "hasarder",
    phonetic: "['azarde]",
    type: "",
    translation: "\u865a\u97f3H v.t.\uff0c v.pr. \u62ff\u2026\u5192\u9669\uff0c\u5192\u9669\u8fdb\u884c\uff1b\u62ff\u2026\u78b0\u8fd0\u6c14\uff1b\u8bd5\u7528 7 119",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1192,
    word: "soumis",
    phonetic: "[sumi, -z]",
    type: "",
    translation: "adj. \u670d\u4ece\u7684\uff0c \u987a\u4ece\u7684\uff0c \u542c\u8bdd\u7684\uff0c \u9a6f\u670d\u7684 8 119",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1193,
    word: "situ\u00e9",
    phonetic: "[sit\u0265e]",
    type: "",
    translation: "a. \u4f4d\u4e8e\u2026\u2026\u7684\uff0c\u5ea7\u843d\u5728\u2026\u2026\u7684 9 120",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1194,
    word: "r\u00e9glementaire",
    phonetic: "[regl\u0259m\u0251\u0303t\u03b5r]",
    type: "",
    translation: "adj. \u89c4\u5b9a\u7684\uff1b\u5408\u4e4e\u89c4\u5b9a\u7684\uff1b\u6709\u5173\u89c4\u7ae0\u6761\u4f8b\u7684 0 120",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1195,
    word: "amarre",
    phonetic: "[amar]",
    type: "",
    translation: "n.f. \u8239\u7f06\uff0c\u7ef3\u7d22 1 120",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1196,
    word: "portion",
    phonetic: "[p\u0254rsj\u0254\u0303]",
    type: "",
    translation: "n.f. \u4e00\u90e8\u5206\uff1b\u4e00\u4efd\uff0c\u4e00\u5ba2[\u6307\u98df\u7269] 2 120",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1197,
    word: "\u00e9pouvanter",
    phonetic: "[epuv\u0251\u0303te]",
    type: "",
    translation: "v.t. \u4f7f\u60ca\u6050\uff0c\u4f7f\u6050\u6016\uff0c\u4f7f\u754f\u60e7 3 120 v.t.\uff0c v.pr. \u5b89\u987f\uff0c\u5b89\u7f6e\uff0c\u5b89\u6392\uff0c\u5b89\u63d2\uff1b\u8bb8\u914d\u6210\u4eb2\uff1b\u653e\u5165",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1198,
    word: "caser",
    phonetic: "[kaze]",
    type: "",
    translation: "4 \u683c\u5185 34 of 35 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. 120",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 1199,
    word: "voleur",
    phonetic: "[v\u0254l\u0153r, -\u00f8z]",
    type: "",
    translation: "n. \u8d3c\uff0c\u5f3a\u76d7\uff1b\u66b4\u5229\u7684\u5546\u4eba 5 35 of 35",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
];
